// Campaign Type
module.exports = {
  // Constraints on Brand ID
  CAMPAIGN_ID_MIN_LENGTH: 4, // Fixed Length
  CAMPAIGN_ID_MAX_LENGTH: 14, // Fixed Length
  CAMPAIGN_ID_CHARSET: `0123456789abcdefghijklmnopqrstuvwxyz`, // Valid charset. Digits, Lowercase Alphabets
  CAMPAIGN_ID_SANATIZE_REGX: /[^0-9a-z]/g, // Regular expression for valid Characters. Digits. Alphabets. Case sensitive
  CAMPAIGN_ID_CHARSET_REGX: /^[0-9a-z]*$/, // Regular expression for valid Characters. Digits. Alphabets. Case sensitive

  // Constraints on Brand Name
  CAMPAIGN_NAME_MAX_LENGTH: 255, // Maximum length

  CAMPAIGN_LIST_LIMIT_EDITOR: 10,

  USER_TYPE: {
    brand_manager: {
      n: "Brand",
    },
    agency_manager: {
      n: "An Agency",
    },
  },

  CAMPAIGN_TYPE: {
    content: {
      n: "Content",
    },
    social_media: {
      n: "Social Media",
    },
  },

  // Campaign Type
  CAMPAIGN_STATUS: {
    save: "sv",
    active: "at",
    expired: "ex",
    complete: "ct",
  },

  // Platforms
  PLATFORM: {
    instagram: {
      n: "Instagram",
      content_types: {
        posts: {
          n: "Instagram Posts",
        },
        carousels: {
          n: "Instagram Carousels",
        },
        stories: {
          n: "Instagram Stories",
        },
      },
    },
    youtube: {
      n: "Youtube",
      content_types: {
        video: {
          n: "Youtube Video",
        },
        shorts: {
          n: "Youtube Shorts",
        },
      },
    },
    twitter: {
      n: "Twitter",
      content_types: {
        post: {
          n: "Twitter Posts",
        },
      },
    },
    facebook: {
      n: "Facebook",
      content_types: {
        post: {
          n: "Facebook Posts",
        },
      },
    },
  },

  AGE_RANGE: {
    "18_25": {
      n: "18-25",
      id: "18_25",
    },
    "26_35": {
      n: "26-35",
      id: "26_35",
    },
    "36_45": {
      n: "36-45",
      id: "36_45",
    },
    "46_55": {
      n: "46-55",
      id: "46_55",
    },
    "56_65+": {
      n: "56-65+",
      id: "56_65+",
    },
  },

  // INFLUENCER_FOLLOWERS: {
  //   nano: {
  //     n: "Nano 1K-10K",
  //     id: "1000",
  //     minFollowers: 1000,
  //     maxFollowers: 10000,
  //   },
  //   micro: {
  //     n: "Micro 10K-50K",
  //     id: "10000",
  //     minFollowers: 10000,
  //     maxFollowers: 50000,
  //   },
  //   macro: {
  //     n: "Macro 50K-1M",
  //     id: "50000",
  //     minFollowers: 50000,
  //     maxFollowers: 1000000,
  //   },
  //   // mega: {
  //   //   n: "Mega 1M",
  //   //   id: "1000000",
  //   //   minFollowers: 1000000,
  //   //   maxFollowers: null,
  //   // },
  // },

  INFLUENCER_FOLLOWERS: {
    nano: {
      n: "Nano 1K-10K",
      id: "1000",
      minFollowers: 1000,
      maxFollowers: 10000,
    },
    micro: {
      n: "Micro 10K-50K",
      id: "10000",
      minFollowers: 10000,
      maxFollowers: 50000,
    },
    midTier: {
      n: "Mid Tier 50K-2.5L",
      id: "50000",
      minFollowers: 50000,
      maxFollowers: 250000,
    },
    macro: {
      n: "Macro 2.5L-10L",
      id: "250000",
      minFollowers: 250000,
      maxFollowers: 1000000,
    },
    topTier: {
      n: "Top Tier 1M+",
      id: "1000000",
      minFollowers: 1000000,
      maxFollowers: null,
    },
  },

  // GENDER
  GENDER: {
    all: {
      n: "All",
      id: "all",
    },
    male: {
      n: "Male",
      id: "male",
    },
    female: {
      n: "Female",
      id: "female",
    },
  },

  CITY: [
    {
      type: "state",
      label: "Andaman and Nicobar Islands",
      id: 10032,
    },
    {
      type: "state",
      label: "Andhra Pradesh",
      id: 10013,
    },
    {
      type: "state",
      label: "Arunachal Pradesh",
      id: 10033,
    },
    {
      type: "state",
      label: "Assam",
      id: 10019,
    },
    {
      type: "state",
      label: "Bihar",
      id: 10011,
    },
    {
      type: "state",
      label: "Chandigarh",
      id: 10020,
    },
    {
      type: "state",
      label: "Chhattisgarh",
      id: 10018,
    },
    {
      type: "state",
      label: "Dadra and Nagar Haveli",
      id: 10034,
    },
    {
      type: "state",
      label: "Delhi",
      id: 10003,
    },
    {
      type: "state",
      label: "Goa",
      id: 10031,
    },
    {
      type: "state",
      label: "Gujarat",
      id: 10005,
    },
    {
      type: "state",
      label: "Haryana",
      id: 10015,
    },
    {
      type: "state",
      label: "Himachal Pradesh",
      id: 10029,
    },
    {
      type: "state",
      label: "Jammu and Kashmir",
      id: 10016,
    },
    {
      type: "state",
      label: "Jharkhand",
      id: 10017,
    },
    {
      type: "state",
      label: "Karnataka",
      id: 10004,
    },
    {
      type: "state",
      label: "Kerala",
      id: 10022,
    },
    {
      type: "state",
      label: "Madhya Pradesh",
      id: 10012,
    },
    {
      type: "state",
      label: "Maharashtra",
      id: 10002,
    },
    {
      type: "state",
      label: "Manipur",
      id: 10028,
    },
    {
      type: "state",
      label: "Meghalaya",
      id: 10027,
    },
    {
      type: "state",
      label: "Mizoram",
      id: 10026,
    },
    {
      type: "state",
      label: "Nagaland",
      id: 10030,
    },
    {
      type: "state",
      label: "Odisha",
      id: 10021,
    },
    {
      type: "state",
      label: "PAN India",
      id: 10001,
    },
    {
      type: "state",
      label: "Puducherry",
      id: 10024,
    },
    {
      type: "state",
      label: "Punjab",
      id: 10014,
    },
    {
      type: "state",
      label: "Rajasthan",
      id: 10009,
    },
    {
      type: "state",
      label: "Tamil Nadu",
      id: 10007,
    },
    {
      type: "state",
      label: "Telangana",
      id: 10006,
    },
    {
      type: "state",
      label: "Tripura",
      id: 10025,
    },
    {
      type: "state",
      label: "Uttar Pradesh",
      id: 10010,
    },
    {
      type: "state",
      label: "Uttarakhand",
      id: 10023,
    },
    {
      type: "state",
      label: "West Bengal",
      id: 10008,
    },
    {
      type: "state",
      label: "Lakshadweep",
      id: 15515,
    },
    {
      type: "state",
      label: "Daman And Diu",
      id: 15520,
    },
    {
      type: "state",
      label: "Sikkim",
      id: 15523,
    },
    {
      type: "state",
      label: "Ladakh",
      id: 15545,
    },
    {
      type: "city",
      label: "Port Blair",
      id: 10369,
      state_id: 10032,
    },
    {
      type: "city",
      label: "Nicobars",
      id: 11493,
      state_id: 10032,
    },
    {
      type: "city",
      label: "South Andamans",
      id: 11517,
      state_id: 10032,
    },
    {
      type: "city",
      label: "North And Middle Andaman",
      id: 11676,
      state_id: 10032,
    },
    {
      type: "city",
      label: "Bombooflat",
      id: 15519,
      state_id: 10032,
    },
    {
      type: "city",
      label: "Garacharma",
      id: 15525,
      state_id: 10032,
    },
    {
      type: "city",
      label: "Adoni",
      id: 10237,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Amalapuram",
      id: 10620,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Anakapalle",
      id: 10417,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Anantapur",
      id: 10171,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bapatla",
      id: 10481,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bheemunipatnam",
      id: 10628,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bhimavaram",
      id: 10278,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bobbili",
      id: 10585,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chilakaluripet",
      id: 10362,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chirala",
      id: 10413,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chittoor",
      id: 10254,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Dharmavaram",
      id: 10304,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Eluru",
      id: 10196,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gooty",
      id: 10672,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gudivada",
      id: 10309,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gudur",
      id: 10550,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Guntakal",
      id: 10294,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Guntur",
      id: 10096,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Hindupur",
      id: 10258,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jaggaiahpet",
      id: 10615,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jammalamadugu",
      id: 10697,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kadapa",
      id: 10180,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kadiri",
      id: 10400,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kakinada",
      id: 10148,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kandukur",
      id: 10579,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kavali",
      id: 10428,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kovvur",
      id: 10773,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kurnool",
      id: 10128,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Macherla",
      id: 10665,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Machilipatnam",
      id: 10230,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Madanapalle",
      id: 10285,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Mandapeta",
      id: 10682,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Markapur",
      id: 10566,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nagari",
      id: 10532,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Naidupet",
      id: 10523,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nandyal",
      id: 10203,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narasapuram",
      id: 10562,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narasaraopet",
      id: 10317,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narsipatnam",
      id: 10865,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nellore",
      id: 10116,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nidadavole",
      id: 10726,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nuzvid",
      id: 10563,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ongole",
      id: 10202,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Palacole",
      id: 10449,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Palasa Kasibugga",
      id: 10655,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Parvathipuram",
      id: 10660,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Pedana",
      id: 10951,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Peddapuram",
      id: 10704,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Pithapuram",
      id: 10650,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ponnur",
      id: 10575,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Proddatur",
      id: 10263,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Punganur",
      id: 10717,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Puttur",
      id: 10955,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rajahmundry",
      id: 10130,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rajam",
      id: 11103,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rajampet",
      id: 10338,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ramachandrapuram",
      id: 10754,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rayachoti",
      id: 10473,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rayadurg",
      id: 10605,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Renigunta",
      id: 11090,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Repalle",
      id: 10737,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Salur",
      id: 10673,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Samalkot",
      id: 10614,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sattenapalle",
      id: 10637,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Srikakulam",
      id: 10312,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Srikalahasti",
      id: 10479,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Srisailam Project (Right Flank Colony) Township",
      id: 11109,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sullurpeta",
      id: 10451,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tadepalligudem",
      id: 10353,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tadpatri",
      id: 10341,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tanuku",
      id: 10472,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tenali",
      id: 10240,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tirupati",
      id: 10159,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tiruvuru",
      id: 10795,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tuni",
      id: 10617,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Uravakonda",
      id: 10831,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Venkatagiri",
      id: 10634,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vijayawada",
      id: 10076,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vinukonda",
      id: 10556,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Visakhapatnam",
      id: 10053,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vizianagaram",
      id: 10184,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Yemmiganur",
      id: 10385,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Yerraguntla",
      id: 10890,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ntr",
      id: 11325,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Parvathipuram Manyam",
      id: 11327,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Y.S.R.",
      id: 11345,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Annamayya",
      id: 11350,
      state_id: 10013,
    },
    {
      type: "city",
      label: "West Godavari",
      id: 11427,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Alluri Sitharama Raju",
      id: 11429,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Anakapalli",
      id: 11430,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Krishna",
      id: 11480,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sri Potti Sriramulu Nellore",
      id: 11521,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sri Sathya Sai",
      id: 11522,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ananthapuramu",
      id: 11528,
      state_id: 10013,
    },
    {
      type: "city",
      label: "East Godavari",
      id: 11554,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Prakasam",
      id: 11599,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Dr. B.R. Ambedkar Konaseema",
      id: 11646,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Palnadu",
      id: 11679,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Adilabad",
      id: 11723,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Akkarampalle",
      id: 11753,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Akkayapalle",
      id: 11754,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Alwal",
      id: 11787,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Amadalavalasa",
      id: 11790,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Asifabad",
      id: 11907,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Badepalle",
      id: 11979,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bandarulanka",
      id: 12070,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bellampalle",
      id: 12197,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bestavaripeta",
      id: 12213,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bethamcheria",
      id: 12215,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bhadrachalam",
      id: 12227,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bhainsa",
      id: 12235,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bheemavaram",
      id: 12275,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bhongir",
      id: 12298,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bodhan",
      id: 12382,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bollaram",
      id: 12389,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Bugganipalle",
      id: 12413,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chandur",
      id: 12483,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chatakonda",
      id: 12503,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chemmumiahpet",
      id: 12515,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chinnachowk",
      id: 12578,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chintalavalasa",
      id: 12586,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Choutuppal",
      id: 12613,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Chunchupalle",
      id: 12618,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Cuddapah",
      id: 12630,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Dasnapur",
      id: 12677,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Devarakonda",
      id: 12728,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Dommara Nandyal",
      id: 12830,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Dowleswaram",
      id: 12839,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Eddumailaram",
      id: 12869,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ekambara kuppam",
      id: 12872,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Farooqnagar",
      id: 12905,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gaddi annaram",
      id: 12932,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gadwal",
      id: 12936,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gajapathinagaram",
      id: 12940,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gajularega",
      id: 12944,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Gajuwaka",
      id: 12945,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ghatkeser",
      id: 13004,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Hyderabad M.Corp",
      id: 13214,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ichchapuram",
      id: 13216,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Isnapur",
      id: 13250,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jaggayyapet",
      id: 13267,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jagtial",
      id: 13271,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jallaram Kamanpur",
      id: 13298,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jangaon",
      id: 13314,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Jarjapupeta",
      id: 13320,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kaghaznagar",
      id: 13424,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kallur",
      id: 13470,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kalyandurg",
      id: 13477,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kamareddy",
      id: 13484,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kanapaka",
      id: 13501,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kantabamsuguda",
      id: 13543,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kanuru",
      id: 13550,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kapra",
      id: 13555,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Karimnagar",
      id: 13579,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Khammam",
      id: 13684,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Koratla",
      id: 13834,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kothagudem",
      id: 13847,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kothavalasa",
      id: 13849,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kovurpalle",
      id: 13869,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kukatpalle",
      id: 13891,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kuppam",
      id: 13923,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Kyathampalle",
      id: 13951,
      state_id: 10013,
    },
    {
      type: "city",
      label: "L.B. Nagar",
      id: 13953,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Madaram",
      id: 14011,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Mahbubnagar",
      id: 14032,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Malkajgiri",
      id: 14072,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Mancherial",
      id: 14094,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Mandamarri",
      id: 14096,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Mangalagiri",
      id: 14105,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Manugur",
      id: 14128,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Medak",
      id: 14161,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Meerpet",
      id: 14163,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Miryalguda",
      id: 14200,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Moragudi",
      id: 14227,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nagarkurnool",
      id: 14312,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nalgonda",
      id: 14332,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narayanavanam",
      id: 14367,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narayanpet",
      id: 14369,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narsapur",
      id: 14374,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Narsingi",
      id: 14376,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Naspur",
      id: 14379,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nellimaria",
      id: 14408,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nirmal",
      id: 14437,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Nizamabad",
      id: 14442,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Omerkhan daira",
      id: 14478,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Osmania University",
      id: 14487,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Palakurthi",
      id: 14512,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Palasa @ Kasibugga",
      id: 14515,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Palwancha",
      id: 14539,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Pamur",
      id: 14542,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Papampeta",
      id: 14571,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Patancheru",
      id: 14603,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Pitapuram",
      id: 14681,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Quthbullapur",
      id: 14747,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rajendranagar",
      id: 14771,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ramachandrapuram-Bhel Township )",
      id: 14783,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ramagundam",
      id: 14784,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ramanayyapeta",
      id: 14787,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Ramapuram",
      id: 14790,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rameswaram",
      id: 14794,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Rampachodavaram",
      id: 14804,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sadasivpet",
      id: 14875,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Samalkota",
      id: 14907,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sangareddy",
      id: 14918,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sarapaka",
      id: 14945,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Secunderabad",
      id: 14983,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Serilingampalle",
      id: 15001,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Siddipet",
      id: 15051,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Singapur",
      id: 15074,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Singarayakonda",
      id: 15075,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sirsilla",
      id: 15094,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sompeta",
      id: 15111,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Sriramnagar",
      id: 15129,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Srisailam  Project (RFC) Township",
      id: 15131,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Srisailamgudem Devasthanam",
      id: 15132,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Suryapet",
      id: 15163,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Suryaraopeta",
      id: 15164,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tallapalle",
      id: 15180,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tandur",
      id: 15188,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Teegalapahad",
      id: 15199,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tiruchanur",
      id: 15290,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tirumala",
      id: 15292,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Tirupati (NMA)",
      id: 15293,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Uppal Kalan",
      id: 15351,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Upper Sileru Project Site Camp",
      id: 15352,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vaparala",
      id: 15409,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vepagunta",
      id: 15451,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vetapalem",
      id: 15454,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vicarabad",
      id: 15457,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Vijayapuri (North)",
      id: 15464,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Wanaparthi",
      id: 15491,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Warangal",
      id: 15494,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Yadagirigutta",
      id: 15499,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Yellandu",
      id: 15504,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Zahirabad",
      id: 15509,
      state_id: 10013,
    },
    {
      type: "city",
      label: "Naharlagun",
      id: 10824,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Pasighat",
      id: 11157,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Lohit",
      id: 11312,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Upper Subansiri",
      id: 11342,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Lower Dibang Valley",
      id: 11400,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Lower Siang",
      id: 11401,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Papum Pare",
      id: 11410,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Siang",
      id: 11418,
      state_id: 10033,
    },
    {
      type: "city",
      label: "West Kameng",
      id: 11428,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Anjaw",
      id: 11431,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Dibang Valley",
      id: 11446,
      state_id: 10033,
    },
    {
      type: "city",
      label: "East Siang",
      id: 11451,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Pakke Kessang",
      id: 11496,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Shi Yomi",
      id: 11515,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Changlang",
      id: 11544,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Kra Daadi",
      id: 11581,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Leparada",
      id: 11586,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Longding",
      id: 11587,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Lower Subansiri",
      id: 11588,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Namsai",
      id: 11591,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Tawang",
      id: 11612,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Tirap",
      id: 11614,
      state_id: 10033,
    },
    {
      type: "city",
      label: "East Kameng",
      id: 11647,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Kamle",
      id: 11661,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Kurung Kumey",
      id: 11669,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Upper Siang",
      id: 11692,
      state_id: 10033,
    },
    {
      type: "city",
      label: "West Siang",
      id: 11698,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Along",
      id: 11781,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Basar",
      id: 12152,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Bomdila",
      id: 12391,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Daporijo",
      id: 12665,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Deomali",
      id: 12706,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Itanagar",
      id: 13252,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Jairampur",
      id: 13277,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Khonsa",
      id: 13746,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Roing",
      id: 14855,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Seppa",
      id: 14998,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Tezu",
      id: 15213,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Ziro",
      id: 15514,
      state_id: 10033,
    },
    {
      type: "city",
      label: "Barpeta",
      id: 10735,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bongaigaon City",
      id: 10500,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dhubri",
      id: 10527,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dibrugarh",
      id: 10280,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Diphu",
      id: 10542,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dispur",
      id: 11256,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Goalpara",
      id: 10616,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Guwahati",
      id: 10078,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Jorhat",
      id: 10476,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Karimganj",
      id: 10583,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lanka",
      id: 10810,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lumding",
      id: 10923,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Mangaldoi",
      id: 11089,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Mankachar",
      id: 10969,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Margherita",
      id: 11086,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Mariani",
      id: 11192,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Marigaon",
      id: 11204,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Nagaon",
      id: 10316,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Nalbari",
      id: 10989,
      state_id: 10019,
    },
    {
      type: "city",
      label: "North Lakhimpur",
      id: 10555,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Rangia",
      id: 11060,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sibsagar",
      id: 10610,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Silapathar",
      id: 11141,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Silchar",
      id: 10220,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Tezpur",
      id: 10564,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Tinsukia",
      id: 10372,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Majuli",
      id: 11316,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Baksa",
      id: 11351,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Biswanath",
      id: 11361,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Cachar",
      id: 11365,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Charaideo",
      id: 11368,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Chirang",
      id: 11369,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kamrup Metro",
      id: 11393,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sivasagar",
      id: 11420,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sonitpur",
      id: 11421,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bajali",
      id: 11435,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Darrang",
      id: 11443,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dhemaji",
      id: 11445,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Hailakandi",
      id: 11460,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dima Hasao",
      id: 11551,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Hojai",
      id: 11563,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kamrup",
      id: 11573,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Karbi Anglong",
      id: 11575,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lakhimpur",
      id: 11585,
      state_id: 10019,
    },
    {
      type: "city",
      label: "West Karbi Anglong",
      id: 11619,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bongaigaon",
      id: 11628,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Golaghat",
      id: 11649,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kokrajhar",
      id: 11666,
      state_id: 10019,
    },
    {
      type: "city",
      label: "South Salmara Mancachar",
      id: 11686,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Tamulpur",
      id: 11689,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Udalguri",
      id: 11691,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Abhayapuri",
      id: 11709,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Ambikapur Part-X",
      id: 11811,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Amguri",
      id: 11815,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Anand Nagar",
      id: 11836,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Badarpur",
      id: 11973,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Badarpur Rly Town",
      id: 11974,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bahbari Gaon",
      id: 12009,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bamun Sualkuchi",
      id: 12061,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Barbari (AMC Area)",
      id: 12115,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Barpathar",
      id: 12138,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Barpeta Road",
      id: 12139,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Basugaon",
      id: 12165,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bihpuria",
      id: 12322,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bijni",
      id: 12327,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bilasipara",
      id: 12338,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Biswanath Chariali",
      id: 12377,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bohari",
      id: 12385,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bokajan",
      id: 12387,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bokakhat",
      id: 12388,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Bongaigaon, Refinery & Petro-chemical Ltd. Township",
      id: 12394,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Borgolai Grant No.11",
      id: 12398,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Chabua",
      id: 12431,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Chandrapur Bagicha",
      id: 12480,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Chapar",
      id: 12490,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Chekonidhara",
      id: 12512,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Choto Haibor",
      id: 12610,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dergaon",
      id: 12716,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dharapur",
      id: 12765,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dhekiajuli",
      id: 12785,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dhing",
      id: 12787,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Digboi",
      id: 12802,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Digboi Oil Town",
      id: 12803,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dimaruguri",
      id: 12812,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Doboka",
      id: 12820,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Dokmoka",
      id: 12827,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Donkamokam",
      id: 12836,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Doom Dooma",
      id: 12837,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Duliajan No.1",
      id: 12845,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Duliajan Oil Town",
      id: 12846,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Durga Nagar Part-V",
      id: 12855,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Gauripur",
      id: 12987,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Gohpur",
      id: 13042,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Golokganj",
      id: 13049,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Gossaigaon",
      id: 13068,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Haflong",
      id: 13110,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Hamren",
      id: 13124,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Hindustan Paper Corporation Ltd. Township Area Panchgram",
      id: 13178,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Howli",
      id: 13202,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Howraghat",
      id: 13203,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Jagiroad",
      id: 13268,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Jonai Bazar",
      id: 13387,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kampur Town",
      id: 13492,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kanakpur Part-II",
      id: 13499,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kharijapikon",
      id: 13708,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kharupatia",
      id: 13718,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kochpara",
      id: 13783,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Kumar Kaibarta Gaon",
      id: 13899,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lakhipur",
      id: 13958,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lala",
      id: 13963,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lido Tikok",
      id: 13987,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lido Town",
      id: 13988,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Lumding Rly Colony",
      id: 14004,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Mahur",
      id: 14047,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Maibong",
      id: 14050,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Majgaon",
      id: 14056,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Makum",
      id: 14067,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Moran Town",
      id: 14228,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Moranhat",
      id: 14229,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Naharkatiya",
      id: 14321,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Namrup",
      id: 14340,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Naubaisa Gaon",
      id: 14387,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Nazira",
      id: 14400,
      state_id: 10019,
    },
    {
      type: "city",
      label: "New Bongaigaon Rly. Colony",
      id: 14420,
      state_id: 10019,
    },
    {
      type: "city",
      label: "North Guwahati",
      id: 14452,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Numaligarh Refinery Township",
      id: 14458,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Palasbari",
      id: 14516,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Pathsala",
      id: 14610,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Rangapara",
      id: 14814,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Salakati",
      id: 14898,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sapatgram",
      id: 14939,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sarbhog",
      id: 14947,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sarthebari",
      id: 14959,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sarupathar",
      id: 14960,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sarupathar Bengali",
      id: 14961,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Senchoa Gaon",
      id: 14991,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Silchar Part-X",
      id: 15061,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sonari",
      id: 15115,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Sualkuchi",
      id: 15135,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Tangla",
      id: 15189,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Tihu",
      id: 15279,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Titabor Town",
      id: 15298,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Umrangso",
      id: 15339,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Uttar Krishnapur Part-I",
      id: 15371,
      state_id: 10019,
    },
    {
      type: "city",
      label: "Araria",
      id: 10440,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Arrah",
      id: 10172,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Arwal",
      id: 10633,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Asarganj",
      id: 11249,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Aurangabad",
      id: 10363,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bagaha",
      id: 10326,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Barh",
      id: 11240,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Begusarai",
      id: 10177,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bettiah",
      id: 10288,
      state_id: 10011,
    },
    {
      type: "city",
      label: "BhabUrban Agglomeration",
      id: 10648,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bhagalpur",
      id: 10133,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Buxar",
      id: 10355,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Chhapra",
      id: 10179,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Darbhanga",
      id: 10155,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dehri-on-Sone",
      id: 10284,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dumraon",
      id: 10613,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Forbesganj",
      id: 10646,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Gaya",
      id: 10123,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Gopalganj",
      id: 10499,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Hajipur",
      id: 10268,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jamalpur",
      id: 10350,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jamui",
      id: 10411,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jehanabad",
      id: 10357,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Katihar",
      id: 10185,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Kishanganj",
      id: 10344,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Lakhisarai",
      id: 10370,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Lalganj",
      id: 11116,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Madhepura",
      id: 10707,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Madhubani",
      id: 10511,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Maharajganj",
      id: 11200,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Mahnar Bazar",
      id: 10801,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Makhdumpur",
      id: 10940,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Maner",
      id: 10941,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Manihari",
      id: 11169,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Marhaura",
      id: 11074,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Masaurhi",
      id: 10528,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Mirganj",
      id: 11100,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Mokameh",
      id: 10586,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Motihari",
      id: 10298,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Motipur",
      id: 11158,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Munger",
      id: 10197,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Murliganj",
      id: 11122,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Muzaffarpur",
      id: 10140,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Narkatiaganj",
      id: 10663,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Naugachhia",
      id: 10668,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Nawada",
      id: 10376,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Nokha",
      id: 11009,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Patna",
      id: 10049,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Piro",
      id: 11044,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Purnia",
      id: 10209,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Rafiganj",
      id: 11065,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Rajgir",
      id: 10867,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Ramnagar",
      id: 10784,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Raxaul Bazar",
      id: 10750,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Revelganj",
      id: 10857,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Rosera",
      id: 11004,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Saharsa",
      id: 10252,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Samastipur",
      id: 10536,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sasaram",
      id: 10267,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sheikhpura",
      id: 10729,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sheohar",
      id: 11183,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sherghati",
      id: 10892,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Silao",
      id: 11221,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sitamarhi",
      id: 10412,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Siwan",
      id: 10337,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sonepur",
      id: 10873,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sugauli",
      id: 10922,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Sultanganj",
      id: 10747,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Supaul",
      id: 10606,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Warisaliganj",
      id: 10856,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Purbi Champaran",
      id: 11328,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Banka",
      id: 11356,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Nalanda",
      id: 11406,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bhojpur",
      id: 11438,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Kaimur (Bhabua)",
      id: 11468,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Khagaria",
      id: 11474,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Saran",
      id: 11511,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Vaishali",
      id: 11526,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Pashchim Champaran",
      id: 11595,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Rohtas",
      id: 11683,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Amarpur",
      id: 11796,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Areraj",
      id: 11885,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bahadurganj",
      id: 12007,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bairgania",
      id: 12023,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bakhtiarpur",
      id: 12031,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Banmankhi Bazar",
      id: 12091,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Barahiya",
      id: 12105,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Barauli",
      id: 12112,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Barauni IOC Township",
      id: 12113,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Barbigha",
      id: 12116,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Behea",
      id: 12185,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Belsand",
      id: 12200,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bhabua",
      id: 12221,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bhagalpur (M.Corp)",
      id: 12231,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bihar",
      id: 12321,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bikramganj",
      id: 12333,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Birpur",
      id: 12363,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Bodh Gaya",
      id: 12381,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Chakia",
      id: 12445,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Chanpatia",
      id: 12489,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Chapra",
      id: 12492,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Colgong",
      id: 12623,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dalsinghsarai",
      id: 12654,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Daudnagar",
      id: 12681,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dehri",
      id: 12693,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dhaka",
      id: 12737,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dighwara",
      id: 12806,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dinapur Cantt.",
      id: 12814,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dinapur Nizamat",
      id: 12815,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Dumra",
      id: 12850,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Fatwah",
      id: 12918,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Ghoghardiha",
      id: 13013,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Gogri Jamalpur",
      id: 13039,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Habibpur",
      id: 13107,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Hilsa",
      id: 13173,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Hisua",
      id: 13187,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Islampur",
      id: 13249,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jagdishpur",
      id: 13266,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jainagar",
      id: 13276,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jamhaur",
      id: 13305,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Janakpur Road",
      id: 13312,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jhajha",
      id: 13353,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jhanjharpur",
      id: 13357,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Jogbani",
      id: 13382,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Kanti",
      id: 13547,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Kasba",
      id: 13601,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Kataiya",
      id: 13609,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Khagaul",
      id: 13666,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Kharagpur",
      id: 13698,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Khusrupur",
      id: 13755,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Koath",
      id: 13780,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Koilwar",
      id: 13795,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Lauthaha",
      id: 13979,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Mairwa",
      id: 14054,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Mohiuddinagar",
      id: 14216,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Nabinagar",
      id: 14301,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Nirmali",
      id: 14438,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Paharpur",
      id: 14505,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Phulwari Sharif",
      id: 14662,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Raghunathpur",
      id: 14756,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Shahpur",
      id: 15018,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Tekari",
      id: 15202,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Thakurganj",
      id: 15217,
      state_id: 10011,
    },
    {
      type: "city",
      label: "Chandigarh",
      id: 10079,
      state_id: 10020,
    },
    {
      type: "city",
      label: "Ambikapur",
      id: 10321,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bhatapara",
      id: 10578,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bhilai Nagar",
      id: 10101,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bilaspur",
      id: 10144,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Chirmiri",
      id: 10490,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dalli-Rajhara",
      id: 10716,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dhamtari",
      id: 10429,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Durg",
      id: 10166,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Jagdalpur",
      id: 10297,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Korba",
      id: 10136,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Mahasamund",
      id: 10418,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Manendragarh",
      id: 10935,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Mungeli",
      id: 10917,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Naila Janjgir",
      id: 10765,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Raigarh",
      id: 10318,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Raipur",
      id: 10071,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Rajnandgaon",
      id: 10275,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Sakti",
      id: 11219,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Tilda Newra",
      id: 10900,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Balod",
      id: 11259,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Balrampur-Ramanujganj",
      id: 11261,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bemetara",
      id: 11264,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bijapur",
      id: 11269,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gariyaband",
      id: 11289,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kabeerdham",
      id: 11301,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Balodabazar-Bhatapara",
      id: 11354,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Jashpur",
      id: 11386,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dakshin Bastar Dantewada",
      id: 11442,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Janjgir-Champa",
      id: 11467,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Manendragarh-Chirmiri-Bharatpur(M C B)",
      id: 11486,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Sarangarh-Bilaigarh",
      id: 11512,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gaurela-Pendra-Marwahi",
      id: 11560,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Korea",
      id: 11580,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Mohla-Manpur-Ambagarh Chouki",
      id: 11590,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Surajpur",
      id: 11609,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Surguja",
      id: 11610,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Uttar Bastar Kanker",
      id: 11617,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bastar",
      id: 11622,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Khairagarh-Chhuikhadan-Gandai",
      id: 11665,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kondagaon",
      id: 11668,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Narayanpur",
      id: 11671,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Sukma",
      id: 11688,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Ahiwara",
      id: 11732,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Akaltara",
      id: 11748,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Ambagarh Chowki",
      id: 11800,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Arang",
      id: 11878,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bade Bacheli",
      id: 11978,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bagbahara",
      id: 11996,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Baikunthpur",
      id: 12018,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Baloda",
      id: 12054,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Baloda Bazar",
      id: 12055,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Banarsi",
      id: 12065,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Basna",
      id: 12160,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bemetra",
      id: 12206,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bhanpuri",
      id: 12249,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bhatgaon",
      id: 12260,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bhilai Charoda",
      id: 12279,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bilha",
      id: 12344,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Birgaon",
      id: 12360,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Bodri",
      id: 12384,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Champa",
      id: 12460,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Chharchha",
      id: 12538,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Chhuikhadan",
      id: 12555,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dantewada",
      id: 12663,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Deori",
      id: 12708,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dhamdha",
      id: 12744,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dharamjaigarh",
      id: 12759,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dipka",
      id: 12818,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dongargaon",
      id: 12833,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Dongragarh",
      id: 12834,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Frezarpur",
      id: 12924,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gandai",
      id: 12950,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gaurella",
      id: 12984,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Geedam",
      id: 12991,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gharghoda",
      id: 12998,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gobranawapara",
      id: 13033,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Gogaon",
      id: 13037,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Hatkachora",
      id: 13157,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Jamul",
      id: 13310,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Jashpur nagar",
      id: 13323,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Jhagrakhand",
      id: 13352,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kanker",
      id: 13527,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Katghora",
      id: 13613,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kawardha",
      id: 13633,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Khairagarh",
      id: 13670,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Khamhria",
      id: 13683,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kharod",
      id: 13714,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kharsia",
      id: 13717,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Khongapani",
      id: 13743,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kirandul",
      id: 13767,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kota",
      id: 13841,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kumhari",
      id: 13907,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Kurud",
      id: 13936,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Lingiyadih",
      id: 13992,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Lormi",
      id: 14002,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Mehmand",
      id: 14171,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Mowa",
      id: 14236,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Namna Kalan",
      id: 14339,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Naya Baradwar",
      id: 14398,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Pandariya",
      id: 14552,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Patan",
      id: 14600,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Pathalgaon",
      id: 14605,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Pendra",
      id: 14629,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Phunderdihari",
      id: 14664,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Pithora",
      id: 14682,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Rajgamar",
      id: 14772,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Ramanujganj",
      id: 14788,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Ratanpur",
      id: 14827,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Saraipali",
      id: 14943,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Sarangarh",
      id: 14944,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Shivrinarayan",
      id: 15041,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Simga",
      id: 15063,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Sirgiti",
      id: 15087,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Takhatpur",
      id: 15172,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Telgaon",
      id: 15204,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Urla",
      id: 15357,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Vishrampur",
      id: 15480,
      state_id: 10018,
    },
    {
      type: "city",
      label: "Silvassa",
      id: 11164,
      state_id: 10034,
    },
    {
      type: "city",
      label: "Amli",
      id: 15518,
      state_id: 10034,
    },
    {
      type: "city",
      label: "Dadra And Nagar Haveli",
      id: 15549,
      state_id: 10034,
    },
    {
      type: "city",
      label: "Delhi",
      id: 10037,
      state_id: 10003,
    },
    {
      type: "city",
      label: "New Delhi",
      id: 10178,
      state_id: 10003,
    },
    {
      type: "city",
      label: "North East",
      id: 11323,
      state_id: 10003,
    },
    {
      type: "city",
      label: "North",
      id: 11408,
      state_id: 10003,
    },
    {
      type: "city",
      label: "North West",
      id: 11409,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Shahdara",
      id: 11513,
      state_id: 10003,
    },
    {
      type: "city",
      label: "West",
      id: 11527,
      state_id: 10003,
    },
    {
      type: "city",
      label: "East",
      id: 11552,
      state_id: 10003,
    },
    {
      type: "city",
      label: "South East",
      id: 11607,
      state_id: 10003,
    },
    {
      type: "city",
      label: "South West",
      id: 11608,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Central",
      id: 11630,
      state_id: 10003,
    },
    {
      type: "city",
      label: "South",
      id: 11685,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Ali Pur",
      id: 11773,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Asola",
      id: 11910,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Babar Pur",
      id: 11955,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Bankner",
      id: 12089,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Bawana",
      id: 12172,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Begum Pur",
      id: 12181,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Bhalswa Jahangir Pur",
      id: 12239,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Bhati",
      id: 12261,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Burari",
      id: 12418,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Chhawla",
      id: 12545,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Chilla Saroda Bangar",
      id: 12571,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Dallo Pura",
      id: 12652,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Dayal Pur",
      id: 12688,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Delhi Cantt.",
      id: 12696,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Delhi Municipal Corporation (U)",
      id: 12697,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Deoli",
      id: 12704,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Gharoli",
      id: 12999,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Gharonda Neemka Bangar alias Patpar Ganj",
      id: 13000,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Gheora",
      id: 13007,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Ghitorni",
      id: 13009,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Ghoga",
      id: 13011,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Gokal Pur",
      id: 13044,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Hastsal",
      id: 13152,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Jaffrabad",
      id: 13258,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Jharoda Majra Burari",
      id: 13361,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Jiwan Pur alias Johri Pur",
      id: 13375,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Jona Pur",
      id: 13386,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Kanjhawala",
      id: 13522,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Kapas Hera",
      id: 13552,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Karawal Nagar",
      id: 13570,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Khajoori Khas",
      id: 13672,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Khera Khurd",
      id: 13730,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Kirari Suleman Nagar",
      id: 13770,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Kondli",
      id: 13818,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Libas Pur",
      id: 13985,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Mirpur Turk",
      id: 14199,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Mithe Pur",
      id: 14204,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Molar Band",
      id: 14222,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Mundka",
      id: 14269,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Mustafabad",
      id: 14290,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Nangal Dewat",
      id: 14349,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Nangal Thakran",
      id: 14350,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Nangloi Jat",
      id: 14353,
      state_id: 10003,
    },
    {
      type: "city",
      label: "New Delhi Municipal Council",
      id: 14421,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Pehlad Pur Bangar",
      id: 14628,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Pooth Kalan",
      id: 14698,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Pooth Khurd",
      id: 14699,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Pul Pehlad",
      id: 14718,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Quammruddin Nagar",
      id: 14743,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Rajokri",
      id: 14778,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Roshan Pura alias Dichaon Khurd",
      id: 14857,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Sadat Pur Gujran",
      id: 14877,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Sahibabad Daulat Pur",
      id: 14886,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Saidul Ajaib",
      id: 14890,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Sambhalka",
      id: 14910,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Sanoth",
      id: 14931,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Siras Pur",
      id: 15084,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Sultan Pur",
      id: 15145,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Sultan Pur Majra",
      id: 15146,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Taj Pul",
      id: 15171,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Tigri",
      id: 15278,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Ziauddin Pur",
      id: 15513,
      state_id: 10003,
    },
    {
      type: "city",
      label: "Mapusa",
      id: 10766,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Margao",
      id: 10389,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Marmagao",
      id: 10351,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Panaji",
      id: 10371,
      state_id: 10031,
    },
    {
      type: "city",
      label: "South Goa",
      id: 11338,
      state_id: 10031,
    },
    {
      type: "city",
      label: "North Goa",
      id: 11495,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Aldona",
      id: 11772,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Aquem",
      id: 11871,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Bambolim",
      id: 12057,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Bandora",
      id: 12075,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Benaulim",
      id: 12207,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Bicholim",
      id: 12315,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Calangute",
      id: 12425,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Calapor",
      id: 12426,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Canacona",
      id: 12427,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Candolim",
      id: 12428,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Carapur",
      id: 12429,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Chicalim",
      id: 12557,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Chimbel",
      id: 12573,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Chinchinim",
      id: 12575,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Colvale",
      id: 12625,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Cuncolim",
      id: 12631,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Curchorem Cacora",
      id: 12632,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Curti",
      id: 12633,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Davorlim",
      id: 12687,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Goa Velha",
      id: 13028,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Guirim",
      id: 13085,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Mormugao",
      id: 14233,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Navelim",
      id: 14392,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Pale",
      id: 14524,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Parcem",
      id: 14586,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Penha-de-Franca",
      id: 14630,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Pernem",
      id: 14643,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Ponda",
      id: 14689,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Quepem",
      id: 14744,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Queula",
      id: 14745,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Reis Magos",
      id: 14840,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Saligao",
      id: 14903,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Sancoale",
      id: 14915,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Sanguem",
      id: 14922,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Sanquelim",
      id: 14932,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Sanvordem",
      id: 14937,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Sao Jose-de-Areal",
      id: 14938,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Siolim",
      id: 15082,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Socorro (Serula)",
      id: 15106,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Valpoi",
      id: 15399,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Varca",
      id: 15414,
      state_id: 10031,
    },
    {
      type: "city",
      label: "Adalaj",
      id: 11238,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ahmedabad",
      id: 10039,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Amreli",
      id: 10348,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Anand",
      id: 10208,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Anjar",
      id: 10414,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ankleshwar",
      id: 10460,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bharuch",
      id: 10233,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bhavnagar",
      id: 10105,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bhuj",
      id: 10269,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chhapra",
      id: 11241,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Deesa",
      id: 10330,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dhoraji",
      id: 10421,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gandhinagar",
      id: 11251,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Godhra",
      id: 10276,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jamnagar",
      id: 10110,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kadi",
      id: 10465,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kapadvanj",
      id: 10664,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Keshod",
      id: 10450,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Khambhat",
      id: 10425,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Lathi",
      id: 11186,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Limbdi",
      id: 10734,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Lunawada",
      id: 10807,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahemdabad",
      id: 10934,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahesana",
      id: 10219,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahuva",
      id: 10432,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Manavadar",
      id: 11000,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mandvi",
      id: 10740,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mangrol",
      id: 10589,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mansa",
      id: 10986,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Modasa",
      id: 10604,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Morvi",
      id: 10212,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Nadiad",
      id: 10193,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Navsari",
      id: 10244,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Padra",
      id: 10776,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Palanpur",
      id: 10293,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Palitana",
      id: 10632,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Pardi",
      id: 11055,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Patan",
      id: 10325,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Petlad",
      id: 10641,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Porbandar",
      id: 10206,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Radhanpur",
      id: 10907,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Rajkot",
      id: 10057,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Rajpipla",
      id: 10841,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Rajula",
      id: 10897,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ranavav",
      id: 10950,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Rapar",
      id: 11118,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Salaya",
      id: 11014,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sanand",
      id: 10896,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Savarkundla",
      id: 10461,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sidhpur",
      id: 10569,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sihor",
      id: 10690,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Songadh",
      id: 11142,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Surat",
      id: 10045,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Talaja",
      id: 10990,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Thangadh",
      id: 10741,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Tharad",
      id: 10985,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Umbergaon",
      id: 10987,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Umreth",
      id: 10864,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Una",
      id: 10565,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Unjha",
      id: 10581,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Upleta",
      id: 10561,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vadnagar",
      id: 10995,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vadodara",
      id: 10054,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Valsad",
      id: 10320,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vapi",
      id: 10242,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Veraval",
      id: 10255,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vijapur",
      id: 11048,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Viramgam",
      id: 10596,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Visnagar",
      id: 10529,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vyara",
      id: 10772,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Wadhwan",
      id: 10452,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Wankaner",
      id: 10724,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Arvalli",
      id: 11258,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Botad",
      id: 11270,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chhotaudepur",
      id: 11276,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dahod",
      id: 11277,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dangs",
      id: 11280,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kheda",
      id: 11305,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahisagar",
      id: 11314,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kachchh",
      id: 11390,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Morbi",
      id: 11404,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Surendranagar",
      id: 11423,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sabar Kantha",
      id: 11508,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Tapi",
      id: 11523,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Banas Kantha",
      id: 11535,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Devbhumi Dwarka",
      id: 11550,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gir Somnath",
      id: 11561,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Panch Mahals",
      id: 11594,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Junagadh",
      id: 11660,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Narmada",
      id: 11672,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Aadityana",
      id: 11705,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Aambaliyasan",
      id: 11706,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Aantaliya",
      id: 11707,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Aarambhada",
      id: 11708,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Abrama",
      id: 11712,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ahmedabad Cantonment",
      id: 11736,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Alang",
      id: 11764,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ambaji",
      id: 11802,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Andada",
      id: 11842,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Anklav",
      id: 11852,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Anklesvar",
      id: 11853,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Anklesvar INA",
      id: 11854,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Atul",
      id: 11926,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bagasara",
      id: 11995,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bajva",
      id: 12028,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Balasinor",
      id: 12043,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bantwa",
      id: 12099,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bardoli",
      id: 12118,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bavla",
      id: 12170,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bedi",
      id: 12175,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bhachau",
      id: 12222,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bhanvad",
      id: 12250,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bharuch INA",
      id: 12256,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bhayavadar",
      id: 12273,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bilimora",
      id: 12346,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bodeli",
      id: 12380,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bopal",
      id: 12397,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Boriavi",
      id: 12399,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Borsad",
      id: 12400,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chaklasi",
      id: 12447,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chala",
      id: 12453,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chalala",
      id: 12454,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chalthan",
      id: 12457,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chanasma",
      id: 12465,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chandkheda",
      id: 12474,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chandlodiya",
      id: 12476,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chanod",
      id: 12488,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chhaprabhatha",
      id: 12536,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chhatral INA",
      id: 12543,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chhaya",
      id: 12546,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chhota Udaipur",
      id: 12552,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chikhli",
      id: 12564,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chiloda(Naroda)",
      id: 12572,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Chorvad",
      id: 12609,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dabhoi",
      id: 12634,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dahegam",
      id: 12642,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dakor",
      id: 12645,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Damnagar",
      id: 12658,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Devgadbaria",
      id: 12731,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Devsar",
      id: 12734,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dhandhuka",
      id: 12754,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dhanera",
      id: 12755,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dharampur",
      id: 12761,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dhola",
      id: 12788,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dholka",
      id: 12789,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dhrangadhra",
      id: 12790,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dhrol",
      id: 12791,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Digvijaygram",
      id: 12809,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dohad",
      id: 12824,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dungra",
      id: 12854,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Dwarka",
      id: 12862,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Freelandgunj",
      id: 12923,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gadhada",
      id: 12933,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gandevi",
      id: 12951,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gandhidham",
      id: 12953,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gariadhar",
      id: 12979,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ghatlodiya",
      id: 13005,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ghogha",
      id: 13012,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gondal",
      id: 13051,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Gota",
      id: 13069,
      state_id: 10005,
    },
    {
      type: "city",
      label: "GSFC Complex INA",
      id: 13077,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Hajira INA",
      id: 13115,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Halol",
      id: 13121,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Halvad",
      id: 13123,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Harij",
      id: 13138,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Himatnagar",
      id: 13174,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ichchhapor",
      id: 13217,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Idar",
      id: 13220,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jafrabad",
      id: 13260,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jalalpore",
      id: 13291,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jam Jodhpur",
      id: 13300,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jambusar",
      id: 13304,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jasdan",
      id: 13322,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jawaharnagar (Gujarat Refinery)",
      id: 13332,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jetpur Navagadh",
      id: 13347,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Jodhpur",
      id: 13380,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Joshipura",
      id: 13390,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kadodara",
      id: 13420,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kalavad",
      id: 13453,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kali",
      id: 13457,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kalol",
      id: 13472,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kalol INA",
      id: 13473,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kandla",
      id: 13509,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kanodar",
      id: 13540,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Karachiya",
      id: 13558,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Karamsad",
      id: 13564,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Karjan",
      id: 13582,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Katpar",
      id: 13619,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kevadiya",
      id: 13661,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Khambhalia",
      id: 13681,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kharaghoda",
      id: 13697,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Khedbrahma",
      id: 13726,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kheralu",
      id: 13732,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kodinar",
      id: 13790,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kosamba",
      id: 13838,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Kutiyana",
      id: 13948,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Lambha",
      id: 13967,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Limla",
      id: 13991,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahemdavad",
      id: 14033,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahudha",
      id: 14046,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mahuvar",
      id: 14048,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Makarba",
      id: 14061,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Maktampur",
      id: 14066,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Malpur",
      id: 14081,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Meghraj",
      id: 14166,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Memnagar",
      id: 14184,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mithapur",
      id: 14203,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mogravadi",
      id: 14208,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Motera",
      id: 14234,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Mundra",
      id: 14270,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Nanakvada",
      id: 14341,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Nandej",
      id: 14345,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Nandesari",
      id: 14346,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Nandesari INA",
      id: 14347,
      state_id: 10005,
    },
    {
      type: "city",
      label: "NavagamGhed",
      id: 14390,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ode",
      id: 14467,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Okha port",
      id: 14472,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Paddhari",
      id: 14499,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Palej",
      id: 14525,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Parnera",
      id: 14589,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Parvat",
      id: 14594,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Petro Chemical Complex INA",
      id: 14657,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Prantij",
      id: 14705,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ramol",
      id: 14803,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ranip",
      id: 14818,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ranoli",
      id: 14822,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sachin",
      id: 14872,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sachin INA",
      id: 14873,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Santrampur",
      id: 14936,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sarigam INA",
      id: 14952,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sarkhej-Okaf",
      id: 14956,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sayan",
      id: 14981,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Sikka",
      id: 15059,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Singarva",
      id: 15076,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Surajkaradi",
      id: 15158,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Surendranagar Dudhrej",
      id: 15160,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Talod",
      id: 15181,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Tarsali",
      id: 15194,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Thaltej",
      id: 15221,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Ukai",
      id: 15326,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Umbergaon INA",
      id: 15338,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Un",
      id: 15344,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Utran",
      id: 15365,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vadia",
      id: 15387,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vaghodia INA",
      id: 15389,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vallabh Vidhyanagar",
      id: 15396,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Valsad INA",
      id: 15400,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vanthali",
      id: 15407,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vapi INA",
      id: 15410,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vartej",
      id: 15415,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vasna Borsad INA",
      id: 15419,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vastral",
      id: 15420,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vastrapur",
      id: 15421,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vejalpur",
      id: 15436,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vijalpor",
      id: 15461,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Visavadar",
      id: 15479,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vitthal Udyognagar INA",
      id: 15481,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Zalod",
      id: 15510,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Vapi (2)",
      id: 10854,
      state_id: 10005,
    },
    {
      type: "city",
      label: "Bahadurgarh",
      id: 10229,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Bhiwani",
      id: 10205,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Charkhi Dadri",
      id: 10653,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Faridabad",
      id: 10061,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Fatehabad",
      id: 10482,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Gohana",
      id: 10513,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Gurgaon",
      id: 10083,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Hansi",
      id: 10416,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Hisar",
      id: 10152,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Jind",
      id: 10238,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kaithal",
      id: 10274,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Karnal",
      id: 10160,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ladwa",
      id: 10968,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Mahendragarh",
      id: 11080,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Mandi Dabwali",
      id: 10611,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Narnaul",
      id: 10456,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Narwana",
      id: 10533,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Palwal",
      id: 10292,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Panchkula",
      id: 10198,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Panipat",
      id: 10154,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Pehowa",
      id: 10872,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Pinjore",
      id: 10952,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Rania",
      id: 11194,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ratia",
      id: 11092,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Rewari",
      id: 10365,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Rohtak",
      id: 10153,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Safidon",
      id: 11002,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Samalkha",
      id: 10947,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sarsod",
      id: 11250,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Shahbad",
      id: 10803,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sirsa",
      id: 10243,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sohna",
      id: 10999,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sonipat",
      id: 10187,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Taraori",
      id: 11038,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Thanesar",
      id: 10253,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Tohana",
      id: 10525,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Yamunanagar",
      id: 10194,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ambala",
      id: 11349,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Gurugram",
      id: 11380,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Charki Dadri",
      id: 11440,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kurukshetra",
      id: 11583,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Jhajjar",
      id: 11659,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Nuh",
      id: 11678,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ambala Cantt.",
      id: 11803,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ambala Sadar",
      id: 11804,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Asan  Khurd",
      id: 11901,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Assandh",
      id: 11911,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ateli",
      id: 11914,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Babiyal",
      id: 11960,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Barwala",
      id: 12150,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Bawal",
      id: 12171,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Bawani Khera",
      id: 12173,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Beri",
      id: 12211,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Bilaspur",
      id: 12339,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Buria",
      id: 12420,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Cheeka",
      id: 12510,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Chhachhrauli",
      id: 12534,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Dharuhera",
      id: 12777,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Dundahera",
      id: 12851,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ellenabad",
      id: 12879,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Farakhpur",
      id: 12901,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Farrukhnagar",
      id: 12908,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ferozepur Jhirka",
      id: 12920,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ganaur",
      id: 12949,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Gharaunda",
      id: 12997,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Gurgaon Rural",
      id: 13098,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Haileymandi",
      id: 13112,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Hassanpur",
      id: 13150,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Hathin",
      id: 13155,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Hodal",
      id: 13188,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Indri",
      id: 13240,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Jagadhri",
      id: 13262,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Jakhal Mandi",
      id: 13285,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Julana",
      id: 13398,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kalan Wali",
      id: 13447,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kalanaur",
      id: 13449,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kalayat",
      id: 13455,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kalka",
      id: 13464,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kanina",
      id: 13520,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kansepur",
      id: 13542,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kardhan",
      id: 13571,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kharkhoda",
      id: 13713,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Ladrawan",
      id: 13955,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Loharu",
      id: 13998,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Maham",
      id: 14031,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Mustafabad",
      id: 14289,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Nagai Chaudhry",
      id: 14308,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Naraingarh",
      id: 14357,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Narnaund",
      id: 14373,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Nilokheri",
      id: 14432,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Panchkula Urban Estate",
      id: 14549,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Panipat Taraf Ansar",
      id: 14560,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Panipat Taraf Rajputan",
      id: 14561,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Panipt Taraf Makhdum Zadgan",
      id: 14562,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Pataudi",
      id: 14604,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Punahana",
      id: 14721,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Pundri",
      id: 14722,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Radaur",
      id: 14751,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Raipur Rani",
      id: 14764,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Rewari (Rural)",
      id: 14845,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sadaura",
      id: 14878,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sankhol",
      id: 14929,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sasauli",
      id: 14963,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Siwani",
      id: 15104,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Sukhrali",
      id: 15143,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Taoru",
      id: 15190,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Tilpat",
      id: 15283,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Tosham",
      id: 15308,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Uchana",
      id: 15317,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Uklanamandi",
      id: 15328,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Uncha Siwana",
      id: 15345,
      state_id: 10015,
    },
    {
      type: "city",
      label: "Kullu",
      id: 11252,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Manali",
      id: 11253,
      state_id: 10035,
    },
    {
      type: "city",
      label: "Mandi",
      id: 10553,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Nahan",
      id: 10967,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Palampur",
      id: 11108,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Shimla",
      id: 10272,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Solan",
      id: 10853,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Sundarnagar",
      id: 11087,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Hamirpur",
      id: 11292,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Sirmaur",
      id: 11419,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Kangra",
      id: 11470,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Kinnaur",
      id: 11475,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Lahaul And Spiti",
      id: 11584,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Una",
      id: 11616,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Bilaspur",
      id: 11626,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Chamba",
      id: 11631,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Arki",
      id: 11891,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Baddi",
      id: 11977,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Bakloh",
      id: 12033,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Banjar",
      id: 12085,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Bhota",
      id: 12300,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Bhuntar",
      id: 12309,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Chaupal",
      id: 12505,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Chuari Khas",
      id: 12615,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Dagshai",
      id: 12640,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Dalhousie",
      id: 12650,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Daulatpur",
      id: 12683,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Dera Gopipur",
      id: 12714,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Dharmsala",
      id: 12775,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Gagret",
      id: 12937,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Ghumarwin",
      id: 13023,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Jawalamukhi",
      id: 13334,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Jogindarnagar",
      id: 13384,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Jubbal",
      id: 13395,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Jutogh",
      id: 13401,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Kasauli",
      id: 13599,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Kotkhai",
      id: 13853,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Mant Khas",
      id: 14127,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Mehatpur Basdehra",
      id: 14168,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Nadaun",
      id: 14305,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Nagrota Bagwan",
      id: 14320,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Naina Devi",
      id: 14324,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Nalagarh",
      id: 14329,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Narkanda",
      id: 14372,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Nurpur",
      id: 14459,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Paonta Sahib",
      id: 14570,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Parwanoo",
      id: 14595,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Rajgarh",
      id: 14774,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Rampur",
      id: 14805,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Rawalsar",
      id: 14831,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Rohru",
      id: 14854,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Sabathu",
      id: 14870,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Santokhgarh",
      id: 14934,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Sarkaghat",
      id: 14955,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Seoni",
      id: 14996,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Talai",
      id: 15174,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Theog",
      id: 15234,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Tira Sujanpur",
      id: 15287,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Yol",
      id: 15508,
      state_id: 10029,
    },
    {
      type: "city",
      label: "Anantnag",
      id: 10340,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Baramula",
      id: 10236,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Jammu",
      id: 10117,
      state_id: 10016,
    },
    {
      type: "city",
      label: "KathUrban Agglomeration",
      id: 10631,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Punch",
      id: 10758,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Rajauri",
      id: 10751,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Sopore",
      id: 10503,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Srinagar",
      id: 10067,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Udhampur",
      id: 10834,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bandipora",
      id: 11262,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kishtwar",
      id: 11308,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Reasi",
      id: 11330,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Baramulla",
      id: 11357,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kathua",
      id: 11395,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Ramban",
      id: 11414,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Samba",
      id: 11416,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Doda",
      id: 11449,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kulgam",
      id: 11481,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kupwara",
      id: 11482,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Poonch",
      id: 11501,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Pulwama",
      id: 11504,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Rajouri",
      id: 11506,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Ganderbal",
      id: 11559,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Budgam",
      id: 11629,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Shopian",
      id: 11684,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Achabal",
      id: 11714,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Akhnoor",
      id: 11751,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Arnia",
      id: 11893,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Awantipora",
      id: 11940,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Badami Bagh",
      id: 11972,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Badgam",
      id: 11980,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bandipore",
      id: 12074,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Banihal",
      id: 12084,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bari Brahmana",
      id: 12128,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bashohli",
      id: 12156,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Batote",
      id: 12168,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Beerwah",
      id: 12177,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bhaderwah",
      id: 12225,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bijbehara",
      id: 12325,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Billawar",
      id: 12347,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Bishna",
      id: 12372,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Charari Sharief",
      id: 12496,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Chenani",
      id: 12516,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Duru-Verinag",
      id: 12859,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Gho Manhasan",
      id: 13010,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Gorah Salathian",
      id: 13062,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Gulmarg",
      id: 13092,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Hajan",
      id: 13113,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Handwara",
      id: 13127,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Hiranagar",
      id: 13183,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Jammu Cantonment",
      id: 13308,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Jourian",
      id: 13393,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kargil",
      id: 13574,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Katra",
      id: 13620,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Khan Sahib",
      id: 13685,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Khour",
      id: 13748,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Khrew",
      id: 13749,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kud",
      id: 13883,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kukernag",
      id: 13892,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Kunzer",
      id: 13922,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Lakhenpur",
      id: 13957,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Leh",
      id: 13982,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Magam",
      id: 14024,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Mattan",
      id: 14149,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Nowshehra",
      id: 14456,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Pahalgam",
      id: 14504,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Pampore",
      id: 14541,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Parole",
      id: 14591,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Pattan",
      id: 14614,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Qazigund",
      id: 14742,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Ram Garh",
      id: 14782,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Ramnagar",
      id: 14801,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Ranbir Singh Pora",
      id: 14813,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Rehambal",
      id: 14838,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Shupiyan",
      id: 15048,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Sumbal",
      id: 15152,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Sunderbani",
      id: 15155,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Talwara",
      id: 15184,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Thanamandi",
      id: 15223,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Tral",
      id: 15310,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Uri",
      id: 15356,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Vijay Pur",
      id: 15462,
      state_id: 10016,
    },
    {
      type: "city",
      label: "Adityapur",
      id: 10227,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bokaro Steel City",
      id: 10129,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chaibasa",
      id: 10489,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chatra",
      id: 10654,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chirkunda",
      id: 10705,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Deoghar",
      id: 10201,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dhanbad",
      id: 10068,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dumka",
      id: 10683,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Giridih",
      id: 10322,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gumia",
      id: 10677,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Hazaribag",
      id: 10277,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jamshedpur",
      id: 10100,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jhumri Tilaiya",
      id: 10408,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Lohardaga",
      id: 11084,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Madhupur",
      id: 10686,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Medininagar (Daltonganj)",
      id: 10443,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Mihijam",
      id: 10876,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Musabani",
      id: 10861,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Pakaur",
      id: 10825,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Patratu",
      id: 10910,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Phusro",
      id: 10226,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Ramgarh",
      id: 10333,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Ranchi",
      id: 10086,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sahibganj",
      id: 10435,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Saunda",
      id: 10420,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Simdega",
      id: 10860,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Tenu dam-cum-Kathhara",
      id: 11154,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Garhwa",
      id: 11288,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gumla",
      id: 11291,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Khunti",
      id: 11307,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Latehar",
      id: 11311,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Palamu",
      id: 11326,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Godda",
      id: 11379,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Hazaribagh",
      id: 11462,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jamtara",
      id: 11466,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Koderma",
      id: 11477,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Pakur",
      id: 11497,
      state_id: 10017,
    },
    {
      type: "city",
      label: "East Singhbum",
      id: 11556,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sahebganj",
      id: 11601,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Saraikela Kharsawan",
      id: 11603,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bokaro",
      id: 11627,
      state_id: 10017,
    },
    {
      type: "city",
      label: "West Singhbhum",
      id: 11699,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Amlabad",
      id: 11822,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Angarpathar",
      id: 11849,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Ara",
      id: 11872,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Babua Kalan",
      id: 11963,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bagbera",
      id: 11997,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Baliari",
      id: 12047,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Balkundra",
      id: 12050,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bandhgora",
      id: 12071,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Barajamda",
      id: 12107,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Barhi",
      id: 12125,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Barkakana",
      id: 12135,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Barughutu",
      id: 12145,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Barwadih",
      id: 12148,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Basaria",
      id: 12153,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Basukinath",
      id: 12166,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bermo",
      id: 12212,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bhagatdih",
      id: 12232,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bhojudih",
      id: 12294,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bhowrah",
      id: 12302,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bhuli",
      id: 12307,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Bundu",
      id: 12417,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chakradharpur",
      id: 12448,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chakulia",
      id: 12451,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chandaur",
      id: 12469,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chandil",
      id: 12472,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chandrapura",
      id: 12481,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chas",
      id: 12501,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chhatatanr",
      id: 12542,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chhota Gobindpur",
      id: 12551,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chhotaputki",
      id: 12553,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Chiria",
      id: 12592,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Churi",
      id: 12620,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Daltonganj",
      id: 12655,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Danguwapasi",
      id: 12661,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dari",
      id: 12668,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Deorikalan",
      id: 12710,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dhanwar",
      id: 12757,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dhaunsar",
      id: 12782,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dugda",
      id: 12843,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Dumarkunda",
      id: 12848,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Egarkunr",
      id: 12870,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gadhra",
      id: 12935,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Ghatshila",
      id: 13006,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Ghorabandha",
      id: 13014,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gidi",
      id: 13026,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gobindpur",
      id: 13032,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Godhar",
      id: 13035,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gomoh",
      id: 13050,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Gua",
      id: 13078,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Haludbani",
      id: 13122,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Hesla",
      id: 13170,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Hussainabad",
      id: 13211,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Isri",
      id: 13251,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jadugora",
      id: 13255,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jamadoba",
      id: 13301,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jaridih Bazar",
      id: 13319,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jasidih",
      id: 13324,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jena",
      id: 13344,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jharia",
      id: 13359,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jharia Khas",
      id: 13360,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jhinkpani",
      id: 13364,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jorapokhar",
      id: 13388,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Jugsalai",
      id: 13397,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kailudih",
      id: 13427,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kalikapur",
      id: 13460,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kandra",
      id: 13510,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kanke",
      id: 13526,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Katras",
      id: 13623,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kedla",
      id: 13637,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kenduadih",
      id: 13652,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kharkhari",
      id: 13711,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kharsawan",
      id: 13716,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Khelari",
      id: 13728,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kiriburu",
      id: 13772,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kodarma",
      id: 13787,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kuju",
      id: 13890,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kurpania",
      id: 13932,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Kustai",
      id: 13946,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Lakarka",
      id: 13956,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Lapanga",
      id: 13974,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Loyabad",
      id: 14003,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Maithon",
      id: 14055,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Malkera",
      id: 14073,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Mango",
      id: 14111,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Marma",
      id: 14139,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Meghahatuburu Forest village",
      id: 14164,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Mera",
      id: 14186,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Meru",
      id: 14187,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Mugma",
      id: 14249,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Muri",
      id: 14281,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Nagri Kalan",
      id: 14319,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Nirsa",
      id: 14439,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Noamundi",
      id: 14444,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Okni NO.II",
      id: 14473,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Orla",
      id: 14486,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Palawa",
      id: 14520,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Panchet",
      id: 14547,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Paratdih",
      id: 14581,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Pathardih",
      id: 14607,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Pondar Kanali",
      id: 14690,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Rajmahal",
      id: 14776,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Ramgarh Cantonment",
      id: 14797,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Religara alias Pachhiari",
      id: 14841,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Rohraband",
      id: 14853,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sahnidih",
      id: 14888,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Saraidhela",
      id: 14942,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sarjamda",
      id: 14954,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Seraikela",
      id: 14999,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sewai",
      id: 15007,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sijhua",
      id: 15055,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sijua",
      id: 15056,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sindri",
      id: 15069,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sinduria",
      id: 15070,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sini",
      id: 15081,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Sirka",
      id: 15090,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Siuliban",
      id: 15102,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Tati",
      id: 15197,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Tenu Dam-cum- Kathhara",
      id: 15210,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Tisra",
      id: 15297,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Topa",
      id: 15305,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Topchanchi",
      id: 15306,
      state_id: 10017,
    },
    {
      type: "city",
      label: "Adyar",
      id: 11246,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Afzalpur",
      id: 11012,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Arsikere",
      id: 10638,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Athni",
      id: 10700,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ballari",
      id: 10131,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Belagavi",
      id: 10118,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bengaluru",
      id: 10038,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chikkamagaluru",
      id: 10308,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Davanagere",
      id: 10125,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gokak",
      id: 10438,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hubli-Dharwad",
      id: 10080,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Karwar",
      id: 10336,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kolar",
      id: 10281,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Lakshmeshwar",
      id: 10813,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Lingsugur",
      id: 10837,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Maddur",
      id: 11026,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Madhugiri",
      id: 11030,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Madikeri",
      id: 10894,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Magadi",
      id: 11063,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mahalingapura",
      id: 10932,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Malavalli",
      id: 10828,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Malur",
      id: 10991,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mandya",
      id: 10283,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mangaluru",
      id: 10120,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Manvi",
      id: 10799,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudabidri",
      id: 11045,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudalagi",
      id: 10946,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Muddebihal",
      id: 10979,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudhol",
      id: 10738,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mulbagal",
      id: 10722,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mundargi",
      id: 11215,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mysore",
      id: 10139,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Nanjangud",
      id: 10645,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Nargund",
      id: 10820,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Navalgund",
      id: 11072,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Nelamangala",
      id: 10805,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Pavagada",
      id: 10984,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Piriyapatna",
      id: 11236,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Puttur",
      id: 10678,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Raayachuru",
      id: 10199,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Rabkavi Banhatti",
      id: 10487,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ramanagaram",
      id: 10437,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ramdurg",
      id: 10817,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ranebennuru",
      id: 10347,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ranibennur",
      id: 10399,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Robertson Pet",
      id: 10247,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ron",
      id: 11173,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sadalagi",
      id: 11220,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sagara",
      id: 10649,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sakaleshapura",
      id: 11115,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sanduru",
      id: 10998,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sankeshwara",
      id: 10893,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Saundatti-Yellamma",
      id: 10787,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Savanur",
      id: 10832,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sedam",
      id: 10918,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shahabad",
      id: 10508,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shahpur",
      id: 10779,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shiggaon",
      id: 11078,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shikaripur",
      id: 10919,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shivamogga",
      id: 10163,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shrirangapattana",
      id: 11094,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sidlaghatta",
      id: 10757,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sindagi",
      id: 11110,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sindhagi",
      id: 10997,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sindhnur",
      id: 10546,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sira",
      id: 10651,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sirsi",
      id: 10516,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Siruguppa",
      id: 10732,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Srinivaspur",
      id: 11121,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Surapura",
      id: 10727,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Talikota",
      id: 10915,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tarikere",
      id: 10827,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tekkalakote",
      id: 11031,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Terdal",
      id: 11035,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tiptur",
      id: 10557,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tumkur",
      id: 10151,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Udupi",
      id: 10296,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Vijayapura",
      id: 10842,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Wadi",
      id: 10789,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Yadgir",
      id: 10458,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bengaluru Urban",
      id: 11265,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Davangere",
      id: 11282,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hassan",
      id: 11296,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mysuru",
      id: 11320,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chamarajanagara",
      id: 11366,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Dharwad",
      id: 11372,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Haveri",
      id: 11382,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Raichur",
      id: 11412,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chikkaballapura",
      id: 11441,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gadag",
      id: 11456,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Koppal",
      id: 11478,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tumakuru",
      id: 11525,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bengaluru Rural",
      id: 11540,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chitradurga",
      id: 11545,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kalaburagi",
      id: 11571,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kodagu",
      id: 11578,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Vijayanagar",
      id: 11618,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bagalkote",
      id: 11621,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bidar",
      id: 11624,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Dakshina Kannada",
      id: 11639,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ramanagara",
      id: 11682,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Uttara Kannada",
      id: 11693,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Adityapatna",
      id: 11725,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Aland",
      id: 11761,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Alnavar",
      id: 11780,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Alur",
      id: 11784,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ambikanagara",
      id: 11810,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Anekal",
      id: 11847,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ankola",
      id: 11855,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Annigeri",
      id: 11860,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Arkalgud",
      id: 11890,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Aurad",
      id: 11927,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Badami",
      id: 11971,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bagalkot",
      id: 11994,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bagepalli",
      id: 11998,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bail Hongal",
      id: 12020,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bajala",
      id: 12024,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bajpe",
      id: 12026,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bangalore",
      id: 12077,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bangarapet",
      id: 12079,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bankapura",
      id: 12086,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bannur",
      id: 12092,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bantwal",
      id: 12100,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Basavakalyan",
      id: 12154,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Basavana Bagevadi",
      id: 12155,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Belgaum",
      id: 12193,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Belgaum Cantonment",
      id: 12194,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bellary",
      id: 12198,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Beltangadi",
      id: 12201,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Belur",
      id: 12204,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Belvata",
      id: 12205,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bhadravati",
      id: 12229,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bhalki",
      id: 12238,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bhatkal",
      id: 12262,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bhimarayanagudi",
      id: 12281,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bhogadi",
      id: 12290,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bijapur",
      id: 12323,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bilgi",
      id: 12342,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Birur",
      id: 12365,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bommanahalli",
      id: 12392,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Bommasandra",
      id: 12393,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Byadgi",
      id: 12423,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Byatarayanapura",
      id: 12424,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Challakere",
      id: 12456,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chamrajnagar",
      id: 12464,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Channagiri",
      id: 12485,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Channapatna",
      id: 12486,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Channarayapattana",
      id: 12487,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chik Ballapur",
      id: 12561,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chikmagalur",
      id: 12566,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chiknayakanhalli",
      id: 12567,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chikodi",
      id: 12568,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chincholi",
      id: 12576,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chintamani",
      id: 12587,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chitapur",
      id: 12593,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Chitgoppa",
      id: 12595,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Dandeli",
      id: 12660,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Dargajogihalli",
      id: 12667,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Dasarahalli",
      id: 12675,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Devadurga",
      id: 12724,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Devanhalli",
      id: 12727,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Dod Ballapur",
      id: 12821,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Donimalai Township",
      id: 12835,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gadag-Betigeri",
      id: 12929,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gajendragarh",
      id: 12941,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gangawati",
      id: 12965,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gauribidanur",
      id: 12986,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gokak Falls",
      id: 13043,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gonikoppal",
      id: 13054,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gottikere",
      id: 13071,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gubbi",
      id: 13079,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gudibanda",
      id: 13082,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gulbarga",
      id: 13090,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Guledgudda",
      id: 13091,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gundlupet",
      id: 13095,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Gurmatkal",
      id: 13101,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Haliyal",
      id: 13120,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hangal",
      id: 13128,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Harihar",
      id: 13136,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Harpanahalli",
      id: 13142,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hatti",
      id: 13162,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hatti Gold Mines",
      id: 13163,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hebbagodi",
      id: 13164,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hebbalu",
      id: 13165,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Heggadadevanakote",
      id: 13166,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Herohalli",
      id: 13169,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hindalgi",
      id: 13175,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hirekerur",
      id: 13185,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hiriyur",
      id: 13186,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Holalkere",
      id: 13189,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Holenarsipur",
      id: 13190,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Homnabad",
      id: 13191,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Honavar",
      id: 13192,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Honnali",
      id: 13193,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hoovina Hadagalli",
      id: 13194,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hosanagara",
      id: 13196,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hosdurga",
      id: 13197,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hoskote",
      id: 13199,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hospet",
      id: 13200,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hukeri",
      id: 13205,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hunasamaranahalli",
      id: 13207,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hungund",
      id: 13208,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Hunsur",
      id: 13209,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ilkal",
      id: 13229,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Indi",
      id: 13236,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Jagalur",
      id: 13264,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Jamkhandi",
      id: 13306,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Jevargi",
      id: 13348,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Jog Falls",
      id: 13381,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kadur",
      id: 13422,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kalghatgi",
      id: 13456,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kamalapuram",
      id: 13480,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kampli",
      id: 13490,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kanakapura",
      id: 13497,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kangrali (BK)",
      id: 13516,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kangrali (KH)",
      id: 13517,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kannur",
      id: 13538,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Karkal",
      id: 13583,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kengeri",
      id: 13653,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kerur",
      id: 13655,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Khanapur",
      id: 13686,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kodigenahalli",
      id: 13789,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kodiyal",
      id: 13791,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kollegal",
      id: 13806,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Konanakunte",
      id: 13812,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Konnur",
      id: 13822,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Koppa",
      id: 13829,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Koratagere",
      id: 13833,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kotekara",
      id: 13846,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kothnur",
      id: 13852,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kotturu",
      id: 13864,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Krishnarajanagar",
      id: 13872,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Krishnarajapura",
      id: 13873,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Krishnarajasagara",
      id: 13874,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Krishnarajpet",
      id: 13875,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kudchi",
      id: 13885,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kudligi",
      id: 13886,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kudremukh",
      id: 13888,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kumta",
      id: 13909,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kundapura",
      id: 13912,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kundgol",
      id: 13914,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kunigal",
      id: 13916,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kurgunta",
      id: 13929,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kushalnagar",
      id: 13943,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Kushtagi",
      id: 13944,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Londa",
      id: 14001,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mahadevapura",
      id: 14028,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mahalingpur",
      id: 14030,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mallar",
      id: 14076,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mangalore",
      id: 14108,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Molakalmuru",
      id: 14221,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudalgi",
      id: 14240,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudbidri",
      id: 14241,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudgal",
      id: 14242,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudigere",
      id: 14243,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mudushedde",
      id: 14246,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mulgund",
      id: 14260,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mulki",
      id: 14261,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mulur",
      id: 14264,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Mundgod",
      id: 14267,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Munirabad Project Area",
      id: 14274,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Munnur",
      id: 14275,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Nagamangala",
      id: 14309,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Narasimharajapura",
      id: 14362,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Naregal",
      id: 14370,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Nelmangala",
      id: 14410,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Nipani",
      id: 14436,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Pandavapura",
      id: 14553,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Pattanagere",
      id: 14615,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Pudu",
      id: 14710,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Raybag",
      id: 14834,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sadalgi",
      id: 14874,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sagar",
      id: 14880,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sakleshpur",
      id: 14897,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Saligram",
      id: 14904,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sandur",
      id: 14917,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sankeshwar",
      id: 14928,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sathyamangala",
      id: 14971,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shahabad ACC",
      id: 15011,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shaktinagar",
      id: 15021,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shikarpur",
      id: 15031,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shimoga",
      id: 15033,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shirhatti",
      id: 15034,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Shorapur",
      id: 15045,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Siddapur",
      id: 15049,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sindgi",
      id: 15065,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Siralkoppa",
      id: 15083,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Someshwar",
      id: 15110,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Somvarpet",
      id: 15112,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sorab",
      id: 15120,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sringeri",
      id: 15126,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Sulya",
      id: 15151,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tekkalakota",
      id: 15203,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Thokur-62",
      id: 15265,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Thumbe",
      id: 15275,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tirthahalli",
      id: 15289,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Tirumakudal-Narsipur",
      id: 15291,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Turuvekere",
      id: 15316,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Ullal",
      id: 15331,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Uttarahalli",
      id: 15376,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Venkatapura",
      id: 15448,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Virajpet",
      id: 15475,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Wadi ACC",
      id: 15483,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Yelahanka",
      id: 15501,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Yelandur",
      id: 15502,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Yelbarga",
      id: 15503,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Yellapur",
      id: 15505,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Yenagudde",
      id: 15506,
      state_id: 10004,
    },
    {
      type: "city",
      label: "Adoor",
      id: 10964,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Alappuzha",
      id: 10228,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Attingal",
      id: 10802,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chalakudy",
      id: 10662,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Changanassery",
      id: 10681,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Cherthala",
      id: 10701,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chittur-Thathamangalam",
      id: 10902,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Guruvayoor",
      id: 11211,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kanhangad",
      id: 10464,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kannur",
      id: 10584,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kasaragod",
      id: 10603,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kayamkulam",
      id: 10493,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kochi",
      id: 10103,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kodungallur",
      id: 10862,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kollam",
      id: 10142,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kottayam",
      id: 10599,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Koyilandy",
      id: 10475,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kozhikode",
      id: 10126,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kunnamkulam",
      id: 10607,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Malappuram",
      id: 10364,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Mattannur",
      id: 10718,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Mavelikkara",
      id: 10974,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Mavoor",
      id: 10988,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Muvattupuzha",
      id: 10960,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Nedumangad",
      id: 10554,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Neyyattinkara",
      id: 10480,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Nilambur",
      id: 10694,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Ottappalam",
      id: 10612,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Palai",
      id: 11133,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Palakkad",
      id: 10207,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Panamattom",
      id: 11242,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Panniyannur",
      id: 11199,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pappinisseri",
      id: 10874,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Paravoor",
      id: 10782,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pathanamthitta",
      id: 10788,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Peringathur",
      id: 10797,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Perinthalmanna",
      id: 10713,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Perumbavoor",
      id: 11025,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Ponnani",
      id: 10410,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Punalur",
      id: 10688,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Puthuppally",
      id: 11230,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Shoranur",
      id: 10744,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Taliparamba",
      id: 10470,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thiruvalla",
      id: 10623,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thiruvananthapuram",
      id: 10093,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thodupuzha",
      id: 10630,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thrissur",
      id: 10146,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Tirur",
      id: 10593,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Vaikom",
      id: 11112,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Varkala",
      id: 10762,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Vatakara",
      id: 10454,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Ernakulam",
      id: 11452,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Idukki",
      id: 11653,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Wayanad",
      id: 11695,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Akathiyoor",
      id: 11749,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Aluva",
      id: 11786,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Ancharakandy",
      id: 11841,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Angamaly",
      id: 11848,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Arookutty",
      id: 11895,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Aroor",
      id: 11896,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Avinissery",
      id: 11938,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Azhikode North",
      id: 11948,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Azhikode South",
      id: 11949,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Bangramanjeshwar",
      id: 12082,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Beypore",
      id: 12219,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Brahmakulam",
      id: 12402,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chala",
      id: 12452,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chavakkad",
      id: 12507,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chelora",
      id: 12514,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chendamangalam",
      id: 12517,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chengamanad",
      id: 12519,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chengannur",
      id: 12520,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Cheranallur",
      id: 12523,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Cheruthazham",
      id: 12526,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Cheruvannur",
      id: 12527,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chevvoor",
      id: 12532,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chirakkal",
      id: 12589,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chockli",
      id: 12602,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Choornikkara",
      id: 12606,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Chowwara",
      id: 12614,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Dharmadom",
      id: 12773,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Edathala",
      id: 12868,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Elayavoor",
      id: 12877,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Eloor",
      id: 12880,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Eranholi",
      id: 12884,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Erattupetta",
      id: 12886,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Feroke",
      id: 12919,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Hosabettu",
      id: 13195,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Idukki Township",
      id: 13222,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Iringaprom",
      id: 13242,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Irinjalakuda",
      id: 13243,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Iriveri",
      id: 13244,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kadachira",
      id: 13410,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kadamakkudy",
      id: 13411,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kadirur",
      id: 13419,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kadungalloor",
      id: 13421,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kalamassery",
      id: 13441,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kalliasseri",
      id: 13468,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kalpetta",
      id: 13474,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kanhirode",
      id: 13519,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kanjikkuzhi",
      id: 13523,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kannadiparamba",
      id: 13531,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kannapuram",
      id: 13535,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kannur Cantonment",
      id: 13539,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Karuvanthuruthy",
      id: 13597,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kokkothamangalam",
      id: 13796,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kolazhy",
      id: 13803,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Komalapuram",
      id: 13808,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Koothuparamba",
      id: 13825,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Koratty",
      id: 13835,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kothamangalam",
      id: 13848,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kottayam-Malabar",
      id: 13861,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kottuvally",
      id: 13865,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kudlu",
      id: 13887,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Kureekkad",
      id: 13928,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Manjeri",
      id: 14117,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Manjeshwar",
      id: 14118,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Maradu",
      id: 14130,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Marathakkara",
      id: 14135,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Mavilayi",
      id: 14157,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Methala",
      id: 14188,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Muhamma",
      id: 14250,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Mulavukad",
      id: 14259,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Munderi",
      id: 14266,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Muzhappilangad",
      id: 14294,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Nadathara",
      id: 14304,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Narath",
      id: 14364,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Nenmenikkara",
      id: 14412,
      state_id: 10022,
    },
    {
      type: "city",
      label: "New Mahe",
      id: 14422,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Olavanna",
      id: 14475,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Paduvilayi",
      id: 14503,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Palayad",
      id: 14521,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Palissery",
      id: 14529,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pallikkunnu",
      id: 14534,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Paluvai",
      id: 14538,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Panoor",
      id: 14565,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pantheeramkavu",
      id: 14568,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Paravur",
      id: 14583,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pathiriyad",
      id: 14609,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pattiom",
      id: 14618,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pavaratty",
      id: 14622,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Payyannur",
      id: 14625,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Perakam",
      id: 14635,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Peralasseri",
      id: 14637,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Perumbaikad",
      id: 14646,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pinarayi",
      id: 14671,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Pottore",
      id: 14704,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Puranattukara",
      id: 14725,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Puthukkad",
      id: 14734,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Puthunagaram",
      id: 14735,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Puzhathi",
      id: 14738,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Quilandy",
      id: 14746,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Ramanattukara",
      id: 14786,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thaikkad",
      id: 15215,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thalassery",
      id: 15220,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thiruvankulam",
      id: 15256,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thottada",
      id: 15270,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Thrippunithura",
      id: 15273,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Trivandrum",
      id: 15312,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Udma",
      id: 15322,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Vadakara",
      id: 15381,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Valapattanam",
      id: 15393,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Vallachira",
      id: 15397,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Varam",
      id: 15412,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Varappuzha",
      id: 15413,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Vazhakkala",
      id: 15424,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Venmanad",
      id: 15449,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Villiappally",
      id: 15473,
      state_id: 10022,
    },
    {
      type: "city",
      label: "Alirajpur",
      id: 10521,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ashok Nagar",
      id: 10430,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Balaghat",
      id: 10423,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhopal",
      id: 10052,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ganjbasoda",
      id: 10261,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gwalior",
      id: 10075,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Indore",
      id: 10050,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Itarsi",
      id: 10373,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jabalpur",
      id: 10074,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Lahar",
      id: 10830,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Maharajpur",
      id: 11178,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mahidpur",
      id: 10958,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Maihar",
      id: 10850,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Malaj Khand",
      id: 10903,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Manasa",
      id: 11135,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Manawar",
      id: 11052,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mandideep",
      id: 10770,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mandla",
      id: 10552,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mandsaur",
      id: 10279,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mauganj",
      id: 11119,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mhow Cantonment",
      id: 10392,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mhowgaon",
      id: 11210,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Morena",
      id: 10204,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Multai",
      id: 11179,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mundi",
      id: 10944,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Murwara (Katni)",
      id: 10190,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nagda",
      id: 10368,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nainpur",
      id: 11136,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Narsinghgarh",
      id: 10901,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Neemuch",
      id: 10291,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nepanagar",
      id: 10948,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Niwari",
      id: 11095,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nowgong",
      id: 10764,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nowrozabad (Khodargama)",
      id: 11165,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pachore",
      id: 11196,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pali",
      id: 11195,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Panagar",
      id: 11057,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pandhurna",
      id: 10759,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Panna",
      id: 10629,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pasan",
      id: 10954,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pipariya",
      id: 10715,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pithampur",
      id: 10494,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Porsa",
      id: 10881,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Prithvipur",
      id: 11139,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Raghogarh-Vijaypur",
      id: 10666,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rahatgarh",
      id: 11056,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Raisen",
      id: 10829,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rajgarh",
      id: 11088,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ratlam",
      id: 10164,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rau",
      id: 11201,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rehli",
      id: 11041,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rewa",
      id: 10222,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sabalgarh",
      id: 10858,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sagar",
      id: 10150,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sanawad",
      id: 10855,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sarangpur",
      id: 10904,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sarni",
      id: 10387,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Satna",
      id: 10183,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sausar",
      id: 11081,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sehore",
      id: 10391,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sendhwa",
      id: 10669,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Seoni",
      id: 10398,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Seoni-Malwa",
      id: 11032,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shahdol",
      id: 10442,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shajapur",
      id: 10572,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shamgarh",
      id: 11176,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sheopur",
      id: 10567,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shivpuri",
      id: 10270,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shujalpur",
      id: 10739,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sidhi",
      id: 10702,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sihora",
      id: 10793,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Singrauli",
      id: 10217,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sironj",
      id: 10742,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sohagpur",
      id: 11144,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Tarana",
      id: 11066,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Tikamgarh",
      id: 10439,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ujjain",
      id: 10111,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Umaria",
      id: 10880,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Vidisha",
      id: 10251,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Vijaypur",
      id: 11232,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Wara Seoni",
      id: 11062,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhind",
      id: 11268,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chhatarpur",
      id: 11275,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Damoh",
      id: 11279,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dindori",
      id: 11284,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Harda",
      id: 11294,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khargone (West Nimar)",
      id: 11304,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Narmadapuram",
      id: 11321,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Agar-Malwa",
      id: 11346,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Barwani",
      id: 11359,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Datia",
      id: 11370,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jhabua",
      id: 11387,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khandwa (East Nimar)",
      id: 11397,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Katni",
      id: 11473,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Narsimhapur",
      id: 11492,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Anuppur",
      id: 11530,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ashoknagar",
      id: 11532,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Burhanpur",
      id: 11543,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Betul",
      id: 11623,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chhindwara",
      id: 11635,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dewas",
      id: 11643,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dhar",
      id: 11644,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Guna",
      id: 11651,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Agar",
      id: 11728,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ajaigarh",
      id: 11743,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Akoda",
      id: 11756,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Akodia",
      id: 11757,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Alampur",
      id: 11760,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Alot",
      id: 11782,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Amanganj",
      id: 11791,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Amarkantak",
      id: 11793,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Amarpatan",
      id: 11794,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Amarwara",
      id: 11797,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ambada",
      id: 11799,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ambah",
      id: 11801,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Amla",
      id: 11821,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Amlai",
      id: 11823,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Anjad",
      id: 11850,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Antari",
      id: 11864,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Aron",
      id: 11894,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ashta",
      id: 11905,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Babai",
      id: 11954,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bada Malhera",
      id: 11968,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badagaon",
      id: 11969,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badagoan",
      id: 11970,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badarwas",
      id: 11975,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badawada",
      id: 11976,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badi",
      id: 11984,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badkuhi",
      id: 11985,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badnagar",
      id: 11987,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badnawar",
      id: 11988,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badod",
      id: 11989,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badoda",
      id: 11990,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Badra",
      id: 11991,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bagh",
      id: 12000,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bagli",
      id: 12003,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Baihar",
      id: 12017,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Baikunthpur",
      id: 12019,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Baldeogarh",
      id: 12045,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bamhani",
      id: 12058,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bamor",
      id: 12059,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bamora",
      id: 12060,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Banda",
      id: 12069,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bangawan",
      id: 12081,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bansatar Kheda",
      id: 12093,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Baraily",
      id: 12106,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Barela",
      id: 12119,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Barghat",
      id: 12121,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Barhi",
      id: 12126,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Barigarh",
      id: 12130,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Barwaha",
      id: 12149,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Basoda",
      id: 12162,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Begamganj",
      id: 12178,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Beohari",
      id: 12209,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Berasia",
      id: 12210,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Betma",
      id: 12216,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Betul-Bazar",
      id: 12217,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhainsdehi",
      id: 12236,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhamodi",
      id: 12240,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhander",
      id: 12242,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhanpura",
      id: 12248,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bharveli",
      id: 12258,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhaurasa",
      id: 12266,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhavra",
      id: 12269,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhedaghat",
      id: 12274,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhikangaon",
      id: 12276,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhilakhedi",
      id: 12280,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bhitarwar",
      id: 12288,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Biaora",
      id: 12313,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bijawar",
      id: 12324,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bijeypur",
      id: 12326,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bijuri",
      id: 12329,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bilaua",
      id: 12341,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bilpura",
      id: 12350,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bina Etawa",
      id: 12354,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Bina Rly Colony",
      id: 12355,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Birsinghpur",
      id: 12364,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Boda",
      id: 12379,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Budhni",
      id: 12411,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Burhar",
      id: 12419,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Buxwaha",
      id: 12422,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chachaura-Binaganj",
      id: 12433,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chakghat",
      id: 12444,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chandameta-Butaria",
      id: 12466,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chanderi",
      id: 12470,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chandia",
      id: 12471,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chandla",
      id: 12475,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chaurai Khas",
      id: 12506,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chhota Chhindwara (Gotegaon)",
      id: 12550,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chichli",
      id: 12558,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Chitrakoot",
      id: 12598,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Churhat",
      id: 12619,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Daboh",
      id: 12635,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dabra",
      id: 12636,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Damua",
      id: 12659,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Deodara",
      id: 12700,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Deori",
      id: 12709,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Depalpur",
      id: 12711,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Devendranagar",
      id: 12730,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Devhara",
      id: 12733,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dhamnod",
      id: 12745,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dhana",
      id: 12747,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dhanpuri",
      id: 12756,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dharampuri",
      id: 12762,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dighawani",
      id: 12805,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Diken",
      id: 12810,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dola",
      id: 12828,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dongar Parasia",
      id: 12832,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Dumar Kachhar",
      id: 12847,
      state_id: 10012,
    },
    {
      type: "city",
      label: "G.C.F Jabalpur",
      id: 12927,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gadarwara",
      id: 12931,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gairatganj",
      id: 12938,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Garhakota",
      id: 12974,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Garhi-Malhara",
      id: 12976,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Garoth",
      id: 12980,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ghansor",
      id: 12995,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ghuwara",
      id: 13024,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gogapur",
      id: 13038,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gohad",
      id: 13040,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gormi",
      id: 13066,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Govindgarh",
      id: 13075,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Gurh",
      id: 13099,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hanumana",
      id: 13129,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Harpalpur",
      id: 13141,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Harrai",
      id: 13143,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Harsud",
      id: 13145,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hatod",
      id: 13158,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hatpipalya",
      id: 13159,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hatta",
      id: 13161,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hindoria",
      id: 13177,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hirapur",
      id: 13184,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Hoshangabad",
      id: 13198,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ichhawar",
      id: 13219,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Iklehra",
      id: 13226,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Indergarh",
      id: 13235,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Isagarh",
      id: 13246,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jabalpur Cantt.",
      id: 13254,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jaisinghnagar",
      id: 13279,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jaithari",
      id: 13282,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jaitwara",
      id: 13284,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jamai",
      id: 13302,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jaora",
      id: 13318,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jata Chhapar",
      id: 13328,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jatara",
      id: 13329,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jawad",
      id: 13331,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jawar",
      id: 13335,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jeron Khalsa",
      id: 13345,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jhundpura",
      id: 13367,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jiran",
      id: 13373,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jirapur",
      id: 13374,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Jobat",
      id: 13377,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Joura",
      id: 13392,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kailaras",
      id: 13425,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kakarhati",
      id: 13432,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kali Chhapar",
      id: 13458,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kanad",
      id: 13494,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kannod",
      id: 13537,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kantaphod",
      id: 13545,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kareli",
      id: 13572,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Karera",
      id: 13573,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kari",
      id: 13576,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Karnawad",
      id: 13586,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Karrapur",
      id: 13589,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kasrawad",
      id: 13607,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Katangi",
      id: 13610,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kelhauri(chachai)",
      id: 13646,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khachrod",
      id: 13662,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khajuraho",
      id: 13673,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khand(Bansagar)",
      id: 13688,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khandwa",
      id: 13692,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khaniyadhana",
      id: 13693,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khargapur",
      id: 13703,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khargone",
      id: 13704,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khategaon",
      id: 13721,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khetia",
      id: 13738,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khilchipur",
      id: 13740,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khirkiya",
      id: 13741,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khujner",
      id: 13751,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Khurai",
      id: 13753,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kolaras",
      id: 13800,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kotar",
      id: 13844,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kothi",
      id: 13850,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kotma",
      id: 13854,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kukshi",
      id: 13893,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kumbhraj",
      id: 13905,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kurwai",
      id: 13940,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Kymore",
      id: 13952,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Lakhnadon",
      id: 13960,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Lateri",
      id: 13976,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Laundi",
      id: 13978,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Lidhorakhas",
      id: 13986,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Lodhikheda",
      id: 13995,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Loharda",
      id: 13997,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Machalpur",
      id: 14005,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Maheshwar",
      id: 14035,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Majholi",
      id: 14059,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Makronia",
      id: 14064,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Maksi",
      id: 14065,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Malhargarh",
      id: 14070,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mandav",
      id: 14099,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mandleshwar",
      id: 14102,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Manegaon",
      id: 14103,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mangawan",
      id: 14109,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Manglaya Sadak",
      id: 14110,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Manpur",
      id: 14124,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mau",
      id: 14150,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Meghnagar",
      id: 14165,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mehara Gaon",
      id: 14167,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mehgaon",
      id: 14170,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mhow Cantt.",
      id: 14192,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mihona",
      id: 14193,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mohgaon",
      id: 14215,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Morar Cantt.",
      id: 14230,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Mungaoli",
      id: 14272,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nagod",
      id: 14314,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nagri",
      id: 14318,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nai Garhi",
      id: 14323,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nalkheda",
      id: 14333,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Namli",
      id: 14338,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Narayangarh",
      id: 14368,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Narwar",
      id: 14377,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nasrullaganj",
      id: 14381,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Naudhia",
      id: 14388,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Neuton Chikhli Kalan",
      id: 14418,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nowgaon",
      id: 14454,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Nowrozabad(Khodargama)",
      id: 14455,
      state_id: 10012,
    },
    {
      type: "city",
      label: "O.F.Khamaria",
      id: 14462,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Obedullaganj",
      id: 14463,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Omkareshwar",
      id: 14479,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Orachha",
      id: 14481,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ordinance Factory Itarsi",
      id: 14484,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pachmarhi Cantt",
      id: 14494,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pal Chourai",
      id: 14509,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Palda",
      id: 14523,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Palera",
      id: 14526,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Panara",
      id: 14545,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pandhana",
      id: 14554,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pansemal",
      id: 14567,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Patan",
      id: 14602,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Patharia",
      id: 14608,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pawai",
      id: 14623,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Petlawad",
      id: 14656,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Phuphkalan",
      id: 14665,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Pichhore",
      id: 14666,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Piploda",
      id: 14676,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Piplya Mandi",
      id: 14677,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Polay Kalan",
      id: 14687,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Raghogarh -Vijaypur",
      id: 14753,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rajakhedi",
      id: 14766,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rajnagar",
      id: 14777,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rajpur",
      id: 14779,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rampur Baghelan",
      id: 14806,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rampur Naikin",
      id: 14809,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rampura",
      id: 14810,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ranapur",
      id: 14812,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ratangarh",
      id: 14825,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ratlam Rly. Colony (Ratlam Kasba)",
      id: 14829,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Rehti",
      id: 14839,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Runji Gautampura",
      id: 14861,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sagar Cantt.",
      id: 14881,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sailana",
      id: 14891,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sanchi",
      id: 14914,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sardarpur",
      id: 14949,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Satai",
      id: 14966,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Satwas",
      id: 14974,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sawer",
      id: 14979,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Semaria",
      id: 14988,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Seondha",
      id: 14995,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Seoni Malwa",
      id: 14997,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sethia",
      id: 15003,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shahgarh",
      id: 15013,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shahpur",
      id: 15017,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Shahpura",
      id: 15019,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Singoli",
      id: 15078,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sinhasa",
      id: 15080,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sirgora",
      id: 15088,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sirmaur",
      id: 15091,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sitamau",
      id: 15099,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sonkatch",
      id: 15118,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Soyatkalan",
      id: 15122,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Suhagi",
      id: 15139,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Sultanpur",
      id: 15148,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Susner",
      id: 15165,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Suthaliya",
      id: 15166,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Tal",
      id: 15173,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Talen",
      id: 15178,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Taricharkalan",
      id: 15193,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Tekanpur",
      id: 15201,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Tendu Kheda",
      id: 15207,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Teonthar",
      id: 15211,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Thandla",
      id: 15224,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Timarni",
      id: 15284,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Tirodi",
      id: 15288,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Udaipura",
      id: 15318,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Ukwa",
      id: 15329,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Unchehara",
      id: 15347,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Unhel",
      id: 15348,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Vehicle Fac. Jabalpur",
      id: 15435,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Vijayraghavgarh",
      id: 15465,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Narsinghgarh (2)",
      id: 11247,
      state_id: 10012,
    },
    {
      type: "city",
      label: "Achalpur",
      id: 10328,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ahmednagar",
      id: 10141,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Akola",
      id: 10127,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Akot",
      id: 10390,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Amalner",
      id: 10380,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ambejogai",
      id: 10459,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Amravati",
      id: 10097,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Anjangaon",
      id: 10588,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Arvi",
      id: 10733,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Aurangabad",
      id: 10356,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhiwandi",
      id: 10094,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dhule",
      id: 10135,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ichalkaranji",
      id: 10158,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kalyan-Dombivali",
      id: 10064,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Karjat",
      id: 10949,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Latur",
      id: 10134,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Loha",
      id: 11223,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Lonar",
      id: 11105,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Lonavla",
      id: 10574,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mahad",
      id: 11083,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Malegaon",
      id: 10122,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Malkapur",
      id: 10548,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mangalvedhe",
      id: 11171,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mangrulpir",
      id: 10992,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Manjlegaon",
      id: 10723,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Manmad",
      id: 10471,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Manwath",
      id: 10963,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mehkar",
      id: 10796,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mhaswad",
      id: 11212,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mira-Bhayandar",
      id: 10092,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Morshi",
      id: 10871,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mukhed",
      id: 11039,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mul",
      id: 11145,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mumbai",
      id: 10036,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Murtijapur",
      id: 10783,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nagpur",
      id: 10048,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nanded-Waghala",
      id: 10108,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nandgaon",
      id: 11239,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nandura",
      id: 10743,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nandurbar",
      id: 10331,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Narkhed",
      id: 11188,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nashik",
      id: 10060,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nawapur",
      id: 10852,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nilanga",
      id: 10823,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Osmanabad",
      id: 10329,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ozar",
      id: 10639,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pachora",
      id: 10706,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Paithan",
      id: 10845,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Palghar",
      id: 10625,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pandharkaoda",
      id: 11024,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pandharpur",
      id: 10395,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Panvel",
      id: 10200,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Parbhani",
      id: 10174,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Parli",
      id: 10403,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Partur",
      id: 10966,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pathardi",
      id: 11128,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pathri",
      id: 10913,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Patur",
      id: 11208,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pauni",
      id: 11138,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pen",
      id: 10939,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Phaltan",
      id: 10643,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pulgaon",
      id: 10818,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pune",
      id: 10043,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Purna",
      id: 10877,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pusad",
      id: 10502,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rahuri",
      id: 10846,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rajura",
      id: 11043,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ramtek",
      id: 11140,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ratnagiri",
      id: 10486,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Raver",
      id: 11036,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Risod",
      id: 11003,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sailu",
      id: 10771,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sangamner",
      id: 10538,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sangli",
      id: 10112,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sangole",
      id: 10983,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sasvad",
      id: 11020,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Satana",
      id: 10891,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Satara",
      id: 10342,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Savner",
      id: 11019,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sawantwadi",
      id: 11124,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shahade",
      id: 10661,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shegaon",
      id: 10626,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shendurjana",
      id: 11190,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shirdi",
      id: 11033,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shirpur-Warwade",
      id: 10544,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shirur",
      id: 11013,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shrigonda",
      id: 11029,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shrirampur",
      id: 10401,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sillod",
      id: 10725,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sinnar",
      id: 10916,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Solapur",
      id: 10085,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Soyagaon",
      id: 11167,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Talegaon Dabhade",
      id: 10587,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Talode",
      id: 11028,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tasgaon",
      id: 10791,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Thane",
      id: 10051,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tirora",
      id: 11059,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tuljapur",
      id: 10859,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tumsar",
      id: 10709,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Uchgaon",
      id: 10926,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Udgir",
      id: 10352,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Umarga",
      id: 10835,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Umarkhed",
      id: 10685,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Umred",
      id: 10608,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Uran",
      id: 10936,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Uran Islampur",
      id: 10498,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vadgaon Kasba",
      id: 11046,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vaijapur",
      id: 10755,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vasai-Virar",
      id: 10065,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vita",
      id: 10676,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wadgaon Road",
      id: 10760,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wai",
      id: 10826,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wani",
      id: 10560,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wardha",
      id: 10346,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Warora",
      id: 10693,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Warud",
      id: 11248,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Washim",
      id: 10445,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Yavatmal",
      id: 10314,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Yawal",
      id: 10815,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Yevla",
      id: 10657,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Beed",
      id: 11263,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhandara",
      id: 11267,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chandrapur",
      id: 11274,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sindhudurg",
      id: 11334,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jalna",
      id: 11385,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mumbai Suburban",
      id: 11405,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Hingoli",
      id: 11463,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nanded",
      id: 11491,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Raigad",
      id: 11505,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Buldhana",
      id: 11542,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gadchiroli",
      id: 11557,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gondia",
      id: 11562,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jalgaon",
      id: 11567,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chhatrapati Sambhajinagar",
      id: 11634,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dharashiv",
      id: 11645,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kolhapur",
      id: 11667,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ahmadnagar",
      id: 11733,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ahmadpur",
      id: 11735,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ajra",
      id: 11746,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Akkalkot",
      id: 11752,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Alandi",
      id: 11762,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Alibag",
      id: 11774,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ambad",
      id: 11798,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ambarnath",
      id: 11805,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ambivali Tarf Wankhal",
      id: 11812,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ashta",
      id: 11906,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ausa",
      id: 11932,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Babhulgaon",
      id: 11958,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Badlapur",
      id: 11986,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Balapur",
      id: 12039,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ballarpur",
      id: 12051,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Baramati",
      id: 12108,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Barshi",
      id: 12143,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Basmath",
      id: 12159,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhadravati",
      id: 12228,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhagur",
      id: 12233,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhingar",
      id: 12285,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhokardan",
      id: 12295,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhor",
      id: 12299,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhum",
      id: 12308,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bhusawal",
      id: 12310,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Bid",
      id: 12316,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Biloli",
      id: 12348,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Birwadi",
      id: 12366,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Boisar",
      id: 12386,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Brahmapuri",
      id: 12404,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Budhgaon",
      id: 12409,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Buldana",
      id: 12416,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chakan",
      id: 12440,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chalisgaon",
      id: 12455,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chandur",
      id: 12482,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chandurbazar",
      id: 12484,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chicholi",
      id: 12559,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chikhaldara",
      id: 12562,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chikhli",
      id: 12563,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chinchani",
      id: 12574,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chiplun",
      id: 12588,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Chopda",
      id: 12608,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dahanu",
      id: 12641,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dapoli Camp",
      id: 12664,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Darwha",
      id: 12673,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Daryapur Banosa",
      id: 12674,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dattapur Dhamangaon",
      id: 12680,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Daund",
      id: 12684,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Davlameti",
      id: 12686,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Deglur",
      id: 12692,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dehu",
      id: 12694,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dehu Road",
      id: 12695,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Deolali",
      id: 12701,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Deolali Pravara",
      id: 12702,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Deoli",
      id: 12703,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Desaiganj",
      id: 12717,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Deulgaon Raja",
      id: 12720,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dewhadi",
      id: 12736,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dharangaon",
      id: 12763,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dharmabad",
      id: 12772,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dharur",
      id: 12778,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dhatau",
      id: 12779,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Digdoh",
      id: 12804,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Digras",
      id: 12808,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dondaicha-Warwade",
      id: 12831,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dudhani",
      id: 12841,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Durgapur",
      id: 12857,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Dyane",
      id: 12863,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Eklahare",
      id: 12874,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Erandol",
      id: 12883,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Faizpur",
      id: 12898,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gadhinglaj",
      id: 12934,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gandhinagar",
      id: 12955,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ganeshpur",
      id: 12956,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gangakhed",
      id: 12959,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gangapur",
      id: 12960,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Georai",
      id: 12992,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ghatanji",
      id: 13003,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ghoti Budruk",
      id: 13019,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ghugus",
      id: 13021,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ghulewadi",
      id: 13022,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Godoli",
      id: 13036,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gokhivare",
      id: 13045,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Gondiya",
      id: 13052,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Goregaon",
      id: 13065,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Greater Mumbai",
      id: 13076,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Guhagar",
      id: 13084,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Hadgaon",
      id: 13108,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Hinganghat",
      id: 13180,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Hupari",
      id: 13210,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Igatpuri",
      id: 13223,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Indapur",
      id: 13234,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jalgaon (Jamod)",
      id: 13296,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jamkhed",
      id: 13307,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jawhar",
      id: 13336,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jaysingpur",
      id: 13340,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jejuri",
      id: 13341,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Jintur",
      id: 13372,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Junnar",
      id: 13400,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kabnur",
      id: 13403,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kagal",
      id: 13423,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kalamb",
      id: 13442,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kalambe Turf Thane",
      id: 13443,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kalameshwar",
      id: 13445,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kalamnuri",
      id: 13446,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kalundre",
      id: 13476,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kamptee",
      id: 13491,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kandari",
      id: 13505,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kandhar",
      id: 13506,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kandri",
      id: 13511,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kanhan (Pipri)",
      id: 13518,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kankavli",
      id: 13525,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kannad",
      id: 13529,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Karad",
      id: 13559,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Karanja",
      id: 13565,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Karanje Turf Satara",
      id: 13566,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Karivali",
      id: 13581,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Karmala",
      id: 13584,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kasara Budruk",
      id: 13598,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Katai",
      id: 13608,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Katkar",
      id: 13616,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Katol",
      id: 13617,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kegaon",
      id: 13643,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khadkale",
      id: 13664,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khamgaon",
      id: 13682,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khapa",
      id: 13696,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khed",
      id: 13725,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kherdi",
      id: 13733,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khoni",
      id: 13745,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khopoli",
      id: 13747,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Khuldabad",
      id: 13752,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kinwat",
      id: 13766,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kirkee",
      id: 13773,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kodoli",
      id: 13792,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kon",
      id: 13811,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kondumal",
      id: 13819,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kopargaon",
      id: 13827,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kopharad",
      id: 13828,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Korochi",
      id: 13836,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kudal",
      id: 13884,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kundalwadi",
      id: 13911,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kurduvadi",
      id: 13927,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kurundvad",
      id: 13939,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Kusgaon Budruk",
      id: 13941,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Lanja",
      id: 13972,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Lasalgaon",
      id: 13975,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Lonavala",
      id: 14000,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Madhavnagar",
      id: 14014,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mahabaleshwar",
      id: 14026,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mahadula",
      id: 14029,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Maindargi",
      id: 14052,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Malwan",
      id: 14082,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Manadur",
      id: 14085,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Manchar",
      id: 14093,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Manor",
      id: 14123,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mansar",
      id: 14125,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Matheran",
      id: 14147,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mhasla",
      id: 14191,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mohpa",
      id: 14218,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mohpada Alias Wasambe",
      id: 14219,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mowad",
      id: 14237,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Mudkhed",
      id: 14244,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Murbad",
      id: 14278,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Murgud",
      id: 14280,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Murud",
      id: 14283,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Murum",
      id: 14285,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nachane",
      id: 14302,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nagapur",
      id: 14310,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nagardeole",
      id: 14311,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nagothana",
      id: 14316,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nakoda",
      id: 14327,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nala Sopara",
      id: 14328,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Naldurg",
      id: 14331,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Navghar-Manikpur",
      id: 14393,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Navi Mumbai",
      id: 14394,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Navi Mumbai (Panvel, Raigarh)",
      id: 14395,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Neral",
      id: 14413,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nildoh",
      id: 14431,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Nimbhore Budruk",
      id: 14434,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pachgaon",
      id: 14493,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Padagha",
      id: 14496,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pali",
      id: 14527,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Panchgani",
      id: 14548,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Panhala",
      id: 14557,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Paranda",
      id: 14578,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Parola",
      id: 14590,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pasthal",
      id: 14597,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Patan",
      id: 14601,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Peth Umri",
      id: 14653,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Pimpri Chinchwad",
      id: 14669,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Poladpur",
      id: 14685,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Purushottamnagar",
      id: 14730,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rahimatpur",
      id: 14759,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rahta Pimplas",
      id: 14761,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rajapur",
      id: 14767,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rajgurunagar (Khed)",
      id: 14775,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Rajur",
      id: 14781,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Roha Ashtami",
      id: 14852,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sandor",
      id: 14916,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sangli-Miraj & Kupwad",
      id: 14920,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sasti",
      id: 14965,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Savda",
      id: 14977,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sawari Jawharnagar",
      id: 14978,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shahapur",
      id: 15012,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shelar",
      id: 15027,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shirwal",
      id: 15035,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shivajinagar",
      id: 15036,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shivatkar (Nira)",
      id: 15037,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shrirampur(Rural)",
      id: 15046,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Shrivardhan",
      id: 15047,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sillewada",
      id: 15062,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sindi",
      id: 15066,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sindi Turf Hindnagar",
      id: 15067,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sindkhed Raja",
      id: 15068,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Singnapur",
      id: 15077,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sonegaon (Nipani)",
      id: 15117,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Sonpeth",
      id: 15119,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Surgana",
      id: 15161,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Taloje Panchnad",
      id: 15182,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tarapur",
      id: 15192,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tathavade",
      id: 15196,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Tekadi",
      id: 15200,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Telhara",
      id: 15205,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Totaladoh",
      id: 15309,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Trimbak",
      id: 15311,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Ulhasnagar",
      id: 15330,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Umarsara",
      id: 15336,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Umbar Pada Nandade",
      id: 15337,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Umri Pragane Balapur",
      id: 15342,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Utekhol",
      id: 15360,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vada",
      id: 15380,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vadgaon",
      id: 15386,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vanvadi (Sadashivgad)",
      id: 15408,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vasai",
      id: 15416,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vasantnagar",
      id: 15417,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vashind",
      id: 15418,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Vengurla",
      id: 15446,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Virar",
      id: 15476,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wadi",
      id: 15482,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Waghapur",
      id: 15484,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wajegaon",
      id: 15485,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Walani",
      id: 15488,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Waliv",
      id: 15489,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Wanadongri",
      id: 15490,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Yerkheda",
      id: 15507,
      state_id: 10002,
    },
    {
      type: "city",
      label: "Imphal",
      id: 10168,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Lilong",
      id: 11126,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Mayang Imphal",
      id: 11209,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Thoubal",
      id: 10699,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Chandel",
      id: 11273,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Noney",
      id: 11322,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Tengnoupal",
      id: 11339,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Bishnupur",
      id: 11360,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Jiribam",
      id: 11388,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Senapati",
      id: 11417,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Imphal West",
      id: 11566,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Kakching",
      id: 11570,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Kamjong",
      id: 11572,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Kangpokpi",
      id: 11574,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Pherzawl",
      id: 11598,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Tamenglong",
      id: 11611,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Ukhrul",
      id: 11615,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Churachandpur",
      id: 11637,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Imphal East",
      id: 11654,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Andro",
      id: 11845,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Heriok",
      id: 13168,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Kakching Khunou",
      id: 13433,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Khongman",
      id: 13744,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Kumbi",
      id: 13906,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Kwakta",
      id: 13950,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Lamai",
      id: 13966,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Lamjaotongba",
      id: 13968,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Lamshang",
      id: 13969,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Lilong (Imphal West)",
      id: 13989,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Lilong (Thoubal)",
      id: 13990,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Moirang",
      id: 14220,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Moreh",
      id: 14231,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Nambol",
      id: 14337,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Naoriya Pakhanglakpa",
      id: 14356,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Ningthoukhong",
      id: 14435,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Oinam",
      id: 14471,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Porompat",
      id: 14700,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Samurou",
      id: 14912,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Sekmai Bazar",
      id: 14987,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Sikhong Sekmai",
      id: 15058,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Sugnu",
      id: 15138,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Thongkhong Laxmi Bazar",
      id: 15268,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Torban (Khetri Leikai)",
      id: 15307,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Wangjing",
      id: 15492,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Wangoi",
      id: 15493,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Yairipok",
      id: 15500,
      state_id: 10028,
    },
    {
      type: "city",
      label: "Nongstoin",
      id: 10970,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Shillong",
      id: 10167,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Tura",
      id: 10455,
      state_id: 10027,
    },
    {
      type: "city",
      label: "East Jaintia Hills",
      id: 11286,
      state_id: 10027,
    },
    {
      type: "city",
      label: "West Khasi Hills",
      id: 11343,
      state_id: 10027,
    },
    {
      type: "city",
      label: "East Garo Hills",
      id: 11374,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Ri Bhoi",
      id: 11415,
      state_id: 10027,
    },
    {
      type: "city",
      label: "South Garo Hills",
      id: 11518,
      state_id: 10027,
    },
    {
      type: "city",
      label: "South West Khasi Hills",
      id: 11519,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Eastern West Khasi Hills",
      id: 11553,
      state_id: 10027,
    },
    {
      type: "city",
      label: "East Khasi Hills",
      id: 11555,
      state_id: 10027,
    },
    {
      type: "city",
      label: "North Garo Hills",
      id: 11677,
      state_id: 10027,
    },
    {
      type: "city",
      label: "South West Garo Hills",
      id: 11687,
      state_id: 10027,
    },
    {
      type: "city",
      label: "West Garo Hills",
      id: 11696,
      state_id: 10027,
    },
    {
      type: "city",
      label: "West Jaintia Hills",
      id: 11697,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Baghmara",
      id: 12002,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Cherapunjee",
      id: 12525,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Jawai",
      id: 13333,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Madanrting",
      id: 14010,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Mairang",
      id: 14053,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Mawlai",
      id: 14159,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Nongmynsong",
      id: 14446,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Nongpoh",
      id: 14447,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Nongthymmai",
      id: 14448,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Pynthorumkhrah",
      id: 14740,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Resubelpara",
      id: 14844,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Shillong Cantt.",
      id: 15032,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Williamnagar",
      id: 15498,
      state_id: 10027,
    },
    {
      type: "city",
      label: "Aizawl",
      id: 10157,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Lunglei",
      id: 10582,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Saiha",
      id: 11227,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Kolasib",
      id: 11309,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Hnahthial",
      id: 11383,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Lawngtlai",
      id: 11399,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Mamit",
      id: 11485,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Saitual",
      id: 11509,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Siaha",
      id: 11516,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Khawzawl",
      id: 11576,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Serchhip",
      id: 11605,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Champhai",
      id: 11632,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Bairabi",
      id: 12021,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Biate",
      id: 12314,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Darlawn",
      id: 12671,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Khawhai",
      id: 13724,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Lengpui",
      id: 13984,
      state_id: 10026,
    },
    {
      type: "city",
      label: "N. Vanlaiphai",
      id: 14296,
      state_id: 10026,
    },
    {
      type: "city",
      label: "N.Kawnpui",
      id: 14297,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Sairang",
      id: 14893,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Thenzawl",
      id: 15233,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Tlabung",
      id: 15301,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Vairengte",
      id: 15390,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Zawlnuam",
      id: 15512,
      state_id: 10026,
    },
    {
      type: "city",
      label: "Dimapur",
      id: 10300,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Kohima",
      id: 10374,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Mokokchung",
      id: 10927,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Tuensang",
      id: 10812,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Wokha",
      id: 10840,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Zunheboto",
      id: 10800,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Longleng",
      id: 11313,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Mon",
      id: 11318,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Kiphire",
      id: 11476,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Noklak",
      id: 11494,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Shamator",
      id: 11514,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Tseminyu",
      id: 11524,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Chumoukedima",
      id: 11547,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Peren",
      id: 11596,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Phek",
      id: 11597,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Niuland",
      id: 11674,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Chumukedima",
      id: 12616,
      state_id: 10030,
    },
    {
      type: "city",
      label: "Balangir",
      id: 10375,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Baleshwar Town",
      id: 10310,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Barbil",
      id: 10509,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bargarh",
      id: 10433,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Baripada Town",
      id: 10335,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bhadrak",
      id: 10343,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bhawanipatna",
      id: 10492,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bhubaneswar",
      id: 10089,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Brahmapur",
      id: 10138,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Byasanagar",
      id: 10670,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Cuttack",
      id: 10102,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Dhenkanal",
      id: 10497,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jatani",
      id: 10595,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jharsuguda",
      id: 10377,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kendrapara",
      id: 10689,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kendujhar",
      id: 10551,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Malkangiri",
      id: 11117,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nabarangapur",
      id: 10945,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Paradip",
      id: 10462,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Parlakhemundi",
      id: 10730,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Pattamundai",
      id: 10887,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Phulabani",
      id: 10863,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Puri",
      id: 10246,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Rairangpur",
      id: 11163,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Rajagangapur",
      id: 10728,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Raurkela",
      id: 10119,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Rayagada",
      id: 10573,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Sambalpur",
      id: 10221,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Soro",
      id: 10993,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Sunabeda",
      id: 10559,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Sundargarh",
      id: 10785,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Talcher",
      id: 10761,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Tarbha",
      id: 11245,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Titlagarh",
      id: 10925,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jagatsinghapur",
      id: 11297,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Sonepur",
      id: 11336,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Baleshwar",
      id: 11352,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Ganjam",
      id: 11376,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kalahandi",
      id: 11391,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Deogarh",
      id: 11444,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jajapur",
      id: 11465,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kandhamal",
      id: 11469,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Mayurbhanj",
      id: 11487,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nabarangpur",
      id: 11489,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Anugul",
      id: 11529,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Boudh",
      id: 11541,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Gajapati",
      id: 11558,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khordha",
      id: 11577,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Koraput",
      id: 11579,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nuapada",
      id: 11593,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nayagarh",
      id: 11673,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Anandapur",
      id: 11837,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Asika",
      id: 11908,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Athagad",
      id: 11915,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Athmallik",
      id: 11920,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Balagoda (Bolani)",
      id: 12035,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Balimela",
      id: 12049,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Balugaon",
      id: 12056,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Banapur",
      id: 12063,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bangura",
      id: 12083,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Banki",
      id: 12087,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Barapali",
      id: 12110,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Baripada",
      id: 12132,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Basudebpur",
      id: 12164,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Baudhgarh",
      id: 12169,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Belagachhia",
      id: 12189,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bellaguntha",
      id: 12196,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Belpahar",
      id: 12199,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bhanjanagar",
      id: 12245,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bhuban",
      id: 12303,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Binika",
      id: 12357,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Biramitrapur",
      id: 12359,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Bishama Katek",
      id: 12370,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Brajarajnagar",
      id: 12405,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Buguda",
      id: 12415,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Burla",
      id: 12421,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Champua",
      id: 12462,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Chandapur",
      id: 12468,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Chandili",
      id: 12473,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Charibatia",
      id: 12497,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Chhatrapur",
      id: 12544,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Chikiti",
      id: 12565,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Choudwar",
      id: 12612,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Dadhapatna",
      id: 12637,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Daitari",
      id: 12644,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Damanjodi",
      id: 12657,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Debagarh",
      id: 12690,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Deracolliery Township",
      id: 12715,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Dhamanagar",
      id: 12743,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Digapahandi",
      id: 12801,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Dungamal",
      id: 12852,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Fertilzer Corporation of IndiaTownship",
      id: 12921,
      state_id: 10021,
    },
    {
      type: "city",
      label: "G. Udayagiri",
      id: 12926,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Ghantapada",
      id: 12996,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Gopalpur",
      id: 13057,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Gudari",
      id: 13081,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Gunupur",
      id: 13097,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Hatibandha",
      id: 13156,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Hinjilicut",
      id: 13181,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Hirakud",
      id: 13182,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jalda",
      id: 13293,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jaleswar",
      id: 13295,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jeypur",
      id: 13350,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Jhumpura",
      id: 13366,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Joda",
      id: 13379,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Junagarh",
      id: 13399,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kamakshyanagar",
      id: 13479,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kantabanji",
      id: 13544,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kantilo",
      id: 13548,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Karanjia",
      id: 13567,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kashinagara",
      id: 13602,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kavisuryanagar",
      id: 13632,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kesinga",
      id: 13658,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khaliapali",
      id: 13675,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khalikote",
      id: 13676,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khandapada",
      id: 13689,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khariar",
      id: 13706,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khariar Road",
      id: 13707,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Khatiguda",
      id: 13722,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kochinda",
      id: 13782,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kodala",
      id: 13785,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Konark",
      id: 13814,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Kotpad",
      id: 13855,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Lattikata",
      id: 13977,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Makundapur",
      id: 14068,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Mukhiguda",
      id: 14254,
      state_id: 10021,
    },
    {
      type: "city",
      label: "NALCO",
      id: 14330,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nilagiri",
      id: 14429,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nimapada",
      id: 14433,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Nuapatna",
      id: 14457,
      state_id: 10021,
    },
    {
      type: "city",
      label: "OCL Industrialship",
      id: 14464,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Padmapur",
      id: 14502,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Panposh",
      id: 14566,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Patnagarh",
      id: 14612,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Pipili",
      id: 14675,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Polasara",
      id: 14686,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Pratapsasan",
      id: 14707,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Purusottampur",
      id: 14731,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Rambha",
      id: 14791,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Raurkela Industrialship",
      id: 14830,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Redhakhol",
      id: 14836,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Remuna",
      id: 14842,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Rengali Dam Projectship",
      id: 14843,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Sonapur",
      id: 15114,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Surada",
      id: 15156,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Talcher Thermal Power Station Township",
      id: 15177,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Tensa",
      id: 15208,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Udala",
      id: 15319,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Umarkote",
      id: 15335,
      state_id: 10021,
    },
    {
      type: "city",
      label: "Karaikal",
      id: 10415,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Mahe",
      id: 10809,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Pondicherry",
      id: 10115,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Yanam",
      id: 10598,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Puducherry",
      id: 11503,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Kurumbapet",
      id: 15531,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Ozhukarai",
      id: 15537,
      state_id: 10024,
    },
    {
      type: "city",
      label: "Amritsar",
      id: 10070,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Barnala",
      id: 10315,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Batala",
      id: 10249,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bathinda",
      id: 10161,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dhuri",
      id: 10601,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Faridkot",
      id: 10419,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Fazilka",
      id: 10448,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Firozpur",
      id: 10334,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Firozpur Cantt.",
      id: 10621,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Gobindgarh",
      id: 10467,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Gurdaspur",
      id: 10453,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Hoshiarpur",
      id: 10235,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jagraon",
      id: 10519,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jalandhar",
      id: 10087,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jalandhar Cantt.",
      id: 10679,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kapurthala",
      id: 10361,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Khanna",
      id: 10290,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kharar",
      id: 10457,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kot Kapura",
      id: 10393,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Longowal",
      id: 11091,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ludhiana",
      id: 10056,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Malerkotla",
      id: 10286,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Malout",
      id: 10483,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Mansa",
      id: 10469,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Moga",
      id: 10262,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Mohali",
      id: 10301,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Morinda, India",
      id: 11134,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Mukerian",
      id: 11180,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Muktsar",
      id: 10426,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Nabha",
      id: 10495,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Nakodar",
      id: 10806,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Nangal",
      id: 10756,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Nawanshahr",
      id: 10698,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Pathankot",
      id: 10234,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Patiala",
      id: 10062,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Patti",
      id: 10847,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Pattran",
      id: 11151,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Phagwara",
      id: 10358,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Phillaur",
      id: 11147,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Qadian",
      id: 11162,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Raikot",
      id: 11069,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rajpura",
      id: 10427,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rampura Phul",
      id: 10712,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rupnagar",
      id: 10667,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Samana",
      id: 10692,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sangrur",
      id: 10446,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sirhind Fatehgarh Sahib",
      id: 10658,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sujanpur",
      id: 11168,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sunam",
      id: 10590,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Talwara",
      id: 11229,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Tarn Taran",
      id: 10505,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Urmar Tanda",
      id: 11104,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Zira",
      id: 10814,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Zirakpur",
      id: 10381,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ferozepur",
      id: 11287,
      state_id: 10014,
    },
    {
      type: "city",
      label: "S.A.S Nagar",
      id: 11331,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Shahid Bhagat Singh Nagar",
      id: 11332,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Fatehgarh Sahib",
      id: 11375,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sri Muktsar Sahib",
      id: 11520,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Abohar",
      id: 11711,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Adampur",
      id: 11720,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ahmedgarh",
      id: 11737,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ajnala",
      id: 11745,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Akalgarh",
      id: 11747,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Alawalpur",
      id: 11771,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Amloh",
      id: 11824,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Amritsar Cantt.",
      id: 11831,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Anandpur Sahib",
      id: 11839,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Badhni Kalan",
      id: 11983,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bagha Purana",
      id: 12001,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Balachaur",
      id: 12034,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Banaur",
      id: 12067,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Banga",
      id: 12076,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Baretta",
      id: 12120,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bariwala",
      id: 12133,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bassi Pathana",
      id: 12163,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Begowal",
      id: 12180,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhabat",
      id: 12220,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhadaur",
      id: 12224,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhankharpur",
      id: 12246,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bharoli Kalan",
      id: 12254,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhawanigarh",
      id: 12272,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhikhi",
      id: 12277,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhikhiwind",
      id: 12278,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhisiana",
      id: 12287,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhogpur",
      id: 12292,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhucho Mandi",
      id: 12304,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Bhulath",
      id: 12305,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Budha Theh",
      id: 12407,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Budhlada",
      id: 12410,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Cheema",
      id: 12511,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Chohal",
      id: 12603,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Daroha",
      id: 12672,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dasua",
      id: 12678,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Daulatpur",
      id: 12682,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dera Baba Nanak",
      id: 12712,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dera Bassi",
      id: 12713,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dhanaula",
      id: 12749,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dharamkot",
      id: 12760,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dhariwal",
      id: 12771,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dhilwan",
      id: 12786,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dina Nagar",
      id: 12813,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Dirba",
      id: 12819,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Fatehgarh Churian",
      id: 12913,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Fiozpur",
      id: 12922,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Gardhiwala",
      id: 12973,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Garhshanker",
      id: 12978,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ghagga",
      id: 12993,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ghanaur",
      id: 12994,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Gidderbaha",
      id: 13025,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Goniana",
      id: 13053,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Goraya",
      id: 13063,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Guru Har Sahai",
      id: 13104,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Hajipur",
      id: 13114,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Handiaya",
      id: 13126,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Hariana",
      id: 13135,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Hussainpur",
      id: 13212,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jaitu",
      id: 13283,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jalalabad",
      id: 13289,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jandiala",
      id: 13313,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Jugial",
      id: 13396,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kalanaur",
      id: 13448,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Karoran",
      id: 13588,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kartarpur",
      id: 13590,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Khamanon",
      id: 13679,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Khanauri",
      id: 13687,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Khem Karan",
      id: 13729,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kot Fatta",
      id: 13840,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Kurali",
      id: 13924,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Lehragaga",
      id: 13983,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Lodhian Khas",
      id: 13994,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Machhiwara",
      id: 14006,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Mahilpur",
      id: 14037,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Majitha",
      id: 14060,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Makhu",
      id: 14063,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Maloud",
      id: 14080,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Maur",
      id: 14154,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Moonak",
      id: 14224,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Morinda",
      id: 14232,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Mullanpur Dakha",
      id: 14262,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Mullanpur- Garibdas",
      id: 14263,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Nehon",
      id: 14405,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Noor Mahal",
      id: 14449,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Payal",
      id: 14624,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rahon",
      id: 14760,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rajasansi",
      id: 14770,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Raman",
      id: 14785,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ramdass",
      id: 14793,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rayya",
      id: 14835,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Rurki Kasba",
      id: 14863,
      state_id: 10014,
    },
    {
      type: "city",
      label: "S.A.S. Nagar (Mohali)",
      id: 14866,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sahnewal",
      id: 14887,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Samrala",
      id: 14911,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sanaur",
      id: 14913,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sangat",
      id: 14919,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sansarpur",
      id: 14933,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sardulgarh",
      id: 14950,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Shahkot",
      id: 15015,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Shamchaurasi",
      id: 15022,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Shekhpura",
      id: 15026,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sirhind -Fategarh",
      id: 15089,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sri Hargobindpur",
      id: 15123,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Sultanpur Lodhi",
      id: 15149,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Talwandi Bhai",
      id: 15183,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Tappa",
      id: 15191,
      state_id: 10014,
    },
    {
      type: "city",
      label: "Ajmer",
      id: 10109,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Alwar",
      id: 10147,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Barmer",
      id: 10211,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bharatpur",
      id: 10176,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhilwara",
      id: 10137,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bikaner",
      id: 10098,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jaipur",
      id: 10044,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jodhpur",
      id: 10069,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kota",
      id: 11255,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Lachhmangarh",
      id: 10618,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ladnu",
      id: 10514,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Lakheri",
      id: 10953,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Lalsot",
      id: 10849,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Losal",
      id: 10971,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Makrana",
      id: 10394,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Malpura",
      id: 11006,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mandalgarh",
      id: 11222,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mandawa",
      id: 11203,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mangrol",
      id: 11166,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Merta City",
      id: 10768,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mount Abu",
      id: 11152,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nadbai",
      id: 11027,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nagar",
      id: 11047,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nagaur",
      id: 10366,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nasirabad",
      id: 10642,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nathdwara",
      id: 10745,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Neem-Ka-Thana",
      id: 10821,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nimbahera",
      id: 10539,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nohar",
      id: 10656,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nokha",
      id: 10531,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pali",
      id: 10182,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Phalodi",
      id: 10710,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Phulera",
      id: 11172,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pilani",
      id: 10763,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pilibanga",
      id: 10870,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pindwara",
      id: 11206,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pipar City",
      id: 10886,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Prantij",
      id: 11149,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pratapgarh",
      id: 10836,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Raisinghnagar",
      id: 10996,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rajakhera",
      id: 10976,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rajaldesar",
      id: 11127,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rajgarh (Alwar)",
      id: 11064,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rajgarh (Churu)",
      id: 10636,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rajsamand",
      id: 10597,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ramganj Mandi",
      id: 10930,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ramngarh",
      id: 10973,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ratangarh",
      id: 10526,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rawatbhata",
      id: 10843,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rawatsar",
      id: 10975,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Reengus",
      id: 11123,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sadri",
      id: 11076,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sadulpur",
      id: 10302,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sadulshahar",
      id: 11146,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sagwara",
      id: 10929,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sambhar",
      id: 11148,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sanchore",
      id: 11042,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sangaria",
      id: 10844,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sardarshahar",
      id: 10431,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sawai Madhopur",
      id: 10360,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Shahpura",
      id: 10981,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sheoganj",
      id: 11068,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sikar",
      id: 10215,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sirohi",
      id: 10833,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sojat",
      id: 10780,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sri Madhopur",
      id: 10972,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sujangarh",
      id: 10424,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sumerpur",
      id: 10920,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Suratgarh",
      id: 10571,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Takhatgarh",
      id: 11233,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Taranagar",
      id: 10889,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Todabhim",
      id: 11120,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Todaraisingh",
      id: 11101,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Tonk",
      id: 10239,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Udaipur",
      id: 10104,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Udaipurwati",
      id: 10962,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Vijainagar, Ajmer",
      id: 10911,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dudu",
      id: 11285,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jalore",
      id: 11298,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jhalawar",
      id: 11300,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Karauli",
      id: 11303,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bundi",
      id: 11364,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dholpur",
      id: 11373,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jodhpur (Gramin)",
      id: 11389,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Khairthal-Tijara",
      id: 11396,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Anupgarh",
      id: 11432,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Didwana-Kuchaman",
      id: 11447,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dungarpur",
      id: 11450,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Gangapurcity",
      id: 11457,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Hanumangarh",
      id: 11461,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kotputli-Behror",
      id: 11479,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Salumbar",
      id: 11510,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Balotra",
      id: 11534,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Banswara",
      id: 11536,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Baran",
      id: 11537,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Beawar",
      id: 11539,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chittorgarh",
      id: 11546,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Churu",
      id: 11548,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jhunjhunu",
      id: 11568,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Neem Ka Thana",
      id: 11592,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dausa",
      id: 11640,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Deeg",
      id: 11641,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ganganagar",
      id: 11648,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jaipur (Gramin)",
      id: 11655,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jaisalmer",
      id: 11656,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kekri",
      id: 11664,
      state_id: 10009,
    },
    {
      type: "city",
      label: "1 SGM",
      id: 11701,
      state_id: 10009,
    },
    {
      type: "city",
      label: "3 STR",
      id: 11702,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Abu Road",
      id: 11713,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Aklera",
      id: 11755,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Amet",
      id: 11814,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Antah",
      id: 11863,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Asind",
      id: 11909,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Baggar",
      id: 11999,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bagru",
      id: 12005,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bakani",
      id: 12029,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bali",
      id: 12046,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bandikui",
      id: 12073,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bari",
      id: 12127,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bari Sadri",
      id: 12129,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Basni Belima",
      id: 12161,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bayana",
      id: 12174,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Beejoliya Kalan",
      id: 12176,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Begun",
      id: 12183,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Behat",
      id: 12184,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Behror",
      id: 12186,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhadra",
      id: 12226,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhalariya",
      id: 12237,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhawani Mandi",
      id: 12271,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhinder",
      id: 12283,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhinmal",
      id: 12286,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhiwadi",
      id: 12289,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bhusawar",
      id: 12311,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bidasar",
      id: 12317,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bilara",
      id: 12335,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Bissau",
      id: 12375,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Budhpura",
      id: 12412,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chaksu",
      id: 12450,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chechat",
      id: 12509,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chhabra",
      id: 12533,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chhapar",
      id: 12535,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chhipabarod",
      id: 12548,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chhoti Sadri",
      id: 12554,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chirawa",
      id: 12590,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chittaurgarh",
      id: 12601,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Chomu",
      id: 12605,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dariba",
      id: 12669,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Deoli",
      id: 12705,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Deshnoke",
      id: 12718,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Devgarh",
      id: 12732,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dhariawad",
      id: 12770,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dhaulpur",
      id: 12781,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Didwana",
      id: 12800,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Dungargarh",
      id: 12853,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Fatehnagar",
      id: 12914,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Fatehpur",
      id: 12915,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Gajsinghpur",
      id: 12943,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Galiakot",
      id: 12947,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Gangapur",
      id: 12961,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Gangapur City",
      id: 12963,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Goredi Chancha",
      id: 13064,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Gothra",
      id: 13070,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Govindgarh",
      id: 13074,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Gulabpura",
      id: 13086,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Hindaun",
      id: 13176,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Indragarh",
      id: 13238,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jahazpur",
      id: 13275,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jaitaran",
      id: 13280,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jalor",
      id: 13299,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jhalrapatan",
      id: 13355,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jhunjhunun",
      id: 13368,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Jobner",
      id: 13378,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kaithoon",
      id: 13430,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kaman",
      id: 13483,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kanor",
      id: 13541,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kapasan",
      id: 13553,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kaprain",
      id: 13556,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Karanpur",
      id: 13568,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Keshoraipatan",
      id: 13657,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kesrisinghpur",
      id: 13659,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Khairthal",
      id: 13671,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Khandela",
      id: 13690,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kherli",
      id: 13734,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kherliganj",
      id: 13735,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kherwara Chhaoni",
      id: 13736,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Khetri",
      id: 13739,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kiranipura",
      id: 13768,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kishangarh",
      id: 13775,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kishangarh Renwal",
      id: 13776,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kolvi Mandi Rajendra pura",
      id: 13807,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kotputli",
      id: 13856,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kuchaman City",
      id: 13880,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kuchera",
      id: 13882,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kumbhkot",
      id: 13904,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kumher",
      id: 13908,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Kushalgarh",
      id: 13942,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mahu Kalan",
      id: 14043,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mahwa",
      id: 14049,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mandawar",
      id: 14101,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Manohar Thana",
      id: 14122,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Marwar Junction",
      id: 14143,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Modak",
      id: 14205,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mukandgarh",
      id: 14252,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Mundwa",
      id: 14271,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nainwa",
      id: 14326,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nawa",
      id: 14396,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Nawalgarh",
      id: 14397,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Newa Talai",
      id: 14423,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Niwai",
      id: 14440,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Padampur",
      id: 14498,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Parbatsar",
      id: 14584,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Partapur",
      id: 14593,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Phalna",
      id: 14659,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Piparcity",
      id: 14673,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pirawa",
      id: 14680,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pokaran",
      id: 14684,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Pushkar",
      id: 14732,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rajgarh",
      id: 14773,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ramgarh",
      id: 14796,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rani",
      id: 14815,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Ratannagar",
      id: 14826,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Rikhabdeo",
      id: 14847,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sangod",
      id: 14921,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sarwar",
      id: 14962,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Satalkheri",
      id: 14967,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sogariya",
      id: 15107,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Sojat Road",
      id: 15108,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Suket",
      id: 15141,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Surajgarh",
      id: 15157,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Tijara",
      id: 15280,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Todra",
      id: 15303,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Udpura",
      id: 15323,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Uniara",
      id: 15349,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Vanasthali",
      id: 15402,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Vidyavihar",
      id: 15458,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Vijainagar",
      id: 15460,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Viratnagar",
      id: 15477,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Weir",
      id: 15496,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Shahpura (2)",
      id: 10994,
      state_id: 10009,
    },
    {
      type: "city",
      label: "Arakkonam",
      id: 10444,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aruppukkottai",
      id: 10409,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chennai",
      id: 10041,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Coimbatore",
      id: 10073,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Erode",
      id: 10248,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gobichettipalayam",
      id: 10558,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kancheepuram",
      id: 10241,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karur",
      id: 10477,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Lalgudi",
      id: 11093,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madurai",
      id: 10077,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manachanallur",
      id: 11040,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nagapattinam",
      id: 10354,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nagercoil",
      id: 10188,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Namagiripettai",
      id: 11184,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Namakkal",
      id: 10602,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nandivaram-Guduvancheri",
      id: 10721,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nanjikottai",
      id: 10888,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Natham",
      id: 11096,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nellikuppam",
      id: 10691,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neyveli (TS)",
      id: 10349,
      state_id: 10007,
    },
    {
      type: "city",
      label: "O' Valley",
      id: 11159,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Oddanchatram",
      id: 10942,
      state_id: 10007,
    },
    {
      type: "city",
      label: "P.N.Patti",
      id: 11107,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pacode",
      id: 11130,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Padmanabhapuram",
      id: 11225,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palani",
      id: 10501,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palladam",
      id: 10943,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallapatti",
      id: 11079,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallikonda",
      id: 11205,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Panagudi",
      id: 11051,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Panruti",
      id: 10600,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Paramakudi",
      id: 10422,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Parangipettai",
      id: 11197,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pattukkottai",
      id: 10515,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perambalur",
      id: 10798,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Peravurani",
      id: 11191,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Periyakulam",
      id: 10746,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Periyasemur",
      id: 10912,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pernampattu",
      id: 10752,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pollachi",
      id: 10289,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Polur",
      id: 11050,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ponneri",
      id: 11082,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudukkottai",
      id: 10339,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudupattinam",
      id: 11198,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puliyankudi",
      id: 10878,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Punjaipugalur",
      id: 11216,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rajapalayam",
      id: 10303,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ramanathapuram",
      id: 10534,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rameshwaram",
      id: 10790,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ranipet",
      id: 10170,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rasipuram",
      id: 10695,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Salem",
      id: 10090,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sankarankovil",
      id: 10484,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sankari",
      id: 11005,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sathyamangalam",
      id: 10869,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sattur",
      id: 10921,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Shenkottai",
      id: 11015,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sholavandan",
      id: 11174,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sholingur",
      id: 11023,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sirkali",
      id: 10906,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sivaganga",
      id: 10769,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sivagiri",
      id: 11214,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sivakasi",
      id: 10306,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Srivilliputhur",
      id: 10466,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Surandai",
      id: 10982,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Suriyampalayam",
      id: 11161,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tenkasi",
      id: 10485,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thammampatti",
      id: 11177,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thanjavur",
      id: 10189,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tharamangalam",
      id: 10937,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tharangambadi",
      id: 11114,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Theni Allinagaram",
      id: 10388,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirumangalam",
      id: 10640,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirupuvanam",
      id: 11234,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruthuraipoondi",
      id: 11077,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvallur",
      id: 10592,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvarur",
      id: 10568,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thuraiyur",
      id: 10895,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tindivanam",
      id: 10468,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruchendur",
      id: 10908,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruchengode",
      id: 10383,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruchirappalli",
      id: 10088,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tirukalukundram",
      id: 10957,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tirukkoyilur",
      id: 10938,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tirunelveli",
      id: 10121,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tirupathur",
      id: 10524,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruppur",
      id: 10124,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruttani",
      id: 10711,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruvannamalai",
      id: 10273,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruvethipuram",
      id: 10794,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tittakudi",
      id: 11125,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Udhagamandalam",
      id: 10406,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Udumalaipettai",
      id: 10547,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Unnamalaikadai",
      id: 11097,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Usilampatti",
      id: 10838,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uthamapalayam",
      id: 10965,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uthiramerur",
      id: 11058,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadakkuvalliyur",
      id: 10956,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadalur",
      id: 10774,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadipatti",
      id: 11017,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Valparai",
      id: 10478,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vandavasi",
      id: 10924,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vaniyambadi",
      id: 10386,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vedaranyam",
      id: 10851,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vellakoil",
      id: 10767,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vellore",
      id: 10216,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vikramasingapuram",
      id: 10687,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Viluppuram",
      id: 10379,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Virudhachalam",
      id: 10463,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Virudhunagar",
      id: 10474,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Viswanatham",
      id: 11049,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Theni",
      id: 11340,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dharmapuri",
      id: 11371,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kallakurichi",
      id: 11392,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mayiladuthurai",
      id: 11403,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thoothukkudi",
      id: 11424,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dindigul",
      id: 11448,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ariyalur",
      id: 11531,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Krishnagiri",
      id: 11582,
      state_id: 10007,
    },
    {
      type: "city",
      label: "The Nilgiris",
      id: 11613,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chengalpattu",
      id: 11633,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Cuddalore",
      id: 11638,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kanniyakumari",
      id: 11662,
      state_id: 10007,
    },
    {
      type: "city",
      label: "A.Thirumuruganpoondi",
      id: 11703,
      state_id: 10007,
    },
    {
      type: "city",
      label: "A.Vellalapatti",
      id: 11704,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Abiramam",
      id: 11710,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Achampudur",
      id: 11715,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Acharapakkam",
      id: 11716,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Acharipallam",
      id: 11717,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Achipatti",
      id: 11719,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Adikaratti",
      id: 11722,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Adiramapattinam",
      id: 11724,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aduthurai alias Maruthuvakudi",
      id: 11726,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Agaram",
      id: 11729,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Agastheeswaram",
      id: 11731,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alagappapuram",
      id: 11758,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alampalayam",
      id: 11759,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alandur",
      id: 11763,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alanganallur",
      id: 11765,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alangayam",
      id: 11766,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alangudi",
      id: 11767,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alangulam",
      id: 11768,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alanthurai",
      id: 11769,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alapakkam",
      id: 11770,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Allapuram",
      id: 11779,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alur",
      id: 11785,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alwarkurichi",
      id: 11788,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Alwarthirunagiri",
      id: 11789,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ambasamudram",
      id: 11806,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ambattur",
      id: 11808,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ambur",
      id: 11813,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ammainaickanur",
      id: 11825,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ammapettai",
      id: 11826,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ammavarikuppam",
      id: 11827,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ammoor",
      id: 11828,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Anaimalai",
      id: 11833,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Anaiyur",
      id: 11834,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Anakaputhur",
      id: 11835,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ananthapuram",
      id: 11840,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Andipalayam",
      id: 11843,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Andipatti Jakkampatti",
      id: 11844,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Anjugramam",
      id: 11851,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Annamalai Nagar",
      id: 11858,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Annavasal",
      id: 11859,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Annur",
      id: 11861,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Anthiyur",
      id: 11865,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Appakudal",
      id: 11870,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arachalur",
      id: 11873,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arakandanallur",
      id: 11874,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arakonam",
      id: 11875,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aralvaimozhi",
      id: 11876,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arani",
      id: 11879,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aranthangi",
      id: 11880,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arasiramani",
      id: 11881,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aravakurichi",
      id: 11882,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aravankad",
      id: 11883,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arcot",
      id: 11884,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arimalam",
      id: 11887,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ariyappampalayam",
      id: 11888,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ariyur",
      id: 11889,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arumanai",
      id: 11898,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arumbavur",
      id: 11899,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Arumuganeri",
      id: 11900,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ashokapuram",
      id: 11902,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Athani",
      id: 11916,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Athanur",
      id: 11917,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Athimarapatti",
      id: 11918,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Athipattu",
      id: 11919,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Athur",
      id: 11921,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Attayampatti",
      id: 11924,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Attur",
      id: 11925,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Avadattur",
      id: 11933,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Avadi",
      id: 11934,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Avalpoondurai",
      id: 11935,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Avanashi",
      id: 11936,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Avaniapuram",
      id: 11937,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ayakudi",
      id: 11941,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Aygudi",
      id: 11942,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ayothiapattinam",
      id: 11943,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ayyalur",
      id: 11944,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ayyampalayam",
      id: 11945,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ayyampettai",
      id: 11946,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Azhagiapandiapuram",
      id: 11947,
      state_id: 10007,
    },
    {
      type: "city",
      label: "B. Mallapuram",
      id: 11952,
      state_id: 10007,
    },
    {
      type: "city",
      label: "B. Meenakshipuram",
      id: 11953,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Balakrishnampatti",
      id: 12036,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Balakrishnapuram",
      id: 12037,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Balapallam",
      id: 12038,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Balasamudram",
      id: 12042,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Bargur",
      id: 12122,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Batlagundu",
      id: 12167,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Belur",
      id: 12203,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Bhavani",
      id: 12267,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Bhavanisagar",
      id: 12268,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Bhuvanagiri",
      id: 12312,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Bikketti",
      id: 12332,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Bodinayakkanur",
      id: 12383,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Boothapandi",
      id: 12395,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Boothipuram",
      id: 12396,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Brahmana Periya-Agraharam",
      id: 12403,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chengam",
      id: 12518,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chennasamudram",
      id: 12521,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chennimalai",
      id: 12522,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Cheranmadevi",
      id: 12524,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chetpet",
      id: 12528,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chettiarpatti",
      id: 12529,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chettipalayam",
      id: 12530,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chettithangal",
      id: 12531,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chidambaram",
      id: 12560,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinna Anuppanadi",
      id: 12577,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnakkampalayam",
      id: 12579,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnalapatti",
      id: 12580,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnamanur",
      id: 12581,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnampalayam",
      id: 12582,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnasalem",
      id: 12583,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnasekkadu",
      id: 12584,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chinnavedampatti",
      id: 12585,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chithode",
      id: 12596,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Chitlapakkam",
      id: 12597,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Cholapuram",
      id: 12604,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Coonoor",
      id: 12627,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Courtalam",
      id: 12629,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dalavaipatti",
      id: 12649,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Denkanikottai",
      id: 12698,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Desur",
      id: 12719,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Devadanapatti",
      id: 12723,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Devakottai",
      id: 12725,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Devanangurichi",
      id: 12726,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Devarshola",
      id: 12729,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dhalavoipuram",
      id: 12739,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dhali",
      id: 12740,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dhaliyur",
      id: 12741,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dharapadavedu",
      id: 12764,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dharapuram",
      id: 12766,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dharasuram",
      id: 12767,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Dusi",
      id: 12860,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Edaganasalai",
      id: 12864,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Edaikodu",
      id: 12865,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Edakalinadu",
      id: 12866,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Edappadi",
      id: 12867,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Elathur",
      id: 12876,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Elayirampannai",
      id: 12878,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Elumalai",
      id: 12881,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Eral",
      id: 12882,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Eraniel",
      id: 12885,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Eriodu",
      id: 12888,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Erumaipatti",
      id: 12889,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Eruvadi",
      id: 12890,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ethapur",
      id: 12891,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ettayapuram",
      id: 12893,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ettimadai",
      id: 12894,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ezhudesam",
      id: 12895,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ganapathipuram",
      id: 12948,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gandhi Nagar(Katpadi Ext.)",
      id: 12952,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gangaikondan",
      id: 12958,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gangavalli",
      id: 12964,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ganguvarpatti",
      id: 12968,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gingee",
      id: 13027,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gopalasamudram",
      id: 13055,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Goundampalayam",
      id: 13072,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gudalur",
      id: 13080,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gudiyatham",
      id: 13083,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Gummidipoondi",
      id: 13094,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Hanumanthampatti",
      id: 13130,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Harur",
      id: 13146,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Harveypatti",
      id: 13147,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Highways",
      id: 13171,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Hosur",
      id: 13201,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Hubbathala",
      id: 13204,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Huligal",
      id: 13206,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Idikarai",
      id: 13221,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ilampillai",
      id: 13227,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ilanji",
      id: 13228,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Iluppaiyurani",
      id: 13231,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Iluppur",
      id: 13232,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Inam Karur",
      id: 13233,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Injambakkam",
      id: 13241,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Irugur",
      id: 13245,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jaffrabad",
      id: 13259,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jagathala",
      id: 13265,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jalakandapuram",
      id: 13287,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jalladiampet",
      id: 13297,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jambai",
      id: 13303,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jayankondam",
      id: 13337,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Jolarpet",
      id: 13385,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kadambur",
      id: 13412,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kadathur",
      id: 13413,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kadayal",
      id: 13415,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kadayampatti",
      id: 13416,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kadayanallur",
      id: 13417,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalakkad",
      id: 13440,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalambur",
      id: 13444,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalapatti",
      id: 13450,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalappanaickenpatti",
      id: 13451,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalavai",
      id: 13454,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalinjur",
      id: 13462,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kaliyakkavilai",
      id: 13463,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalladaikurichi",
      id: 13465,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kallakkurichi",
      id: 13466,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kallakudi",
      id: 13467,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kallukuttam",
      id: 13469,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kalugumalai",
      id: 13475,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kamayagoundanpatti",
      id: 13486,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kambainallur",
      id: 13487,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kambam",
      id: 13488,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kamuthi",
      id: 13493,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kanadukathan",
      id: 13495,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kanakkampalayam",
      id: 13498,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kanam",
      id: 13500,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kandanur",
      id: 13504,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kangayampalayam",
      id: 13513,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kangeyam",
      id: 13514,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kangeyanallur",
      id: 13515,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kaniyur",
      id: 13521,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kanjikoil",
      id: 13524,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kannadendal",
      id: 13530,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kannamangalam",
      id: 13532,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kannampalayam",
      id: 13533,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kannankurichi",
      id: 13534,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kannivadi",
      id: 13536,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kappiyarai",
      id: 13554,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karaikkudi",
      id: 13560,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karamadai",
      id: 13561,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karambakkam",
      id: 13562,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karambakkudi",
      id: 13563,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kariamangalam",
      id: 13577,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kariapatti",
      id: 13578,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karugampattur",
      id: 13591,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karumandi Chellipalayam",
      id: 13592,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karumathampatti",
      id: 13593,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karungal",
      id: 13594,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karunguzhi",
      id: 13595,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Karuppur",
      id: 13596,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kasipalayam (E)",
      id: 13605,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kasipalayam (G)",
      id: 13606,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kathujuganapalli",
      id: 13615,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Katpadi",
      id: 13618,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kattivakkam",
      id: 13624,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kattumannarkoil",
      id: 13625,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kattuputhur",
      id: 13626,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kaveripakkam",
      id: 13630,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kaveripattinam",
      id: 13631,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kayalpattinam",
      id: 13634,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kayatharu",
      id: 13635,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Keelakarai",
      id: 13638,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Keeramangalam",
      id: 13639,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Keeranur",
      id: 13640,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Keeripatti",
      id: 13641,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Keezhapavur",
      id: 13642,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kelamangalam",
      id: 13645,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kembainaickenpalayam",
      id: 13647,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kethi",
      id: 13660,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kilampadi",
      id: 13758,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kilkulam",
      id: 13759,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kilkunda",
      id: 13760,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Killiyur",
      id: 13761,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Killlai",
      id: 13762,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kilpennathur",
      id: 13763,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kilvelur",
      id: 13764,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kinathukadavu",
      id: 13765,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kodaikanal",
      id: 13784,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kodavasal",
      id: 13788,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kodumudi",
      id: 13793,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kolachal",
      id: 13797,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kolappalur",
      id: 13799,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kolathupalayam",
      id: 13801,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kolathur",
      id: 13802,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kollankodu",
      id: 13804,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kollankoil",
      id: 13805,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Komaralingam",
      id: 13809,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kombai",
      id: 13810,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Konavattam",
      id: 13815,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kondalampatti",
      id: 13817,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Konganapuram",
      id: 13820,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kooraikundu",
      id: 13823,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Koothappar",
      id: 13824,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Koradacheri",
      id: 13831,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kotagiri",
      id: 13843,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kothinallur",
      id: 13851,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kottaiyur",
      id: 13858,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kottakuppam",
      id: 13859,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kottaram",
      id: 13860,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kottivakkam",
      id: 13862,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kottur",
      id: 13863,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kouthanallur",
      id: 13867,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kovilpatti",
      id: 13868,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Krishnarayapuram",
      id: 13876,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Krishnasamudram",
      id: 13877,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kuchanur",
      id: 13881,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kuhalur",
      id: 13889,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kulasekarapuram",
      id: 13895,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kulithalai",
      id: 13897,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kumarapalayam",
      id: 13900,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kumarapuram",
      id: 13901,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kumbakonam",
      id: 13903,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kundrathur",
      id: 13915,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kuniyamuthur",
      id: 13917,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kunnathur",
      id: 13919,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kurichi",
      id: 13930,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kurinjipadi",
      id: 13931,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kurudampalayam",
      id: 13937,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kurumbalur",
      id: 13938,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kuthalam",
      id: 13947,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Kuzhithurai",
      id: 13949,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Labbaikudikadu",
      id: 13954,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Lakkampatti",
      id: 13961,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Lalpet",
      id: 13965,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Llayangudi",
      id: 13993,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madambakkam",
      id: 14008,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madathukulam",
      id: 14012,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madavaram",
      id: 14013,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madippakkam",
      id: 14019,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madukkarai",
      id: 14020,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Madukkur",
      id: 14021,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Maduranthakam",
      id: 14022,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Maduravoyal",
      id: 14023,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mallamooppampatti",
      id: 14074,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mallankinaru",
      id: 14075,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mallasamudram",
      id: 14077,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mallur",
      id: 14079,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mamallapuram",
      id: 14083,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mamsapuram",
      id: 14084,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manali",
      id: 14086,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manalmedu",
      id: 14087,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manalurpet",
      id: 14088,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manamadurai",
      id: 14089,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manapakkam",
      id: 14090,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manapparai",
      id: 14091,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manavalakurichi",
      id: 14092,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mandaikadu",
      id: 14095,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mandapam",
      id: 14097,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mangadu",
      id: 14104,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mangalam",
      id: 14106,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mangalampet",
      id: 14107,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Manimutharu",
      id: 14115,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mannargudi",
      id: 14121,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mappilaiurani",
      id: 14129,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Maraimalainagar",
      id: 14131,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Marakkanam",
      id: 14132,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Maramangalathupatti",
      id: 14133,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Marandahalli",
      id: 14134,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Markayankottai",
      id: 14138,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Marudur",
      id: 14141,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Marungur",
      id: 14142,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mathigiri",
      id: 14148,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mecheri",
      id: 14160,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Meenambakkam",
      id: 14162,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melacheval",
      id: 14174,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melachokkanathapuram",
      id: 14175,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melagaram",
      id: 14176,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melamadai",
      id: 14177,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melamaiyur",
      id: 14178,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melathiruppanthuruthi",
      id: 14179,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melattur",
      id: 14180,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melpattampakkam",
      id: 14181,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melur",
      id: 14182,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Melvisharam",
      id: 14183,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mettupalayam",
      id: 14189,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mettur",
      id: 14190,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Minjur",
      id: 14195,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Modakurichi",
      id: 14206,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mohanur",
      id: 14214,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Moolakaraipatti",
      id: 14223,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Moovarasampettai",
      id: 14225,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mopperipalayam",
      id: 14226,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mudukulathur",
      id: 14245,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mukasipidariyur",
      id: 14253,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mukkudal",
      id: 14255,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mulagumudu",
      id: 14257,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Mulanur",
      id: 14258,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Muruganpalayam",
      id: 14284,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Musiri",
      id: 14287,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Muthupet",
      id: 14291,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Muthur",
      id: 14292,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Muttayyapuram",
      id: 14293,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Myladi",
      id: 14295,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Naduvattam",
      id: 14307,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nagavakulam",
      id: 14313,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nagojanahalli",
      id: 14315,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nallampatti",
      id: 14334,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nallur",
      id: 14335,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nambiyur",
      id: 14336,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nandambakkam",
      id: 14344,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nangavalli",
      id: 14351,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nangavaram",
      id: 14352,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nanguneri",
      id: 14354,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nannilam",
      id: 14355,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Naranammalpuram",
      id: 14359,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Naranapuram",
      id: 14360,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Narasimhanaickenpalayam",
      id: 14361,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Narasingapuram",
      id: 14363,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Naravarikuppam",
      id: 14366,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nasiyanur",
      id: 14378,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nathampannai",
      id: 14382,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Natrampalli",
      id: 14384,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nattapettai",
      id: 14385,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nattarasankottai",
      id: 14386,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Navalpattu",
      id: 14391,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nazerath",
      id: 14399,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Needamangalam",
      id: 14402,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neelagiri",
      id: 14403,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neelankarai",
      id: 14404,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neikkarapatti",
      id: 14406,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neiyyur",
      id: 14407,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nelliyalam",
      id: 14409,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nemili",
      id: 14411,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neripperichal",
      id: 14414,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nerkunram",
      id: 14415,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nerkuppai",
      id: 14416,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nerunjipettai",
      id: 14417,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neykkarappatti",
      id: 14424,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Neyveli",
      id: 14425,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Nilakkottai",
      id: 14430,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Odaipatti",
      id: 14465,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Odaiyakulam",
      id: 14466,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Odugathur",
      id: 14468,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Oggiyamduraipakkam",
      id: 14470,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Olagadam",
      id: 14474,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Omalur",
      id: 14477,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Orathanadu (Mukthambalpuram)",
      id: 14483,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Othakadai",
      id: 14488,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Othakalmandapam",
      id: 14489,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ottapparai",
      id: 14490,
      state_id: 10007,
    },
    {
      type: "city",
      label: "P. J. Cholapuram",
      id: 14491,
      state_id: 10007,
    },
    {
      type: "city",
      label: "P.Mettupalayam",
      id: 14492,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Padaiveedu",
      id: 14497,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Padianallur",
      id: 14500,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Padirikuppam",
      id: 14501,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palaganangudy",
      id: 14510,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palakkodu",
      id: 14511,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palamedu",
      id: 14513,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palani Chettipatti",
      id: 14514,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palavakkam",
      id: 14518,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palavansathu",
      id: 14519,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Palayam",
      id: 14522,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallapalayam",
      id: 14530,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallathur",
      id: 14531,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallavaram",
      id: 14532,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallikaranai",
      id: 14533,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallipalayam",
      id: 14535,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallipalayam Agraharam",
      id: 14536,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pallipattu",
      id: 14537,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pammal",
      id: 14540,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Panaimarathupatti",
      id: 14543,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Panapakkam",
      id: 14544,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Panboli",
      id: 14546,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pandamangalam",
      id: 14551,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pannaikadu",
      id: 14563,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pannaipuram",
      id: 14564,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Papanasam",
      id: 14572,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pappankurichi",
      id: 14573,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Papparapatti",
      id: 14574,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pappireddipatti",
      id: 14575,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Paramathi",
      id: 14577,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Paravai",
      id: 14582,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pasur",
      id: 14598,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pathamadai",
      id: 14606,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pattinam",
      id: 14617,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pattiveeranpatti",
      id: 14619,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pazhugal",
      id: 14626,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Peerkankaranai",
      id: 14627,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pennadam",
      id: 14631,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pennagaram",
      id: 14632,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pennathur",
      id: 14633,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Peraiyur",
      id: 14634,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Peralam",
      id: 14636,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Peranamallur",
      id: 14638,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Periya Negamam",
      id: 14639,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Periyakodiveri",
      id: 14640,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Periyanaickenpalayam",
      id: 14641,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Periyapatti",
      id: 14642,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perumagalur",
      id: 14644,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perumandi",
      id: 14645,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perumuchi",
      id: 14647,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perundurai",
      id: 14648,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perungalathur",
      id: 14649,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perungudi",
      id: 14650,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perungulam",
      id: 14651,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Perur",
      id: 14652,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pethampalayam",
      id: 14654,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pethanaickenpalayam",
      id: 14655,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pillanallur",
      id: 14668,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Polichalur",
      id: 14688,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ponmani",
      id: 14691,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ponnamaravathi",
      id: 14692,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ponnampatti",
      id: 14693,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Poolambadi",
      id: 14694,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Poolampatti",
      id: 14695,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pooluvapatti",
      id: 14696,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Poonamallee",
      id: 14697,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Porur",
      id: 14701,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pothanur",
      id: 14702,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pothatturpettai",
      id: 14703,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudukadai",
      id: 14711,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudupalaiyam Aghraharam",
      id: 14712,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudupalayam",
      id: 14713,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudupatti",
      id: 14714,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pudur (S)",
      id: 14715,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puduvayal",
      id: 14716,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puliyur",
      id: 14719,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Pullampadi",
      id: 14720,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Punjai Thottakurichi",
      id: 14723,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Punjaipuliampatti",
      id: 14724,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puthalam",
      id: 14733,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puvalur",
      id: 14736,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puzhal",
      id: 14737,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Puzhithivakkam (Ullagaram)",
      id: 14739,
      state_id: 10007,
    },
    {
      type: "city",
      label: "R.Pudupatti",
      id: 14748,
      state_id: 10007,
    },
    {
      type: "city",
      label: "R.S.Mangalam",
      id: 14749,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ramapuram",
      id: 14789,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rameswaram",
      id: 14795,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ranipettai",
      id: 14819,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rayagiri",
      id: 14833,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Reethapuram",
      id: 14837,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rosalpatti",
      id: 14856,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Rudravathi",
      id: 14859,
      state_id: 10007,
    },
    {
      type: "city",
      label: "S. Kannanur",
      id: 14865,
      state_id: 10007,
    },
    {
      type: "city",
      label: "S.Kodikulam",
      id: 14867,
      state_id: 10007,
    },
    {
      type: "city",
      label: "S.Nallur",
      id: 14868,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Salangapalayam",
      id: 14899,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Samalapuram",
      id: 14906,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Samathur",
      id: 14908,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sambavar Vadagarai",
      id: 14909,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sankaramanallur",
      id: 14923,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sankarankoil",
      id: 14924,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sankarapuram",
      id: 14925,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sankarnagar",
      id: 14926,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Saravanampatti",
      id: 14946,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sarcarsamakulam",
      id: 14948,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sathankulam",
      id: 14968,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sathiyavijayanagaram",
      id: 14969,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sathuvachari",
      id: 14970,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sayalgudi",
      id: 14980,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sayapuram",
      id: 14982,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Seerapalli",
      id: 14984,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Seevur",
      id: 14985,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Seithur",
      id: 14986,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sembakkam",
      id: 14989,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Semmipalayam",
      id: 14990,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Senthamangalam",
      id: 14992,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sentharapatti",
      id: 14993,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Senur",
      id: 14994,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sethiathoppu",
      id: 15004,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sevilimedu",
      id: 15005,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sevugampatti",
      id: 15006,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Shenbakkam",
      id: 15028,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sholinganallur",
      id: 15043,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sholur",
      id: 15044,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sikkarayapuram",
      id: 15060,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Singampuneri",
      id: 15072,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Singaperumalkoil",
      id: 15073,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sirugamani",
      id: 15095,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sirumugai",
      id: 15096,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sithayankottai",
      id: 15100,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sithurajapuram",
      id: 15101,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sivanthipuram",
      id: 15103,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Srimushnam",
      id: 15125,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sriperumbudur",
      id: 15127,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sriramapuram",
      id: 15128,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Srivaikuntam",
      id: 15133,
      state_id: 10007,
    },
    {
      type: "city",
      label: "St.Thomas Mount-cum-Pallavaram",
      id: 15134,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Suchindram",
      id: 15137,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Suleeswaranpatti",
      id: 15144,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sulur",
      id: 15150,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sundarapandiam",
      id: 15153,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Sundarapandiapuram",
      id: 15154,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Surampatti",
      id: 15159,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Swamimalai",
      id: 15168,
      state_id: 10007,
    },
    {
      type: "city",
      label: "T.Kallupatti",
      id: 15169,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tambaram",
      id: 15185,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tayilupatti",
      id: 15198,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thadikombu",
      id: 15214,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thakkolam",
      id: 15216,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thalainayar",
      id: 15218,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thalakudi",
      id: 15219,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thamaraikulam",
      id: 15222,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thanthoni",
      id: 15225,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thathaiyangarpet",
      id: 15226,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thedavur",
      id: 15227,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thenambakkam",
      id: 15228,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thengampudur",
      id: 15229,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thenkarai",
      id: 15230,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thenthamaraikulam",
      id: 15231,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thenthiruperai",
      id: 15232,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thesur",
      id: 15235,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thevaram",
      id: 15236,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thevur",
      id: 15237,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiagadurgam",
      id: 15238,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thingalnagar",
      id: 15239,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirukarungudi",
      id: 15241,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirukattupalli",
      id: 15242,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirumalayampalayam",
      id: 15243,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirumazhisai",
      id: 15244,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirunagar",
      id: 15245,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirunageswaram",
      id: 15246,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruneermalai",
      id: 15247,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thirunindravur",
      id: 15248,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruparankundram",
      id: 15249,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruparappu",
      id: 15250,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruporur",
      id: 15251,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruppanandal",
      id: 15252,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruthangal",
      id: 15253,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvaiyaru",
      id: 15254,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvalam",
      id: 15255,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvattaru",
      id: 15257,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvenkatam",
      id: 15258,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvennainallur",
      id: 15259,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruverumbur",
      id: 15260,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvidaimarudur",
      id: 15261,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thiruvithankodu",
      id: 15262,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thisayanvilai",
      id: 15263,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thittacheri",
      id: 15264,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thondamuthur",
      id: 15266,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thondi",
      id: 15267,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thorapadi",
      id: 15269,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thottipalayam",
      id: 15271,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thottiyam",
      id: 15272,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thudiyalur",
      id: 15274,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thuthipattu",
      id: 15276,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Thuvakudi",
      id: 15277,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Timiri",
      id: 15285,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tirusulam",
      id: 15294,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruverkadu",
      id: 15295,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tiruvottiyur",
      id: 15296,
      state_id: 10007,
    },
    {
      type: "city",
      label: "TNPL Pugalur",
      id: 15302,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Udangudi",
      id: 15320,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Udayarpalayam",
      id: 15321,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ullur",
      id: 15332,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Ulundurpettai",
      id: 15334,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Unjalaur",
      id: 15350,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uppidamangalam",
      id: 15353,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uppiliapuram",
      id: 15354,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Urapakkam",
      id: 15355,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uthangarai",
      id: 15361,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uthayendram",
      id: 15362,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uthukkottai",
      id: 15363,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Uthukuli",
      id: 15364,
      state_id: 10007,
    },
    {
      type: "city",
      label: "V. Pudur",
      id: 15379,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadakarai Keezhpadugai",
      id: 15382,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadakkanandal",
      id: 15383,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadamadurai",
      id: 15384,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadavalli",
      id: 15385,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vadugapatti",
      id: 15388,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vaitheeswarankoil",
      id: 15391,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Valangaiman",
      id: 15392,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Valasaravakkam",
      id: 15394,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Valavanur",
      id: 15395,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vallam",
      id: 15398,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Valvaithankoshtam",
      id: 15401,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vanavasi",
      id: 15403,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vandalur",
      id: 15404,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vandiyur",
      id: 15405,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vaniputhur",
      id: 15406,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Varadarajanpettai",
      id: 15411,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vasudevanallur",
      id: 15422,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vathirairuppu",
      id: 15423,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vazhapadi",
      id: 15425,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vedapatti",
      id: 15426,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vedasandur",
      id: 15427,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veeraganur",
      id: 15428,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veerakeralam",
      id: 15429,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veerakkalpudur",
      id: 15430,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veerapandi",
      id: 15431,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veerappanchatram",
      id: 15432,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veeravanallur",
      id: 15433,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Velampalayam",
      id: 15437,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Velankanni",
      id: 15438,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vellakinar",
      id: 15439,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vellalur",
      id: 15440,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vellimalai",
      id: 15441,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vellottamparappu",
      id: 15442,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Velur",
      id: 15443,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vengampudur",
      id: 15444,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vengathur",
      id: 15445,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Venkarai",
      id: 15447,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vennanthur",
      id: 15450,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Veppathur",
      id: 15452,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Verkilambi",
      id: 15453,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vettaikaranpudur",
      id: 15455,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vettavalam",
      id: 15456,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vijayapuri",
      id: 15463,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vikravandi",
      id: 15467,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vilangudi",
      id: 15468,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vilankurichi",
      id: 15469,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vilapakkam",
      id: 15470,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vilathikulam",
      id: 15471,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Vilavur",
      id: 15472,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Villukuri",
      id: 15474,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Virupakshipuram",
      id: 15478,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Walajabad",
      id: 15486,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Walajapet",
      id: 15487,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Wellington",
      id: 15497,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Zamin Uthukuli",
      id: 15511,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Tirupathur (2)",
      id: 11037,
      state_id: 10007,
    },
    {
      type: "city",
      label: "Adilabad",
      id: 10313,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Bellampalle",
      id: 10609,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Bhadrachalam",
      id: 10652,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Bhainsa",
      id: 10659,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Bhongir",
      id: 10619,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Bodhan",
      id: 10447,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Farooqnagar",
      id: 10703,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Gadwal",
      id: 10577,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Hyderabad",
      id: 10040,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Jagtial",
      id: 10378,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Jangaon",
      id: 10627,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Kagaznagar",
      id: 10576,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Kamareddy",
      id: 10434,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Karimnagar",
      id: 10173,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Khammam",
      id: 10218,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Koratla",
      id: 10510,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Kothagudem",
      id: 10436,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Kyathampalle",
      id: 10898,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Mahbubnagar",
      id: 10245,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Mancherial",
      id: 10311,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Mandamarri",
      id: 10507,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Manuguru",
      id: 10884,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Medak",
      id: 10748,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Miryalaguda",
      id: 10396,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Nagarkurnool",
      id: 11018,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Narayanpet",
      id: 10749,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Nirmal",
      id: 10405,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Nizamabad",
      id: 10149,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Palwancha",
      id: 10491,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Ramagundam",
      id: 10181,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Sadasivpet",
      id: 10819,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Sangareddy",
      id: 10580,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Siddipet",
      id: 10540,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Sircilla",
      id: 10517,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Suryapet",
      id: 10345,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Tandur",
      id: 10522,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Vikarabad",
      id: 10622,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Wanaparthy",
      id: 10549,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Warangal",
      id: 10091,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Yellandu",
      id: 10868,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Hanumakonda",
      id: 11293,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Jayashankar Bhupalapally",
      id: 11299,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Mulugu",
      id: 11319,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Ranga Reddy",
      id: 11329,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Kumuram Bheem Asifabad",
      id: 11398,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Nalgonda",
      id: 11407,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Rajanna Sircilla",
      id: 11413,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Bhadradri Kothagudem",
      id: 11437,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Jagitial",
      id: 11464,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Mahabubabad",
      id: 11483,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Medchal Malkajgiri",
      id: 11488,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Peddapalli",
      id: 11500,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Jogulamba Gadwal",
      id: 11569,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Mahabubnagar",
      id: 11589,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Jangoan",
      id: 11657,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Yadadri Bhuvanagiri",
      id: 11700,
      state_id: 10006,
    },
    {
      type: "city",
      label: "Agartala",
      id: 10132,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Belonia",
      id: 11226,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Dharmanagar",
      id: 10933,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Kailasahar",
      id: 11217,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Khowai",
      id: 11231,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Pratapgarh",
      id: 11016,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Udaipur",
      id: 10885,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Dhalai",
      id: 11283,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Gomati",
      id: 11290,
      state_id: 10025,
    },
    {
      type: "city",
      label: "North Tripura",
      id: 11324,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Unakoti",
      id: 11341,
      state_id: 10025,
    },
    {
      type: "city",
      label: "West Tripura",
      id: 11344,
      state_id: 10025,
    },
    {
      type: "city",
      label: "South Tripura",
      id: 11422,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Sepahijala",
      id: 11604,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Amarpur",
      id: 11795,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Ambassa",
      id: 11807,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Badharghat",
      id: 11982,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Gakulnagar",
      id: 12946,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Gandhigram",
      id: 12954,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Indranagar",
      id: 13239,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Jogendranagar",
      id: 13383,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Kamalpur",
      id: 13482,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Kanchanpur",
      id: 13502,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Kumarghat",
      id: 13902,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Kunjaban",
      id: 13918,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Narsingarh",
      id: 14375,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Ranirbazar",
      id: 14821,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Sabroom",
      id: 14871,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Sonamura",
      id: 15113,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Teliamura",
      id: 15206,
      state_id: 10025,
    },
    {
      type: "city",
      label: "Achhnera",
      id: 11129,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Agra",
      id: 10058,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aligarh",
      id: 10084,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Allahabad",
      id: 10072,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Amroha",
      id: 10081,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Azamgarh",
      id: 10332,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bahraich",
      id: 10214,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chandausi",
      id: 10323,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Etawah",
      id: 10175,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehpur Sikri",
      id: 10883,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Firozabad",
      id: 10055,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hapur",
      id: 10169,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hardoi ",
      id: 10327,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhansi",
      id: 10114,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kalpi",
      id: 10635,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kanpur",
      id: 10047,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khair",
      id: 10359,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Laharpur",
      id: 10537,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lakhimpur",
      id: 10256,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lal Gopalganj Nindaura",
      id: 10978,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lalganj",
      id: 11187,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lalitpur",
      id: 10287,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lar",
      id: 10977,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Loni",
      id: 10113,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lucknow",
      id: 10046,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mathura",
      id: 10719,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Meerut",
      id: 10063,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mirzapur",
      id: 11254,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Modinagar",
      id: 10165,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Moradabad",
      id: 10082,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nagina",
      id: 10384,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Najibabad",
      id: 10404,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nakur",
      id: 11132,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nanpara",
      id: 10674,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Naraura",
      id: 11131,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Naugawan Sadat",
      id: 10882,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nautanwa",
      id: 10866,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nawabganj",
      id: 10775,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nehtaur",
      id: 10680,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Niwai",
      id: 11243,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Noida",
      id: 10099,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Noorpur",
      id: 10781,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Obra",
      id: 11237,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Orai",
      id: 10213,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Padrauna",
      id: 10714,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Palia Kalan",
      id: 10839,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Parasi",
      id: 11185,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Phulpur",
      id: 11193,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pihani",
      id: 11001,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pilibhit",
      id: 10299,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pilkhuwa",
      id: 10504,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Powayan",
      id: 11106,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pukhrayan",
      id: 11224,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Puranpur",
      id: 10804,
      state_id: 10010,
    },
    {
      type: "city",
      label: "PurqUrban Agglomerationzi",
      id: 11098,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Purwa",
      id: 11182,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rae Bareli",
      id: 10231,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rampur",
      id: 10162,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rampur Maniharan",
      id: 11067,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rasra",
      id: 10961,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rath",
      id: 10594,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Renukoot",
      id: 10506,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Reoti",
      id: 11153,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Robertsganj",
      id: 10905,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rudauli",
      id: 10811,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rudrapur",
      id: 11021,
      state_id: 10010,
    },
    {
      type: "city",
      label: "SUrban Agglomerationr",
      id: 11034,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sadabad",
      id: 10914,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Safipur",
      id: 11143,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Saharanpur",
      id: 10095,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahaspur",
      id: 11137,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahaswan",
      id: 10570,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahawar",
      id: 11213,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahjanwa",
      id: 11061,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Saidpur",
      id: 11175,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sambhal",
      id: 10192,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Samdhan",
      id: 11054,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Samthar",
      id: 11218,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sandi",
      id: 11111,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sandila",
      id: 10671,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sardhana",
      id: 10675,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Seohara",
      id: 10684,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahabad, Hardoi",
      id: 10496,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahabad, Rampur",
      id: 10899,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahganj",
      id: 11073,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahjahanpur",
      id: 10145,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shamli",
      id: 10397,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shamsabad, Agra",
      id: 11008,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shamsabad, Farrukhabad",
      id: 11099,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sherkot",
      id: 10624,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shikarpur, Bulandshahr",
      id: 10879,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shikohabad",
      id: 10407,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shishgarh",
      id: 11207,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Siana",
      id: 10778,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sikanderpur",
      id: 11170,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sikandra Rao",
      id: 10792,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sikandrabad",
      id: 10488,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sirsaganj",
      id: 10980,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sirsi",
      id: 11181,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sitapur",
      id: 10257,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Soron",
      id: 11022,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sultanpur",
      id: 10367,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sumerpur",
      id: 11071,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tanda",
      id: 10382,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Thakurdwara",
      id: 10720,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Thana Bhawan",
      id: 10816,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tilhar",
      id: 10545,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tirwaganj",
      id: 11085,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tulsipur",
      id: 11075,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tundla",
      id: 10647,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ujhani",
      id: 10535,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Unnao",
      id: 10223,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Utraula",
      id: 10909,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Varanasi",
      id: 10066,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Vrindavan",
      id: 10530,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Warhapur",
      id: 11102,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Zaidpur",
      id: 10848,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Zamania",
      id: 10875,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ambedkar Nagar",
      id: 11257,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Balrampur",
      id: 11260,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhadohi",
      id: 11266,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chandauli",
      id: 11272,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kanpur Dehat",
      id: 11302,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kheri",
      id: 11306,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kushinagar",
      id: 11310,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mainpuri",
      id: 11315,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mau",
      id: 11317,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Siddharthnagar",
      id: 11333,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sonbhadra",
      id: 11335,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ballia",
      id: 11353,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Banda",
      id: 11355,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bareilly",
      id: 11358,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Budaun",
      id: 11362,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bulandshahr",
      id: 11363,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gautam Buddha Nagar",
      id: 11377,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghazipur",
      id: 11378,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hathras",
      id: 11381,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jalaun",
      id: 11384,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kanpur Nagar",
      id: 11394,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mahoba",
      id: 11402,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Prayagraj",
      id: 11411,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Auraiya",
      id: 11433,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ayodhya",
      id: 11434,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bara Banki",
      id: 11436,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Etah",
      id: 11453,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Farrukhabad",
      id: 11454,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehpur",
      id: 11455,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghaziabad",
      id: 11458,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gonda",
      id: 11459,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kannauj",
      id: 11471,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kasganj",
      id: 11472,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mahrajganj",
      id: 11484,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pratapgarh",
      id: 11502,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Baghpat",
      id: 11533,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Basti",
      id: 11538,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sant Kabir Nagar",
      id: 11602,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shrawasti",
      id: 11606,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Amethi",
      id: 11620,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bijnor",
      id: 11625,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chitrakoot",
      id: 11636,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Deoria",
      id: 11642,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gorakhpur",
      id: 11650,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hamirpur",
      id: 11652,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jaunpur",
      id: 11658,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kaushambi",
      id: 11663,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Muzaffarnagar",
      id: 11670,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Achhalda",
      id: 11718,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Adari",
      id: 11721,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Afzalgarh",
      id: 11727,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Agarwal Mandi",
      id: 11730,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ahraura",
      id: 11738,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ailum",
      id: 11740,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Air Force Area",
      id: 11741,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ajhuwa",
      id: 11744,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Akbarpur",
      id: 11750,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aliganj",
      id: 11775,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Allahganj",
      id: 11777,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Allapur",
      id: 11778,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Amanpur",
      id: 11792,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ambehta",
      id: 11809,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Amila",
      id: 11816,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Amilo",
      id: 11817,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aminagar Sarai",
      id: 11818,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aminagar Urf Bhurbaral",
      id: 11819,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Amraudha",
      id: 11830,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Anandnagar",
      id: 11838,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Anpara",
      id: 11862,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Antu",
      id: 11866,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Anupshahr",
      id: 11868,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aonla",
      id: 11869,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Armapur Estate",
      id: 11892,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ashrafpur Kichhauchha",
      id: 11904,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Atarra",
      id: 11912,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Atasu",
      id: 11913,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Atrauli",
      id: 11922,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Atraulia",
      id: 11923,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aurangabad",
      id: 11929,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Aurangabad Bangar",
      id: 11930,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Auras",
      id: 11931,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Awagarh",
      id: 11939,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Azizpur",
      id: 11950,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Azmatgarh",
      id: 11951,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Babarpur Ajitmal",
      id: 11956,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Baberu",
      id: 11957,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Babina",
      id: 11959,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Babrala",
      id: 11962,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Babugarh",
      id: 11964,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bachhraon",
      id: 11965,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bachhrawan",
      id: 11966,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bad",
      id: 11967,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bah",
      id: 12006,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bahadurganj",
      id: 12008,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Baheri",
      id: 12010,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bahjoi",
      id: 12012,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bahsuma",
      id: 12013,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bahuwa",
      id: 12015,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bajna",
      id: 12025,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bakewar",
      id: 12030,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bakiabad",
      id: 12032,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Baldeo",
      id: 12044,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Banat",
      id: 12066,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bangarmau",
      id: 12080,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Banki",
      id: 12088,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bansdih",
      id: 12095,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bansgaon",
      id: 12096,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bansi",
      id: 12098,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Baragaon",
      id: 12104,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Baraut",
      id: 12114,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Barhalganj",
      id: 12123,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Barhani Bazar",
      id: 12124,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Barkhera",
      id: 12136,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Barsana",
      id: 12142,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Barua Sagar",
      id: 12144,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Barwar",
      id: 12151,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Begumabad Budhana",
      id: 12182,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Behta Hajipur",
      id: 12187,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bela Pratapgarh",
      id: 12188,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Belthara Road",
      id: 12202,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Beniganj",
      id: 12208,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Beswan",
      id: 12214,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bewar",
      id: 12218,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhadarsa",
      id: 12223,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhagwant Nagar",
      id: 12234,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bharatganj",
      id: 12252,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhargain",
      id: 12253,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bharthana",
      id: 12255,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bharuhana",
      id: 12257,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bharwari",
      id: 12259,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhatni Bazar",
      id: 12263,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhatpar Rani",
      id: 12264,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhawan Bahadur Nagar",
      id: 12270,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhinga",
      id: 12284,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhogaon",
      id: 12291,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhojpur Dharampur",
      id: 12293,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhokarhedi",
      id: 12296,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bhulepur",
      id: 12306,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bidhuna",
      id: 12319,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bighapur",
      id: 12320,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bijpur",
      id: 12328,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bikapur",
      id: 12330,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilari",
      id: 12336,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilariaganj",
      id: 12337,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilaspur",
      id: 12340,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilgram",
      id: 12343,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilhaur",
      id: 12345,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilram",
      id: 12351,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilsanda",
      id: 12352,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bilsi",
      id: 12353,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bindki",
      id: 12356,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bisalpur",
      id: 12367,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bisanda Buzurg",
      id: 12368,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bisauli",
      id: 12369,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bisharatganj",
      id: 12371,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bisokhar",
      id: 12374,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Biswan",
      id: 12376,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bithoor",
      id: 12378,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Budhana",
      id: 12408,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bugrasi",
      id: 12414,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chail",
      id: 12434,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chak Imam Ali",
      id: 12438,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chakeri",
      id: 12443,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chakia",
      id: 12446,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chandpur",
      id: 12477,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Charkhari",
      id: 12499,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Charthaval",
      id: 12500,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chaumuhan",
      id: 12504,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chhaprauli",
      id: 12537,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chharra Rafatpur",
      id: 12539,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chhata",
      id: 12540,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chhatari",
      id: 12541,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chhibramau",
      id: 12547,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chhutmalpur",
      id: 12556,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chilkana Sultanpur",
      id: 12570,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chirgaon",
      id: 12591,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chitbara Gaon",
      id: 12594,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chitrakoot Dham (Karwi)",
      id: 12599,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chopan",
      id: 12607,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Choubepur Kalan",
      id: 12611,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Chunar",
      id: 12617,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Churk Ghurma",
      id: 12621,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Colonelganj",
      id: 12624,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dadri",
      id: 12638,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dalmau",
      id: 12653,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dankaur",
      id: 12662,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dariyabad",
      id: 12670,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dasna",
      id: 12676,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dataganj",
      id: 12679,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Daurala",
      id: 12685,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dayalbagh",
      id: 12689,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Deoband",
      id: 12699,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Deoranian",
      id: 12707,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dewa",
      id: 12735,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dhampur",
      id: 12746,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dhanauha",
      id: 12748,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dhanauli",
      id: 12750,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dhanaura",
      id: 12751,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dharoti Khurd",
      id: 12776,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dhaura Tanda",
      id: 12783,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dhaurehra",
      id: 12784,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dibai",
      id: 12797,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dibiyapur",
      id: 12798,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dildarnagar Fatehpur Bazar",
      id: 12811,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Doghat",
      id: 12823,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dohrighat",
      id: 12825,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dostpur",
      id: 12838,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dudhi",
      id: 12842,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Dulhipur",
      id: 12844,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ekdil",
      id: 12873,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Erich",
      id: 12887,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Etmadpur",
      id: 12892,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Faizabad",
      id: 12896,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Faizganj",
      id: 12897,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Farah",
      id: 12900,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Faridnagar",
      id: 12902,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Faridpur",
      id: 12903,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fariha",
      id: 12904,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Farrukhabad-cum-Fatehgarh",
      id: 12907,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehabad",
      id: 12909,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehganj Pashchimi",
      id: 12910,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehganj Purvi",
      id: 12911,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehgarh",
      id: 12912,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Fatehpur Chaurasi",
      id: 12916,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gajraula",
      id: 12942,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gangaghat",
      id: 12957,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gangapur",
      id: 12962,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gangoh",
      id: 12966,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ganj Dundawara",
      id: 12969,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ganj Muradabad",
      id: 12970,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Garautha",
      id: 12972,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Garhi Pukhta",
      id: 12975,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Garhmukteshwar",
      id: 12977,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gaura Barhaj",
      id: 12983,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gauri Bazar",
      id: 12985,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gausganj",
      id: 12988,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gawan",
      id: 12989,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghatampur",
      id: 13002,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghiraur",
      id: 13008,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghorawal",
      id: 13015,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghosi",
      id: 13017,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghosia Bazar",
      id: 13018,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ghughuli",
      id: 13020,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gohand",
      id: 13041,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gokul",
      id: 13046,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gola Bazar",
      id: 13047,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gola Gokarannath",
      id: 13048,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gopamau",
      id: 13058,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gopiganj",
      id: 13059,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gosainganj",
      id: 13067,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Govardhan",
      id: 13073,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gulaothi",
      id: 13087,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gularia Bhindara",
      id: 13088,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gulariya",
      id: 13089,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gunnaur",
      id: 13096,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gursahaiganj",
      id: 13102,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gursarai",
      id: 13103,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Gyanpur",
      id: 13106,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hafizpur",
      id: 13109,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Haidergarh",
      id: 13111,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Haldaur",
      id: 13116,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Handia",
      id: 13125,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Harduaganj",
      id: 13132,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hargaon",
      id: 13133,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hariharpur",
      id: 13137,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Harraiya",
      id: 13144,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hasanpur",
      id: 13148,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hasayan",
      id: 13149,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hastinapur",
      id: 13151,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hata",
      id: 13153,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Hyderabad",
      id: 13213,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ibrahimpur",
      id: 13215,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Iglas",
      id: 13224,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ikauna",
      id: 13225,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Iltifatganj Bazar",
      id: 13230,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Indian Telephone Industry, Mankapur (Sp. Village)",
      id: 13237,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Islamnagar",
      id: 13247,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Itaunja",
      id: 13253,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jafarabad",
      id: 13256,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jagner",
      id: 13269,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jahanabad",
      id: 13272,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jahangirabad",
      id: 13273,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jahangirpur",
      id: 13274,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jais",
      id: 13278,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jaithara",
      id: 13281,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jalalabad",
      id: 13288,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jalali",
      id: 13290,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jalalpur",
      id: 13292,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jalesar",
      id: 13294,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jamshila",
      id: 13309,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jangipur",
      id: 13316,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jansath",
      id: 13317,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jarwal",
      id: 13321,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jasrana",
      id: 13326,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jaswantnagar",
      id: 13327,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jatari",
      id: 13330,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jewar",
      id: 13349,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhalu",
      id: 13356,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhansi Rly. Settlement",
      id: 13358,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhinjhak",
      id: 13362,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhinjhana",
      id: 13363,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhusi",
      id: 13369,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jhusi Kohna",
      id: 13370,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jiyanpur",
      id: 13376,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Joya",
      id: 13394,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Jyoti Khuria",
      id: 13402,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kabrai",
      id: 13404,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kachhauna Patseni",
      id: 13405,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kachhla",
      id: 13406,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kachhwa",
      id: 13407,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kadaura",
      id: 13414,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kadipur",
      id: 13418,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kailashpur",
      id: 13426,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kaimganj",
      id: 13428,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kairana",
      id: 13429,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kakgaina",
      id: 13435,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kakod",
      id: 13436,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kakori",
      id: 13437,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kakrala",
      id: 13438,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kalinagar",
      id: 13461,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kamalganj",
      id: 13481,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kampil",
      id: 13489,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kandhla",
      id: 13507,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kandwa",
      id: 13512,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kanth",
      id: 13546,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kaptanganj",
      id: 13557,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Karari",
      id: 13569,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Karhal",
      id: 13575,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Karnawal",
      id: 13587,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Katariya",
      id: 13611,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Katghar Lalganj",
      id: 13612,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kathera",
      id: 13614,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Katra",
      id: 13621,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Katra Medniganj",
      id: 13622,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kauriaganj",
      id: 13629,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kemri",
      id: 13648,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kerakat",
      id: 13654,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khadda",
      id: 13663,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khaga",
      id: 13665,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khailar",
      id: 13668,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khairabad",
      id: 13669,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khalilabad",
      id: 13677,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khamaria",
      id: 13680,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khanpur",
      id: 13694,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kharela",
      id: 13702,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khargupur",
      id: 13705,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khariya",
      id: 13710,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kharkhoda",
      id: 13712,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khatauli",
      id: 13719,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khatauli Rural",
      id: 13720,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khekada",
      id: 13727,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kheragarh",
      id: 13731,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kheta Sarai",
      id: 13737,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khudaganj",
      id: 13750,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khurja",
      id: 13754,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Khutar",
      id: 13756,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kiraoli",
      id: 13769,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kiratpur",
      id: 13771,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kishni",
      id: 13777,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kishunpur",
      id: 13778,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kithaur",
      id: 13779,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Koeripur",
      id: 13794,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Konch",
      id: 13816,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kopaganj",
      id: 13826,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kora Jahanabad",
      id: 13830,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Koraon",
      id: 13832,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Korwa",
      id: 13837,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kosi Kalan",
      id: 13839,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kota",
      id: 13842,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kotra",
      id: 13857,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kotwa",
      id: 13866,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kul Pahar",
      id: 13894,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kunda",
      id: 13910,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kundarki",
      id: 13913,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kunwargaon",
      id: 13921,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kuraoli",
      id: 13925,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kurara",
      id: 13926,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kursath",
      id: 13933,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kurthi Jafarpur",
      id: 13935,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Kusmara",
      id: 13945,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lakhna",
      id: 13959,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lawar NP",
      id: 13980,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ledwa Mahua",
      id: 13981,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Lohta",
      id: 13999,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Machhlishahr",
      id: 14007,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Madhoganj",
      id: 14015,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Madhogarh",
      id: 14016,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maghar",
      id: 14025,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mahaban",
      id: 14027,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mahmudabad",
      id: 14039,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maholi",
      id: 14040,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mahona",
      id: 14041,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mahroni",
      id: 14042,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mailani",
      id: 14051,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Majhara Pipar Ehatmali",
      id: 14057,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Majhauli Raj",
      id: 14058,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Malihabad",
      id: 14071,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mallawan",
      id: 14078,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mandawar",
      id: 14100,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Manikpur",
      id: 14113,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Manikpur Sarhat",
      id: 14114,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maniyar",
      id: 14116,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Manjhanpur",
      id: 14119,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mankapur",
      id: 14120,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Marehra",
      id: 14136,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mariahu",
      id: 14137,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maruadih Rly. Settlement",
      id: 14140,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maswasi",
      id: 14145,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mataundh",
      id: 14146,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mau Aima",
      id: 14151,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maudaha",
      id: 14152,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maunath Bhanjan",
      id: 14153,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mauranipur",
      id: 14155,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Maurawan",
      id: 14156,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mawana",
      id: 14158,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mehdawal",
      id: 14169,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mehnagar",
      id: 14172,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mendu",
      id: 14185,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Milak",
      id: 14194,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Miranpur",
      id: 14196,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mirganj",
      id: 14197,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mirzapur-cum-Vindhyachal",
      id: 14201,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Misrikh-cum-Neemsar",
      id: 14202,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mogra Badshahpur",
      id: 14207,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mohammadabad",
      id: 14209,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mohammadi",
      id: 14210,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mohan",
      id: 14211,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mohanpur",
      id: 14212,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mohiuddinpur",
      id: 14217,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Moth",
      id: 14235,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mubarakpur",
      id: 14239,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mughalsarai",
      id: 14247,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mughalsarai Rly. Settlement",
      id: 14248,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Muhammadabad",
      id: 14251,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mukrampur Khema",
      id: 14256,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mundera Bazar",
      id: 14265,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mundia",
      id: 14268,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Muradnagar",
      id: 14276,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Mursan",
      id: 14282,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Musafirkhana",
      id: 14286,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nadigaon",
      id: 14306,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nagram",
      id: 14317,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nai Bazar",
      id: 14322,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nainana Jat",
      id: 14325,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nanauta",
      id: 14342,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nandgaon",
      id: 14348,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Naraini",
      id: 14358,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Narauli",
      id: 14365,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nichlaul",
      id: 14427,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nidhauli Kalan",
      id: 14428,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Niwari",
      id: 14441,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nizamabad",
      id: 14443,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Northern Rly. Colony",
      id: 14453,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nyoria Husainpur",
      id: 14460,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Nyotini",
      id: 14461,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Oel Dhakwa",
      id: 14469,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Oran",
      id: 14482,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ordnance Factory Muradnagar",
      id: 14485,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pachperwa",
      id: 14495,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pahasu",
      id: 14506,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Paintepur",
      id: 14507,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pali",
      id: 14528,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Parichha",
      id: 14587,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Parikshitgarh",
      id: 14588,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Parsadepur",
      id: 14592,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Patala",
      id: 14599,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Patiyali",
      id: 14611,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Patti",
      id: 14616,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Phalauda",
      id: 14658,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Phaphund",
      id: 14660,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Phulwaria",
      id: 14663,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pilkhana",
      id: 14667,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pinahat",
      id: 14670,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pipalsana Chaudhari",
      id: 14672,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pipiganj",
      id: 14674,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pipraich",
      id: 14678,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pipri",
      id: 14679,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Pratapgarh City",
      id: 14706,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Purdilnagar",
      id: 14727,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Purquazi",
      id: 14728,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Qasimpur Power House Colony",
      id: 14741,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rabupura",
      id: 14750,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Radhakund",
      id: 14752,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Raja Ka Rampur",
      id: 14765,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rajapur",
      id: 14768,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ramkola",
      id: 14799,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ramnagar",
      id: 14802,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rampur Bhawanipur",
      id: 14807,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rampur Karkhana",
      id: 14808,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rampura",
      id: 14811,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ranipur",
      id: 14820,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rashidpur Garhi",
      id: 14823,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rasulabad",
      id: 14824,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Raya",
      id: 14832,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Richha",
      id: 14846,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Risia Bazar",
      id: 14849,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rithora",
      id: 14850,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rly. Settlement Roza",
      id: 14851,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rudayan",
      id: 14858,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rura",
      id: 14862,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Rustamnagar Sahaspur",
      id: 14864,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sadat",
      id: 14876,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahanpur",
      id: 14883,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahatwar",
      id: 14885,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sahpau NP",
      id: 14889,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sainthal",
      id: 14892,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Saiyad Raja",
      id: 14894,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sakhanu",
      id: 14895,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sakit",
      id: 14896,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Salarpur Khadar",
      id: 14901,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Salempur",
      id: 14902,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Salon",
      id: 14905,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sarai Aquil",
      id: 14940,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sarai Mir",
      id: 14941,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sarila",
      id: 14953,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sarsawan",
      id: 14958,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sasni",
      id: 14964,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Satrikh",
      id: 14973,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Saunkh",
      id: 14975,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Saurikh",
      id: 14976,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sewalkhas",
      id: 15008,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sewarhi",
      id: 15009,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahabad",
      id: 15010,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahi",
      id: 15014,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shahpur",
      id: 15016,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shamsabad",
      id: 15023,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shankargarh",
      id: 15024,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shergarh",
      id: 15029,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shikarpur",
      id: 15030,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shivdaspur",
      id: 15038,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shivli",
      id: 15039,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shivrajpur",
      id: 15040,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Shohratgarh",
      id: 15042,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Siddhaur",
      id: 15050,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sidhauli",
      id: 15052,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sidhpura",
      id: 15053,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sikandra",
      id: 15057,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Singahi Bhiraura",
      id: 15071,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sirathu",
      id: 15085,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sirauli",
      id: 15086,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sirsa",
      id: 15092,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sisauli",
      id: 15097,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Siswa Bazar",
      id: 15098,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Som",
      id: 15109,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Suar",
      id: 15136,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Sukhmalpur Nizamabad",
      id: 15142,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Suriyawan",
      id: 15162,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Swamibagh",
      id: 15167,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Talbehat",
      id: 15176,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Talgram",
      id: 15179,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tambaur-cum-Ahmadabad",
      id: 15186,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tatarpur Lallu",
      id: 15195,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tetri Bazar",
      id: 15212,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Thiriya Nizamat Khan",
      id: 15240,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tikait Nagar",
      id: 15281,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tikri",
      id: 15282,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tindwari",
      id: 15286,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Titron",
      id: 15300,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tondi Fatehpur",
      id: 15304,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tundla Kham",
      id: 15314,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Tundla Rly. Colony",
      id: 15315,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ugu",
      id: 15324,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Ujhari",
      id: 15325,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Umri",
      id: 15340,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Umri Kalan",
      id: 15341,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Un",
      id: 15343,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Unchahar",
      id: 15346,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Usawan",
      id: 15358,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Usehat",
      id: 15359,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Vijaigarh",
      id: 15459,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Wazirganj",
      id: 15495,
      state_id: 10010,
    },
    {
      type: "city",
      label: "Bageshwar",
      id: 11244,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dehradun",
      id: 10106,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Haldwani-cum-Kathgodam",
      id: 10250,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Hardwar",
      id: 10186,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kashipur",
      id: 10305,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Manglaur",
      id: 10736,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Mussoorie",
      id: 10959,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Nagla",
      id: 11150,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Nainital",
      id: 10753,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Pauri",
      id: 11070,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Pithoragarh",
      id: 10708,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Ramnagar",
      id: 10696,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Rishikesh",
      id: 10441,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Roorkee",
      id: 10319,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Rudrapur",
      id: 10402,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Sitarganj",
      id: 11156,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Srinagar",
      id: 10264,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Tehri",
      id: 11053,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Chamoli",
      id: 11271,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Haridwar",
      id: 11295,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Almora",
      id: 11348,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Champawat",
      id: 11367,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Udam Singh Nagar",
      id: 11425,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Rudra Prayag",
      id: 11507,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Pauri Garhwal",
      id: 11680,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Tehri Garhwal",
      id: 11690,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Uttar Kashi",
      id: 11694,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Badrinathpuri",
      id: 11992,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Bajpur",
      id: 12027,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Banbasa",
      id: 12068,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Bandia",
      id: 12072,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Barkot",
      id: 12137,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Bharat Heavy Electrical Limited Ranipur",
      id: 12251,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Bhimtal",
      id: 12282,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Bhowali",
      id: 12301,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Chakrata",
      id: 12449,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Chamba",
      id: 12458,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Chamoli Gopeshwar",
      id: 12459,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Clement Town",
      id: 12622,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dev Prayag",
      id: 12722,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dhaluwala",
      id: 12742,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dhandera",
      id: 12753,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dharchula",
      id: 12768,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dharchula Dehat",
      id: 12769,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Didihat",
      id: 12799,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dineshpur",
      id: 12816,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dogadda",
      id: 12822,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Doiwala",
      id: 12826,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Dwarahat",
      id: 12861,
      state_id: 10023,
    },
    {
      type: "city",
      label: "FRI and College Area",
      id: 12925,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Gadarpur",
      id: 12930,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Gangotri",
      id: 12967,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Gochar",
      id: 13034,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Herbertpur",
      id: 13167,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Jaspur",
      id: 13325,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Jhabrera",
      id: 13351,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Joshimath",
      id: 13389,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kachnal Gosain",
      id: 13408,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kaladungi",
      id: 13439,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Karn Prayag",
      id: 13585,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kashirampur",
      id: 13603,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kedarnath",
      id: 13636,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kela Khera",
      id: 13644,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Khatima",
      id: 13723,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kichha",
      id: 13757,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kirtinagar",
      id: 13774,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Kotdwara",
      id: 13845,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Laksar",
      id: 13962,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Lalkuan",
      id: 13964,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Landaura",
      id: 13970,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Landour",
      id: 13971,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Lansdowne",
      id: 13973,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Lohaghat",
      id: 13996,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Mahua Dabra Haripura",
      id: 14044,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Mahua Kheraganj",
      id: 14045,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Mohanpur Mohammadpur",
      id: 14213,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Muni Ki Reti",
      id: 14273,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Mussoori",
      id: 14288,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Nand Prayag",
      id: 14343,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Narendra Nagar",
      id: 14371,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Pratitnagar",
      id: 14708,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Raipur",
      id: 14763,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Ranikhet",
      id: 14817,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Shaktigarh",
      id: 15020,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Sultanpur",
      id: 15147,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Tanakpur",
      id: 15187,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Uttarkashi",
      id: 15377,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Veerbhadra",
      id: 15434,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Vikasnagar",
      id: 15466,
      state_id: 10023,
    },
    {
      type: "city",
      label: "Adra",
      id: 11235,
      state_id: 10008,
    },
    {
      type: "city",
      label: "AlipurdUrban Agglomerationr",
      id: 10520,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Arambagh",
      id: 10512,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Asansol",
      id: 10107,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baharampur",
      id: 10210,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Balurghat",
      id: 10260,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bankura",
      id: 10282,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Darjiling",
      id: 10307,
      state_id: 10008,
    },
    {
      type: "city",
      label: "English Bazar",
      id: 10195,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gangarampur",
      id: 10591,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Habra",
      id: 10266,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Hugli-Chinsurah",
      id: 10224,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jalpaiguri",
      id: 10232,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jhargram",
      id: 10543,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kalimpong",
      id: 10731,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kharagpur",
      id: 10156,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kolkata",
      id: 10042,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mainaguri",
      id: 11011,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Malda",
      id: 11113,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mathabhanga",
      id: 11189,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Medinipur",
      id: 10265,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Memari",
      id: 10822,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Monoharpur",
      id: 11202,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Murshidabad",
      id: 10808,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nabadwip",
      id: 10295,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Naihati",
      id: 10191,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Panchla",
      id: 11155,
      state_id: 10008,
    },
    {
      type: "city",
      label: "PandUrban Agglomeration",
      id: 11010,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Paschim Punropara",
      id: 10928,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Purulia",
      id: 10324,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raghunathganj",
      id: 10143,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raghunathpur",
      id: 11160,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raiganj",
      id: 10225,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Rampurhat",
      id: 10644,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ranaghat",
      id: 10271,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sainthia",
      id: 10777,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Santipur",
      id: 10259,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Siliguri",
      id: 10059,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sonamukhi",
      id: 11007,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Srirampore",
      id: 11228,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Suri",
      id: 10541,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Taki",
      id: 10786,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Tamluk",
      id: 10518,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Tarakeswar",
      id: 10931,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dakshin Dinajpur",
      id: 11278,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Darjeeling",
      id: 11281,
      state_id: 10008,
    },
    {
      type: "city",
      label: "South 24 Parganas",
      id: 11337,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Alipurduar",
      id: 11347,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Dinajpur",
      id: 11426,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Birbhum",
      id: 11439,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nadia",
      id: 11490,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Paschim Bardhaman",
      id: 11498,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Paschim Medinipur",
      id: 11499,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Cooch Behar",
      id: 11549,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Hooghly",
      id: 11564,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Howrah",
      id: 11565,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Purba Medinipur",
      id: 11600,
      state_id: 10008,
    },
    {
      type: "city",
      label: "North 24 Parganas",
      id: 11675,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Purba Bardhaman",
      id: 11681,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ahmadpur",
      id: 11734,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Aiho",
      id: 11739,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Aistala",
      id: 11742,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Alipurduar Rly.Jnc.",
      id: 11776,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Alpur",
      id: 11783,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Amkula",
      id: 11820,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Amodghata",
      id: 11829,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Amtala",
      id: 11832,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Andul",
      id: 11846,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Anksa",
      id: 11856,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ankurhati",
      id: 11857,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Anup Nagar",
      id: 11867,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Arambag",
      id: 11877,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Argari",
      id: 11886,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Arra",
      id: 11897,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ashoknagar Kalyangarh",
      id: 11903,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Aurangabad",
      id: 11928,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bablari Dewanganj",
      id: 11961,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Badhagachhi",
      id: 11981,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baduria",
      id: 11993,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bagnan",
      id: 12004,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bahirgram",
      id: 12011,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bahula",
      id: 12014,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baidyabati",
      id: 12016,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bairatisal",
      id: 12022,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Balaram Pota",
      id: 12040,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Balarampur",
      id: 12041,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Balichak",
      id: 12048,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ballavpur",
      id: 12052,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bally",
      id: 12053,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bamunari",
      id: 12062,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Banarhat Tea Garden",
      id: 12064,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bangaon",
      id: 12078,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bankra",
      id: 12090,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bansberia",
      id: 12094,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Banshra",
      id: 12097,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Banupur",
      id: 12101,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bara Bamonia",
      id: 12102,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barabazar",
      id: 12103,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baranagar",
      id: 12109,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barasat",
      id: 12111,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barddhaman",
      id: 12117,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barijhati",
      id: 12131,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barjora",
      id: 12134,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barrackpur",
      id: 12140,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Barrackpur Cantonment",
      id: 12141,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baruihuda",
      id: 12146,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baruipur",
      id: 12147,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Basirhat",
      id: 12157,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Baska",
      id: 12158,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Begampur",
      id: 12179,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Beldanga",
      id: 12190,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Beldubi",
      id: 12191,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Belebathan",
      id: 12192,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Beliatore",
      id: 12195,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bhadreswar",
      id: 12230,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bhandardaha",
      id: 12241,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bhangar Raghunathpur",
      id: 12243,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bhangri Pratham Khanda",
      id: 12244,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bhanowara",
      id: 12247,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bhatpara",
      id: 12265,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bholar Dabri",
      id: 12297,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bidhan Nagar",
      id: 12318,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bikihakola",
      id: 12331,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bilandapur",
      id: 12334,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bilpahari",
      id: 12349,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bipra  Noapara",
      id: 12358,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Birlapur",
      id: 12361,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Birnagar",
      id: 12362,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bishnupur",
      id: 12373,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bolpur",
      id: 12390,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Bowali",
      id: 12401,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Budge Budge",
      id: 12406,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Cart Road",
      id: 12430,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chachanda",
      id: 12432,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chak Bankola",
      id: 12435,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chak Bansberia",
      id: 12436,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chak Enayetnagar",
      id: 12437,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chak Kashipur",
      id: 12439,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chakapara",
      id: 12441,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chakdaha",
      id: 12442,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Champdani",
      id: 12461,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chamrail",
      id: 12463,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chandannagar",
      id: 12467,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chandpur",
      id: 12478,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chandrakona",
      id: 12479,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chapari",
      id: 12491,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chapui",
      id: 12493,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Char Brahmanagar",
      id: 12494,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Char Maijdia",
      id: 12495,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Charka",
      id: 12498,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chata Kalikapur",
      id: 12502,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chechakhata",
      id: 12508,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chelad",
      id: 12513,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chhora",
      id: 12549,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chikrand",
      id: 12569,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Chittaranjan",
      id: 12600,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Contai",
      id: 12626,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Cooper's Camp",
      id: 12628,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dafahat",
      id: 12639,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dainhat",
      id: 12643,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dakshin Baguan",
      id: 12646,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dakshin Jhapardaha",
      id: 12647,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dakshin Rajyadharpur",
      id: 12648,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dalkhola",
      id: 12651,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dalurband",
      id: 12656,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Darappur",
      id: 12666,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Debipur",
      id: 12691,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Deuli",
      id: 12721,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhakuria",
      id: 12738,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhandadihi",
      id: 12752,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhanyakuria",
      id: 12758,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dharmapur",
      id: 12774,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhatrigram",
      id: 12780,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhuilya",
      id: 12792,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhulian",
      id: 12793,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhupguri",
      id: 12794,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dhusaripara",
      id: 12795,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Diamond Harbour",
      id: 12796,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dignala",
      id: 12807,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dinhata",
      id: 12817,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Domjur",
      id: 12829,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dubrajpur",
      id: 12840,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Dumdum",
      id: 12849,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Durgapur",
      id: 12856,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Durllabhganj",
      id: 12858,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Egra",
      id: 12871,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Eksara",
      id: 12875,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Falakata",
      id: 12899,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Farrakka Barrage Township",
      id: 12906,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Fatellapur",
      id: 12917,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gabberia",
      id: 12928,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gairkata",
      id: 12939,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Garalgachha",
      id: 12971,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Garshyamnagar",
      id: 12981,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Garulia",
      id: 12982,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gayespur",
      id: 12990,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ghatal",
      id: 13001,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ghorsala",
      id: 13016,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Goaljan",
      id: 13029,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Goasafat",
      id: 13030,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gobardanga",
      id: 13031,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gopalpur",
      id: 13056,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gopinathpur",
      id: 13060,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Gora Bazar",
      id: 13061,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Guma",
      id: 13093,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Guriahati",
      id: 13100,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Guskara",
      id: 13105,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Haldia",
      id: 13117,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Haldibari",
      id: 13118,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Halisahar",
      id: 13119,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Haora",
      id: 13131,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Harharia Chak",
      id: 13134,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Haripur",
      id: 13139,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Harishpur",
      id: 13140,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Hatgachha",
      id: 13154,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Hatsimla",
      id: 13160,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Hijuli",
      id: 13172,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Hindusthan Cables Town",
      id: 13179,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ichhapur Defence  Estate",
      id: 13218,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Islampur",
      id: 13248,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jafarpur",
      id: 13257,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jagadanandapur",
      id: 13261,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jagadishpur",
      id: 13263,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jagtaj",
      id: 13270,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jala Kendua",
      id: 13286,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jamuria",
      id: 13311,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jangipur",
      id: 13315,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jaygaon",
      id: 13338,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jaynagar Mazilpur",
      id: 13339,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jemari",
      id: 13342,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jemari  (J.K. Nagar Township)",
      id: 13343,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jetia",
      id: 13346,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jhalda",
      id: 13354,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jhorhat",
      id: 13365,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jiaganj Azimganj",
      id: 13371,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Jot Kamal",
      id: 13391,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kachu Pukur",
      id: 13409,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kajora",
      id: 13431,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kakdihi",
      id: 13434,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kalara",
      id: 13452,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kaliaganj",
      id: 13459,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kalna",
      id: 13471,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kalyani",
      id: 13478,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kamarhati",
      id: 13485,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kanaipur",
      id: 13496,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kanchrapara",
      id: 13503,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kandi",
      id: 13508,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kankuria",
      id: 13528,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kantlia",
      id: 13549,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kanyanagar",
      id: 13551,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Karimpur",
      id: 13580,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kasba",
      id: 13600,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kasim Bazar",
      id: 13604,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Katwa",
      id: 13627,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kaugachhi",
      id: 13628,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kenda",
      id: 13649,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kendra Khottamdi",
      id: 13650,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kendua",
      id: 13651,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kesabpur",
      id: 13656,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khagrabari",
      id: 13667,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khalia",
      id: 13674,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khalor",
      id: 13678,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khandra",
      id: 13691,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khantora",
      id: 13695,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kharagpur Rly. Settlement",
      id: 13699,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kharar",
      id: 13700,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khardaha",
      id: 13701,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kharimala Khagrabari",
      id: 13709,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kharsarai",
      id: 13715,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Khodarampur",
      id: 13742,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Koch Bihar",
      id: 13781,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kodalia",
      id: 13786,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kolaghat",
      id: 13798,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Konardihi",
      id: 13813,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Konnagar",
      id: 13821,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Krishnanagar",
      id: 13870,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Krishnapur",
      id: 13871,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kshidirpur",
      id: 13878,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kshirpai",
      id: 13879,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kulihanda",
      id: 13896,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kulti",
      id: 13898,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kunustara",
      id: 13920,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Kurseong",
      id: 13934,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Madanpur",
      id: 14009,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Madhusudanpur",
      id: 14017,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Madhyamgram",
      id: 14018,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Maheshtala",
      id: 14034,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mahiari",
      id: 14036,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mahira",
      id: 14038,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Makardaha",
      id: 14062,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mal",
      id: 14069,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mandarbani",
      id: 14098,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Manikpur",
      id: 14112,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mansinhapur",
      id: 14126,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Maslandapur",
      id: 14144,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mekliganj",
      id: 14173,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mirik",
      id: 14198,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Mrigala",
      id: 14238,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Muragachha",
      id: 14277,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Murgathaul",
      id: 14279,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nabagram",
      id: 14298,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nabagram Colony",
      id: 14299,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nabgram",
      id: 14300,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nachhratpur Katabari",
      id: 14303,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nasra",
      id: 14380,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Natibpur",
      id: 14383,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Naupala",
      id: 14389,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nebadhai Duttapukur",
      id: 14401,
      state_id: 10008,
    },
    {
      type: "city",
      label: "New Barrackpur",
      id: 14419,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nibra",
      id: 14426,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Nokpul",
      id: 14445,
      state_id: 10008,
    },
    {
      type: "city",
      label: "North Barrackpur",
      id: 14450,
      state_id: 10008,
    },
    {
      type: "city",
      label: "North Dumdum",
      id: 14451,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Old Maldah",
      id: 14476,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ondal",
      id: 14480,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Pairagachha",
      id: 14508,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Palashban",
      id: 14517,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Panchpara",
      id: 14550,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Pandua",
      id: 14555,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Pangachhiya (B)",
      id: 14556,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Paniara",
      id: 14558,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Panihati",
      id: 14559,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Panuhat",
      id: 14569,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Par Beliya",
      id: 14576,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Parashkol",
      id: 14579,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Parasia",
      id: 14580,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Parbbatipur",
      id: 14585,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Paschim  Jitpur",
      id: 14596,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Pattabong Tea Garden",
      id: 14613,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Patuli",
      id: 14620,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Patulia",
      id: 14621,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Phulia",
      id: 14661,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Podara",
      id: 14683,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Prayagpur",
      id: 14709,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Pujali",
      id: 14717,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Purba Tajpur",
      id: 14726,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Puruliya",
      id: 14729,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raghudebbati",
      id: 14754,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raghunathchak",
      id: 14755,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raghunathpur (PS-Dankuni)",
      id: 14757,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raghunathpur (PS-Magra)",
      id: 14758,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raigachhi",
      id: 14762,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Rajarhat Gopalpur",
      id: 14769,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Rajpur Sonarpur",
      id: 14780,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ramchandrapur",
      id: 14792,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ramjibanpur",
      id: 14798,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ramnagar",
      id: 14800,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Raniganj",
      id: 14816,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ratibati",
      id: 14828,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Rishra",
      id: 14848,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ruiya",
      id: 14860,
      state_id: 10008,
    },
    {
      type: "city",
      label: "S.T. Power Project Town",
      id: 14869,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sadpur",
      id: 14879,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sahajadpur",
      id: 14882,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sahapur",
      id: 14884,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Salap",
      id: 14900,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sankarpur",
      id: 14927,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sankrail",
      id: 14930,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Santoshpur",
      id: 14935,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sarenga",
      id: 14951,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sarpi",
      id: 14957,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Satigachha",
      id: 14972,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Serampore",
      id: 15000,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Serpur",
      id: 15002,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Shankhanagar",
      id: 15025,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Siduli",
      id: 15054,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Simla",
      id: 15064,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Singur",
      id: 15079,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sirsha",
      id: 15093,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sobhaganj",
      id: 15105,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sonatikiri",
      id: 15116,
      state_id: 10008,
    },
    {
      type: "city",
      label: "South Dumdum",
      id: 15121,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Srikantabati",
      id: 15124,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Srirampur",
      id: 15130,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Sukdal",
      id: 15140,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Taherpur",
      id: 15170,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Talbandha",
      id: 15175,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Tentulkuli",
      id: 15209,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Titagarh",
      id: 15299,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Tufanganj",
      id: 15313,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Ukhra",
      id: 15327,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uluberia",
      id: 15333,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Bagdogra",
      id: 15366,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Durgapur",
      id: 15367,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Goara",
      id: 15368,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Kalas",
      id: 15369,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Kamakhyaguri",
      id: 15370,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Latabari",
      id: 15372,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Mahammadpur",
      id: 15373,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Pirpur",
      id: 15374,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttar Raypur",
      id: 15375,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Uttarpara Kotrung",
      id: 15378,
      state_id: 10008,
    },
    {
      type: "city",
      label: "Amini",
      id: 15516,
      state_id: 15515,
    },
    {
      type: "city",
      label: "Kavaratti",
      id: 15530,
      state_id: 15515,
    },
    {
      type: "city",
      label: "Minicoy",
      id: 15534,
      state_id: 15515,
    },
    {
      type: "city",
      label: "Lakshadweep District",
      id: 15544,
      state_id: 15515,
    },
    {
      type: "city",
      label: "Daman",
      id: 15521,
      state_id: 15520,
    },
    {
      type: "city",
      label: "Diu",
      id: 15522,
      state_id: 15520,
    },
    {
      type: "city",
      label: "Gangtok",
      id: 15524,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Gyalshing",
      id: 15526,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Jorethang",
      id: 15527,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Mangan",
      id: 15533,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Namchi",
      id: 15535,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Nayabazar",
      id: 15536,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Rangpo",
      id: 15539,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Singtam",
      id: 15541,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Upper Tadong",
      id: 15542,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Pakyong",
      id: 15552,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Soreng",
      id: 15553,
      state_id: 15523,
    },
    {
      type: "city",
      label: "Kargil",
      id: 15546,
      state_id: 15545,
    },
    {
      type: "city",
      label: "Leh Ladakh",
      id: 15551,
      state_id: 15545,
    },
  ],

  // GENDER
  LOCATIONS: {
    an: {
      n: "Andaman and Nicobar Islands",
      id: "an",
    },
    ap: {
      n: "Andhra Pradesh",
      id: "ap",
    },
    ar: {
      n: "Arunachal Pradesh",
      id: "ar",
    },
    as: {
      n: "Assam",
      id: "as",
    },
    br: {
      n: "Bihar",
      id: "br",
    },
    ch: {
      n: "Chandigarh",
      id: "ch",
    },
    ct: {
      n: "Chhattisgarh",
      id: "ct",
    },
    dd: {
      n: "Daman And Diu",
      id: "dd",
    },
    dl: {
      n: "Delhi",
      id: "dl",
    },
    dn: {
      n: "Dadra and Nagar Haveli",
      id: "dn",
    },
    ga: {
      n: "Goa",
      id: "ga",
    },
    gj: {
      n: "Gujarat",
      id: "gj",
    },
    hp: {
      n: "Himachal Pradesh",
      id: "hp",
    },
    hr: {
      n: "Haryana",
      id: "hr",
    },
    in: {
      n: "PAN India",
      id: "in",
    },
    jh: {
      n: "Jharkhand",
      id: "jh",
    },
    jk: {
      n: "Jammu and Kashmir",
      id: "jk",
    },
    ka: {
      n: "Karnataka",
      id: "ka",
    },
    kl: {
      n: "Kerala",
      id: "kl",
    },
    la: {
      n: "Ladakh",
      id: "la",
    },
    ld: {
      n: "Lakshadweep",
      id: "ld",
    },
    mh: {
      n: "Maharashtra",
      id: "mh",
    },
    ml: {
      n: "Meghalaya",
      id: "ml",
    },
    mn: {
      n: "Manipur",
      id: "mn",
    },
    mp: {
      n: "Madhya Pradesh",
      id: "mp",
    },
    mz: {
      n: "Mizoram",
      id: "mz",
    },
    nl: {
      n: "Nagaland",
      id: "nl",
    },
    or: {
      n: "Odisha",
      id: "or",
    },
    pb: {
      n: "Punjab",
      id: "pb",
    },
    py: {
      n: "Puducherry",
      id: "py",
    },
    rj: {
      n: "Rajasthan",
      id: "rj",
    },
    sk: {
      n: "Sikkim",
      id: "sk",
    },
    tg: {
      n: "Telangana",
      id: "tg",
    },
    tn: {
      n: "Tamil Nadu",
      id: "tn",
    },
    tr: {
      n: "Tripura",
      id: "tr",
    },
    up: {
      n: "Uttar Pradesh",
      id: "up",
    },
    ut: {
      n: "Uttarakhand",
      id: "ut",
    },
    wb: {
      n: "West Bengal",
      id: "wb",
    },
  },

  // LANGUAGE
  LANGUAGE: {
    hindi: {
      n: "Hindi",
      id: "hindi",
    },
    english: {
      n: "English",
      id: "english",
    },
    marathi: {
      n: "Marathi",
      id: "marathi",
    },
    tamil: {
      n: "Tamil",
      id: "tamil",
    },
    telugu: {
      n: "Telugu",
      id: "telugu",
    },
    malayalam: {
      n: "Malayalam",
      id: "malayalam",
    },
    bengali: {
      n: "Bengali",
      id: "bengali",
    },
    gujarati: {
      n: "Gujarati",
      id: "gujarati",
    },
    kannada: {
      n: "Kannada",
      id: "kannada",
    },
    odia: {
      n: "Odia",
      id: "odia",
    },
    punjabi: {
      n: "Punjabi",
      id: "punjabi",
    },
    assamese: {
      n: "Assamese",
      id: "assamese",
    },
    kashmiri: {
      n: "Kashmiri",
      id: "kashmiri",
    },
    bhojpuri: {
      n: "Bhojpuri",
      id: "bhojpuri",
    },
  },

  CREATOR_LEVEL: {
    1000: {
      n: "Nano  1K - 10k",
      id: "1000",
    },
    10000: {
      n: "Micro 10k - 50k",
      id: "10000",
    },
    50000: {
      n: "Macro 50k - 1M",
      id: "50000",
    },
    1000000: {
      n: "Mega 1M",
      id: "1000000",
    },
  },

  // Followers
  FOLLOWERS: {
    10000: {
      n: "10 K",
      value: 10000,
    },
    20000: {
      n: "20 K",
      value: 20000,
    },
    30000: {
      n: "30 K",
      value: 30000,
    },
    40000: {
      n: "40 K",
      value: 40000,
    },
    50000: {
      n: "50 K",
      value: 50000,
    },
    70000: {
      n: "70 K",
      value: 70000,
    },
    90000: {
      n: "90 K",
      value: 90000,
    },
    100000: {
      n: "100 K",
      value: 100000,
    },
    250000: {
      n: "250 K",
      value: 250000,
    },
    500000: {
      n: "500 K+",
      value: 500000,
    },
  },

  // REWARD TYPE
  REWARD_TYPE: {
    cash: {
      n: "CASH",
    },
    discount: {
      n: "DISCOUNT",
    },
    cashback: {
      n: "CASHBACK",
    },
  },

  CATEGORY: {
    food_drink: {
      n: "Food & Drink",
      id: "food_drink",
    },
    fashion: {
      n: "Fashion",
      id: "fashion",
    },
    beauty: {
      n: "Beauty & Personal Care",
      id: "beauty",
    },
    web: {
      n: "Social Media, Web & Tech",
      id: "web",
    },
    art: {
      n: "Photography, Art & Design",
      id: "art",
    },
    event: {
      n: "Entertainment & Events",
      id: "event",
    },
    health: {
      n: "Health, Fitness & Sport",
      id: "health",
    },
    travel: {
      n: "Travel & Destinations",
      id: "travel",
    },
    hotel: {
      n: "Restaurants, Bars & Hotels",
      id: "hotel",
    },
    auto: {
      n: "Automotive",
      id: "auto",
    },
    family: {
      n: "Children & Family",
      id: "family",
    },
    home: {
      n: "Home & Garden",
      id: "home",
    },
    animal: {
      n: "Animals",
      id: "animal",
    },
    book: {
      n: "Education & Books",
      id: "book",
    },
    business: {
      n: "Business, Finance & Insurance",
      id: "business",
    },
    social: {
      n: "Social Enterprise & Not-for-profit",
      id: "social",
    },
  },
  FULL_CATEGORIES: {
    CATEGORYS: {
      "4v4m": {
        label: "Finance",
        value: "4v4m",
      },
      "5c20": {
        label: "Entertainment",
        value: "5c20",
      },
      "9w6m": {
        label: "Restaurants",
        value: "9w6m",
      },
      afie: {
        label: "Auto",
        value: "afie",
      },
      cjsh: {
        label: "Travel",
        value: "cjsh",
      },
      m0im: {
        label: "Beauty Influencer",
        value: "m0im",
      },
      m1im: {
        label: "Fashion and Lifestyle",
        value: "m1im",
      },
      nsld: {
        label: "Food & Drink",
        value: "nsld",
      },
      p914: {
        label: "Education",
        value: "p914",
      },
      txv6: {
        label: "Photography",
        value: "txv6",
      },
      w7s7: {
        label: "Technology",
        value: "w7s7",
      },
      yngw: {
        label: "Health & Fitness",
        value: "yngw",
      },
      agri: {
        label: "Agriculture",
        value: "agri",
      },
      sprt: {
        label: "Sports",
        value: "sprt",
      },
      decr: {
        label: "Home Decor",
        value: "decr",
      },
    },
    subcategories: {
      "4v4m": [
        {
          id: "4v4m11",
          name: "Finance",
        },
        {
          id: "4v4m12",
          name: "Real Estate",
        },
        {
          id: "4v4m13",
          name: "Stock Trading",
        },
        {
          id: "4v4m14",
          name: "Business",
        },
        {
          id: "4v4m26",
          name: "Insurance Education",
        },
      ],
      "5c20": [
        {
          id: "5c20_10",
          name: "TV Actor",
        },
        {
          id: "5c20_128",
          name: "Film critic",
        },
        {
          id: "5c20_136",
          name: "Movie Review",
        },
        {
          id: "5c20_16",
          name: "Artist",
        },
        {
          id: "5c20_17",
          name: "Digital content",
        },
        {
          id: "5c20_22",
          name: "Music",
        },
        {
          id: "5c20_38",
          name: "Dance and Music",
        },
        {
          id: "5c20_39",
          name: "Casting",
        },
        {
          id: "5c20_4",
          name: "Acting",
        },
        {
          id: "5c20_40",
          name: "DJ Music",
        },
        {
          id: "5c20_41",
          name: "Film Production",
        },
        {
          id: "5c20_42",
          name: "Radio",
        },
        {
          id: "5c20_44",
          name: "Choreographer",
        },
        {
          id: "5c20_6",
          name: "Comedian",
        },
        {
          id: "5c20_63",
          name: "Voice artist",
        },
        {
          id: "5c20_66",
          name: "Creative director",
        },
        {
          id: "5c20_7",
          name: "Singer",
        },
      ],
      afie: [
        {
          id: "afie1",
          name: "Automobile",
        },
        {
          id: "afie2",
          name: "Biking",
        },
      ],
      cjsh: [
        {
          id: "cjsh5",
          name: "International Travel",
        },
        {
          id: "cjsh7",
          name: "Budget Travel",
        },
        {
          id: "cjsh8",
          name: "Luxury Travel",
        },
        {
          id: "cjsh9",
          name: "Wildlife Travel",
        },
      ],
      m0im: [
        {
          id: "m0im10",
          name: "Hair Care",
        },
        {
          id: "m0im3",
          name: "Make-up",
        },
        {
          id: "m0im4",
          name: "Skin Care",
        },
        {
          id: "m0im5",
          name: "Nail Art",
        },
      ],
      m1im: [
        {
          id: "m1im10",
          name: "Parenting",
        },
        {
          id: "m1im11",
          name: "Fashion Influencer",
        },
        {
          id: "m1im12",
          name: "Fashion stylist",
        },
        {
          id: "m1im13",
          name: "Jewellery",
        },
        {
          id: "m1im14",
          name: "Modeling",
        },
        {
          id: "m1im15",
          name: "Activist",
        },
        {
          id: "m1im19",
          name: "DIY Content",
        },
        {
          id: "m1im2",
          name: "Vlog",
        },
        {
          id: "m1im3",
          name: "Podcast",
        },
        {
          id: "m1im30",
          name: "Kids and toys",
        },
        {
          id: "m1im4",
          name: "Reaction Video",
        },
        {
          id: "m1im5",
          name: "Lifestyle",
        },
        {
          id: "m1im8",
          name: "Fashion",
        },
        {
          id: "m1im9",
          name: "Fashion design",
        },
      ],
      nsld: [
        {
          id: "nsld11",
          name: "Chef",
        },
        {
          id: "nsld20",
          name: "Food blogging",
        },
      ],
      p914: [
        {
          id: "p91410",
          name: "Career coaching",
        },
        {
          id: "p9145",
          name: "Education",
        },
        {
          id: "p9146",
          name: "Science",
        },
        {
          id: "p9147",
          name: "Teacher",
        },
        {
          id: "p9148",
          name: "Religious",
        },
        {
          id: "p9149",
          name: "Astrology",
        },
      ],
      txv6: [
        {
          id: "txv6_3",
          name: "Photography",
        },
        {
          id: "txv6_4",
          name: "Wedding Photography",
        },
      ],
      w7s7: [
        {
          id: "w7s7_0",
          name: "Gaming",
        },
        {
          id: "w7s7_10",
          name: "Gadget Review",
        },
        {
          id: "w7s7_11",
          name: "Ads and Marketing",
        },
        {
          id: "w7s7_16",
          name: "Video game streaming",
        },
        {
          id: "w7s7_28",
          name: "Coding",
        },
        {
          id: "w7s7_7",
          name: "Crypto",
        },
        {
          id: "w7s7_8",
          name: "Technology",
        },
      ],
      yngw: [
        {
          id: "yngw_1",
          name: "Fitness training",
        },
        {
          id: "yngw_10",
          name: "Doctor",
        },
        {
          id: "yngw_12",
          name: "Health",
        },
        {
          id: "yngw_13",
          name: "Gym and Fitness",
        },
        {
          id: "yngw_19",
          name: "Gym Training",
        },
        {
          id: "yngw_2",
          name: "Nutrition",
        },
        {
          id: "yngw_21",
          name: "Personal coaching",
        },
        {
          id: "yngw_25",
          name: "Fertility Expert",
        },
        {
          id: "yngw_3",
          name: "Yoga",
        },
        {
          id: "yngw_4",
          name: "Ayurveda",
        },
        {
          id: "yngw_40",
          name: "Relationship & Sex therapy",
        },
        {
          id: "yngw_61",
          name: "Psychotherapy",
        },
        {
          id: "yngw_9",
          name: "Fitness modeling",
        },
      ],
      agri: [
        {
          id: "agri1",
          name: "Farming and plants",
        },
        {
          id: "agri14",
          name: "Environmental Influencer",
        },
      ],
      decr: [
        {
          id: "decr1",
          name: "Home Decor",
        },
        {
          id: "decr18",
          name: "Construction",
        },
        {
          id: "decr5",
          name: "Architecture",
        },
        {
          id: "decr7",
          name: "Interior design",
        },
      ],
      sprt: [
        {
          id: "sprt3",
          name: "Sports Coach",
        },
        {
          id: "sprt5",
          name: "Footballer",
        },
        {
          id: "sprt6",
          name: "Athlete",
        },
        {
          id: "sprt7",
          name: "Sports",
        },
      ],
      pges: [
        { id: "pges11", name: "Memes" },
        { id: "pges13", name: "Writing" },
        { id: "pges14", name: "Community Page" },
        { id: "pges149", name: "Pet Content" },
        { id: "pges15", name: "Business Page" },
        { id: "pges16", name: "Fan Page" },
        { id: "pges21", name: "Journalism" },
        { id: "pges23", name: "News Page" },
        { id: "pges26", name: "Motivation" },
        { id: "pges42", name: "Poet" },
        { id: "pges54", name: "Lawyer" },
        { id: "pges56", name: "Politics" },
      ],
    },
  },
};
